(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@redux-saga/core/effects"), require("@reduxjs/toolkit"), require("@innovyze/lib-am-common/Reducers"), require("@innovyze/stylovyze"), require("react-redux"), require("@innovyze/lib_get_service"), require("i18next"), require("@innovyze/lib-am-common/Actions"), require("@innovyze/lib_asset_schema_store"), require("@innovyze/lib_asset_schema"));
	else if(typeof define === 'function' && define.amd)
		define(["@redux-saga/core/effects", "@Reduxjs/Toolkit", "@innovyze/lib-am-common/Reducers", "@Innovyze/Stylovyze", "ReactRedux", "@innovyze/lib_get_service", "I18next", "@innovyze/lib-am-common/Actions", "@innovyze/lib_asset_schema_store", "@innovyze/lib_asset_schema"], factory);
	else if(typeof exports === 'object')
		exports["app-MODULE-NAME"] = factory(require("@redux-saga/core/effects"), require("@reduxjs/toolkit"), require("@innovyze/lib-am-common/Reducers"), require("@innovyze/stylovyze"), require("react-redux"), require("@innovyze/lib_get_service"), require("i18next"), require("@innovyze/lib-am-common/Actions"), require("@innovyze/lib_asset_schema_store"), require("@innovyze/lib_asset_schema"));
	else
		root["app-MODULE-NAME"] = factory(root["@redux-saga/core/effects"], root["@Reduxjs/Toolkit"], root["@innovyze/lib-am-common/Reducers"], root["@Innovyze/Stylovyze"], root["ReactRedux"], root["@innovyze/lib_get_service"], root["I18next"], root["@innovyze/lib-am-common/Actions"], root["@innovyze/lib_asset_schema_store"], root["@innovyze/lib_asset_schema"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__redux_saga_core_effects__, __WEBPACK_EXTERNAL_MODULE__reduxjs_toolkit__, __WEBPACK_EXTERNAL_MODULE__innovyze_lib_am_common_Reducers__, __WEBPACK_EXTERNAL_MODULE__innovyze_stylovyze__, __WEBPACK_EXTERNAL_MODULE_react_redux__, __WEBPACK_EXTERNAL_MODULE__innovyze_lib_get_service__, __WEBPACK_EXTERNAL_MODULE_i18next__, __WEBPACK_EXTERNAL_MODULE__innovyze_lib_am_common_Actions__, __WEBPACK_EXTERNAL_MODULE__innovyze_lib_asset_schema_store__, __WEBPACK_EXTERNAL_MODULE__innovyze_lib_asset_schema__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "../node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js":
/*!***************************************************************************!*\
  !*** ../node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _redux_saga_core_effects__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @redux-saga/core/effects */ "@redux-saga/core/effects");
/* harmony import */ var _redux_saga_core_effects__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_redux_saga_core_effects__WEBPACK_IMPORTED_MODULE_0__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _redux_saga_core_effects__WEBPACK_IMPORTED_MODULE_0__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _redux_saga_core_effects__WEBPACK_IMPORTED_MODULE_0__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);



/***/ }),

/***/ "./actions/CoF.actions.ts":
/*!********************************!*\
  !*** ./actions/CoF.actions.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setCoFIsChanged = exports.deleteCoFCategory = exports.saveCoFRejected = exports.saveCoFResolved = exports.saveCoF = exports.setCoFComponents = exports.setCoFComponent = exports.addCoFComponent = exports.getCustomTableFieldsRejected = exports.getCustomTableFieldsResolved = exports.getCustomTableFields = exports.getProximityAttributeFieldsRejected = exports.getProximityAttributeFieldsResolved = exports.getProximityAttributeFields = exports.getCoFFieldsRejected = exports.getCoFFieldsResolved = exports.getCoFFields = exports.setCoFConfig = exports.addCoFConfig = exports.getCoFComponentsRejected = exports.getCoFComponentsResolved = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getCoFComponentsResolved = (0, toolkit_1.createAction)('CoF/getCoFComponentsResolved');
exports.getCoFComponentsRejected = (0, toolkit_1.createAction)('CoF/getCoFComponentsRejected');
exports.addCoFConfig = (0, toolkit_1.createAction)('CoF/addCoFConfig');
exports.setCoFConfig = (0, toolkit_1.createAction)('CoF/setCoFConfig');
exports.getCoFFields = (0, toolkit_1.createAction)('CoF/getCoFFields');
exports.getCoFFieldsResolved = (0, toolkit_1.createAction)('CoF/getCoFFieldsResolved');
exports.getCoFFieldsRejected = (0, toolkit_1.createAction)('CoF/getCoFFieldsRejected');
exports.getProximityAttributeFields = (0, toolkit_1.createAction)('ProximityAttribute/getProximityAttributeFields');
exports.getProximityAttributeFieldsResolved = (0, toolkit_1.createAction)('ProximityAttribute/getProximityAttributeFieldsResolved');
exports.getProximityAttributeFieldsRejected = (0, toolkit_1.createAction)('ProximityAttribute/getProximityAttributeFieldsRejected');
exports.getCustomTableFields = (0, toolkit_1.createAction)('CustomTable/getCustomTableFields');
exports.getCustomTableFieldsResolved = (0, toolkit_1.createAction)('CustomTable/getCustomTableFieldsResolved');
exports.getCustomTableFieldsRejected = (0, toolkit_1.createAction)('CustomTable/getCustomTableFieldsRejected');
exports.addCoFComponent = (0, toolkit_1.createAction)('CoF/addCoFComponent');
exports.setCoFComponent = (0, toolkit_1.createAction)('CoF/setCoFComponent');
exports.setCoFComponents = (0, toolkit_1.createAction)('CoF/setCoFComponents');
exports.saveCoF = (0, toolkit_1.createAction)('CoF/saveCoF');
exports.saveCoFResolved = (0, toolkit_1.createAction)('CoF/saveCoFResolved');
exports.saveCoFRejected = (0, toolkit_1.createAction)('CoF/saveCoFRejected');
exports.deleteCoFCategory = (0, toolkit_1.createAction)('CoF/deleteCoFCategory');
exports.setCoFIsChanged = (0, toolkit_1.createAction)('CoF/setCoFIsChanged');


/***/ }),

/***/ "./actions/LoF.actions.ts":
/*!********************************!*\
  !*** ./actions/LoF.actions.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setLofIsChanged = exports.deleteCategory = exports.saveLoFRejected = exports.saveLoFResolved = exports.saveLoF = exports.setLoFComponents = exports.setLoFComponent = exports.addLoFComponent = exports.getLoFFieldsRejected = exports.getLoFFieldsResolved = exports.getLoFFields = exports.getLoFInspectionFieldsRejected = exports.getLoFInspectionFieldsResolved = exports.getLoFInspectionFields = exports.setLoFConfig = exports.addLoFConfig = exports.getLoFConfigRejected = exports.getLoFConfigResolved = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getLoFConfigResolved = (0, toolkit_1.createAction)('LoF/getLoFConfigResolved');
exports.getLoFConfigRejected = (0, toolkit_1.createAction)('LoF/getLoFConfigRejected');
exports.addLoFConfig = (0, toolkit_1.createAction)('LoF/addLoFConfig');
exports.setLoFConfig = (0, toolkit_1.createAction)('LoF/setLoFConfig');
exports.getLoFInspectionFields = (0, toolkit_1.createAction)('LoF/getLoFInspectionFields');
exports.getLoFInspectionFieldsResolved = (0, toolkit_1.createAction)('LoF/getLoFInspectionFieldsResolved');
exports.getLoFInspectionFieldsRejected = (0, toolkit_1.createAction)('LoF/getLoFInspectionFieldsRejected');
exports.getLoFFields = (0, toolkit_1.createAction)('LoF/getLoFFields');
exports.getLoFFieldsResolved = (0, toolkit_1.createAction)('LoF/getLoFFieldsResolved');
exports.getLoFFieldsRejected = (0, toolkit_1.createAction)('LoF/getLoFFieldsRejected');
exports.addLoFComponent = (0, toolkit_1.createAction)('LoF/addLoFComponent');
exports.setLoFComponent = (0, toolkit_1.createAction)('LoF/setLoFComponent');
exports.setLoFComponents = (0, toolkit_1.createAction)('LoF/setLoFComponents');
exports.saveLoF = (0, toolkit_1.createAction)('LoF/saveLoF');
exports.saveLoFResolved = (0, toolkit_1.createAction)('LoF/saveLoFResolved');
exports.saveLoFRejected = (0, toolkit_1.createAction)('LoF/saveLoFRejected');
exports.deleteCategory = (0, toolkit_1.createAction)('LoF/deleteCategory');
exports.setLofIsChanged = (0, toolkit_1.createAction)('Lof/setLofIsChanged');


/***/ }),

/***/ "./actions/Risk.actions.ts":
/*!*********************************!*\
  !*** ./actions/Risk.actions.ts ***!
  \*********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.changeFilterSelect = exports.getTaskDataResolved = exports.getTaskData = exports.getSimulationDataResolved = exports.getSimulationData = exports.getLogRejected = exports.getLogResolved = exports.getLog = exports.setRiskCalcStatus = exports.setSaveRun = exports.setTab = exports.setRiskDetailsIsBusy = exports.currentRow = exports.clearSelected = exports.removeSelected = exports.addSelected = exports.setSelected = exports.changeSort = exports.clearScanId = exports.setSearchStartSaga = exports.setSearchStart = exports.changeSearch = exports.changePage = exports.changeSlice = exports.clearRiskScanId = exports.changePagination = exports.getRiskDetailsRejected = exports.getRiskDetailsResolved = exports.getRiskDetailsWSReseived = exports.reloadRiskDetails = exports.getRiskDetailsDefaulted = exports.resetRiskResolved = exports.resetRiskRejected = exports.resetRisk = exports.runRiskResolved = exports.runRiskRejected = exports.runRisk = exports.getRiskDetails = exports.saveRiskConfigAction = exports.renameRiskConfigAction = exports.setRiskConfigNameError = exports.setRiskConfigIsCreating = exports.duplicateRiskConfig = exports.changeRiskConfigPublishState = exports.createRiskConfig = exports.clearRiskConfig = exports.getRiskConfigRejected = exports.getRiskConfigResolved = exports.getRiskConfig = exports.paginationDefault = void 0;
exports.setOverallRisk = exports.clearMatrixUpdate = exports.setOnlyGradesUpdated = exports.setEditedCellsList = exports.setRefreshMatrixGrid = exports.setRiskMatrixAfterPreview = exports.setMatrixPreviewStatus = exports.setIsPreviewOnLoad = exports.setIsPreviewLoading = exports.setCancellPreview = exports.setEnablePreview = exports.getRiskMatrixPreview = exports.cancelRiskMatrixPreview = exports.initRiskMatrixPreview = exports.setRiskType = exports.setUpdatedScores = exports.setDidMatrixUpdate = exports.setUpdatedRanges = exports.renameRiskCount = exports.getRiskCountResolved = exports.getRiskCountScoreMatrix = exports.getRiskCountTask = exports.getRiskCountCustomTable = exports.getRiskCountProximityAttribute = exports.getRiskCountProximity = exports.getRiskCountObservation = exports.getRiskCountAttribute = exports.getRiskCountInspection = exports.setRiskCountIsLoading = exports.setRiskIsDeleting = exports.deleteRisk = exports.setRiskIsSaving = exports.setRefreshList = exports.setRunCompleteReload = exports.setRiskSetupDirty = exports.translate = exports.updateColumnFilterSelectOptions = exports.changeFiltersSelect = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
// eslint-disable-next-line import/no-unresolved, import/no-extraneous-dependencies
var Reducers_1 = __webpack_require__(/*! @innovyze/lib-am-common/Reducers */ "@innovyze/lib-am-common/Reducers");
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var paginationDefault = function () { return (__assign(__assign({}, Reducers_1.paginationInitialState), { sortKey: 'CURRENT_RISK', sortDescending: true })); };
exports.paginationDefault = paginationDefault;
exports.getRiskConfig = (0, toolkit_1.createAction)('Risk/getRiskConfig');
exports.getRiskConfigResolved = (0, toolkit_1.createAction)('Risk/getRiskConfigResolved');
exports.getRiskConfigRejected = (0, toolkit_1.createAction)('Risk/getRiskConfigRejected');
exports.clearRiskConfig = (0, toolkit_1.createAction)('Risk/clearRiskConfig');
exports.createRiskConfig = (0, toolkit_1.createAction)('Risk/createRiskConfig');
exports.changeRiskConfigPublishState = (0, toolkit_1.createAction)('Risk/changeRiskConfigPublishState');
exports.duplicateRiskConfig = (0, toolkit_1.createAction)('Risk/duplicateRiskConfig');
exports.setRiskConfigIsCreating = (0, toolkit_1.createAction)('riskSetup/setRiskConfigIsCreating');
exports.setRiskConfigNameError = (0, toolkit_1.createAction)('riskSetup/setRiskConfigNameError');
exports.renameRiskConfigAction = (0, toolkit_1.createAction)('Risk/renameRiskConfig');
exports.saveRiskConfigAction = (0, toolkit_1.createAction)('Risk/saveRiskConfig');
exports.getRiskDetails = (0, toolkit_1.createAction)('risk/getRiskDetails');
exports.runRisk = (0, toolkit_1.createAction)('risk/runRisk');
exports.runRiskRejected = (0, toolkit_1.createAction)('risk/runRiskRejected');
exports.runRiskResolved = (0, toolkit_1.createAction)('risk/runRiskResolved');
exports.resetRisk = (0, toolkit_1.createAction)('risk/resetRisk');
exports.resetRiskRejected = (0, toolkit_1.createAction)('risk/resetRiskRejected');
exports.resetRiskResolved = (0, toolkit_1.createAction)('risk/resetRiskResolved');
var getRiskDetailsDefaulted = function () {
    return (0, exports.getRiskDetails)((0, exports.paginationDefault)());
};
exports.getRiskDetailsDefaulted = getRiskDetailsDefaulted;
exports.reloadRiskDetails = (0, toolkit_1.createAction)('risk/reloadRiskDetails');
exports.getRiskDetailsWSReseived = (0, toolkit_1.createAction)('riskdetails/getRiskDetails/WSReseived');
exports.getRiskDetailsResolved = (0, toolkit_1.createAction)('riskdetails/getRiskDetails/resolved');
exports.getRiskDetailsRejected = (0, toolkit_1.createAction)('riskdetails/getRiskDetails/rejected');
exports.changePagination = (0, toolkit_1.createAction)('riskdetails/paginationModel');
exports.clearRiskScanId = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskdetails/clearRiskScanId'));
exports.changeSlice = (0, toolkit_1.createAction)('riskdetails/slice');
exports.changePage = (0, toolkit_1.createAction)('riskdetails/page');
exports.changeSearch = (0, toolkit_1.createAction)('riskdetails/changeSearch');
exports.setSearchStart = (0, toolkit_1.createAction)('riskdetails/setSearchStart');
exports.setSearchStartSaga = (0, toolkit_1.createAction)('riskdetails/setSearchStartSaga');
exports.clearScanId = (0, toolkit_1.createAction)('riskdetails/clearScanId');
exports.changeSort = (0, toolkit_1.createAction)('riskdetails/sort');
exports.setSelected = (0, toolkit_1.createAction)('riskdetails/selected/set');
exports.addSelected = (0, toolkit_1.createAction)('riskdetails/selected/add');
exports.removeSelected = (0, toolkit_1.createAction)('riskdetails/selected/remove');
exports.clearSelected = (0, toolkit_1.createAction)('riskdetails/selected/clear');
exports.currentRow = (0, toolkit_1.createAction)('riskdetails/current/row');
exports.setRiskDetailsIsBusy = (0, toolkit_1.createAction)('riskdetails/isBusy');
exports.setTab = (0, toolkit_1.createAction)('Risk/setTab');
exports.setSaveRun = (0, toolkit_1.createAction)('Risk/setSaveRun');
exports.setRiskCalcStatus = (0, toolkit_1.createAction)('Risk/setRiskCalcStatus');
exports.getLog = (0, toolkit_1.createAction)('Log/getLog');
exports.getLogResolved = (0, toolkit_1.createAction)('Log/getLogResolved');
exports.getLogRejected = (0, toolkit_1.createAction)('Log/getLogRejected');
exports.getSimulationData = (0, toolkit_1.createAction)('Risk/getSimulationData');
exports.getSimulationDataResolved = (0, toolkit_1.createAction)('Risk/getSimulationDataResolved');
exports.getTaskData = (0, toolkit_1.createAction)('Risk/getTaskData');
exports.getTaskDataResolved = (0, toolkit_1.createAction)('Risk/getTaskDataResolved');
exports.changeFilterSelect = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskDetails/filterSelect'));
exports.changeFiltersSelect = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskDetails/filtersSelect'));
exports.updateColumnFilterSelectOptions = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskDetails/filterSelect/column/options'));
exports.translate = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskDetails/translate'));
exports.setRiskSetupDirty = (0, toolkit_1.createAction)('riskSetup/setRiskSetupDirty');
exports.setRunCompleteReload = (0, toolkit_1.createAction)('Risk/riskCompleteReload');
exports.setRefreshList = (0, toolkit_1.createAction)('Risk/setRefreshList');
exports.setRiskIsSaving = (0, toolkit_1.createAction)('riskSetup/setRiskIsSaving');
exports.deleteRisk = (0, toolkit_1.createAction)('rehab/deleteRisk');
exports.setRiskIsDeleting = (0, toolkit_1.createAction)('risk/setRiskIsDeleting');
exports.setRiskCountIsLoading = (0, toolkit_1.createAction)('Risk/setRiskCountIsLoading');
exports.getRiskCountInspection = (0, toolkit_1.createAction)('Risk/getRiskCountInspection');
exports.getRiskCountAttribute = (0, toolkit_1.createAction)('Risk/getRiskCountAttribute');
exports.getRiskCountObservation = (0, toolkit_1.createAction)('Risk/getRiskCountObservation');
exports.getRiskCountProximity = (0, toolkit_1.createAction)('Risk/getRiskCountProximity');
exports.getRiskCountProximityAttribute = (0, toolkit_1.createAction)('Risk/getRiskCountProximityAttribute');
exports.getRiskCountCustomTable = (0, toolkit_1.createAction)('Risk/getRiskCountCustomTable');
exports.getRiskCountTask = (0, toolkit_1.createAction)('Risk/getRiskCountTask');
exports.getRiskCountScoreMatrix = (0, toolkit_1.createAction)('Risk/getRiskCountScoreMatrix');
exports.getRiskCountResolved = (0, toolkit_1.createAction)('Risk/getRiskCountResolved');
exports.renameRiskCount = (0, toolkit_1.createAction)('Risk/renameRiskCount');
//=== risk Matrix actions =====
exports.setUpdatedRanges = (0, toolkit_1.createAction)('Risk/setUpdatedRanges');
exports.setDidMatrixUpdate = (0, toolkit_1.createAction)('Risk/setDidMatrixUpdate');
exports.setUpdatedScores = (0, toolkit_1.createAction)('Risk/setUpdatedScores');
exports.setRiskType = (0, toolkit_1.createAction)('Risk/setRiskType'); //switch between linear and matrix
exports.initRiskMatrixPreview = (0, toolkit_1.createAction)('Risk/initRiskMatrixPreview');
exports.cancelRiskMatrixPreview = (0, toolkit_1.createAction)('Risk/cancelRiskMatrixPreview');
exports.getRiskMatrixPreview = (0, toolkit_1.createAction)('Risk/getRiskMatrixPreview');
exports.setEnablePreview = (0, toolkit_1.createAction)('Risk/setEnablePreview');
exports.setCancellPreview = (0, toolkit_1.createAction)('Risk/setCancellPreview');
exports.setIsPreviewLoading = (0, toolkit_1.createAction)('Risk/setIsPreviewLoading');
exports.setIsPreviewOnLoad = (0, toolkit_1.createAction)('Risk/setIsPreviewOnLoad');
exports.setMatrixPreviewStatus = (0, toolkit_1.createAction)('Risk/setmatrixPreviewStatus');
exports.setRiskMatrixAfterPreview = (0, toolkit_1.createAction)('Risk/setRiskMatrixAfterPreview');
exports.setRefreshMatrixGrid = (0, toolkit_1.createAction)('Risk/setRefreshMatrixGrid');
exports.setEditedCellsList = (0, toolkit_1.createAction)('Risk/updateEditedCellsList');
exports.setOnlyGradesUpdated = (0, toolkit_1.createAction)('Risk/setOnlyGradesUpdated');
exports.clearMatrixUpdate = (0, toolkit_1.createAction)('Risk/clearMatrixUpdate');
exports.setOverallRisk = (0, toolkit_1.createAction)('Risk/setOverallRisk');
//===================


/***/ }),

/***/ "./actions/asset.actions.ts":
/*!**********************************!*\
  !*** ./actions/asset.actions.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getSpatialLayerListRejected = exports.getSpatialLayerListResolved = exports.getSpatialLayerList = exports.getAssetFilterListResolved = exports.getAssetFilterListRejected = exports.getAssetFilterList = exports.clearAssetFields = exports.getAssetFieldsRejected = exports.getAssetFieldsResolved = exports.getAssetFields = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getAssetFields = (0, toolkit_1.createAction)('asset/getAssetFields');
exports.getAssetFieldsResolved = (0, toolkit_1.createAction)('asset/getAssetFieldsResolved');
exports.getAssetFieldsRejected = (0, toolkit_1.createAction)('asset/getAssetFieldsRejected');
exports.clearAssetFields = (0, toolkit_1.createAction)('asset/clearAssetFields');
exports.getAssetFilterList = (0, toolkit_1.createAction)('asset/getAssetFilterList');
exports.getAssetFilterListRejected = (0, toolkit_1.createAction)('asset/getAssetFilterListRejected');
exports.getAssetFilterListResolved = (0, toolkit_1.createAction)('asset/getAssetFilterListResolved');
exports.getSpatialLayerList = (0, toolkit_1.createAction)('Asset/getSpatialLayerList');
exports.getSpatialLayerListResolved = (0, toolkit_1.createAction)('Asset/getSpatialLayerListResolved');
exports.getSpatialLayerListRejected = (0, toolkit_1.createAction)('Asset/getSpatialLayerListRejected');


/***/ }),

/***/ "./actions/component.actions.ts":
/*!**************************************!*\
  !*** ./actions/component.actions.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getComponentMetadataRejected = exports.getComponentMetadataResolved = exports.getCoFComponentTaskMetadata = exports.getLoFComponentTaskMetadata = exports.getCoFComponentCustomTableMetadata = exports.getLoFComponentCustomTableMetadata = exports.getCoFComponentProximityAttrMetadata = exports.getLoFComponentProximityAttrMetadata = exports.getCoFComponentProximityMetadata = exports.getLoFComponentProximityMetadata = exports.getCoFComponentAssetMetadata = exports.getLoFComponentInspectionMetadata = exports.getLoFComponentAssetMetadata = exports.clearComponentMetadata = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.clearComponentMetadata = (0, toolkit_1.createAction)('Comp/clearComponentMetadata');
exports.getLoFComponentAssetMetadata = (0, toolkit_1.createAction)('Comp/getLoFComponentAssetMetadata');
exports.getLoFComponentInspectionMetadata = (0, toolkit_1.createAction)('Comp/getLoFComponentInpsectionMetadata');
exports.getCoFComponentAssetMetadata = (0, toolkit_1.createAction)('Comp/getCoFComponentAssetMetadata');
exports.getLoFComponentProximityMetadata = (0, toolkit_1.createAction)('Comp/getLoFComponentProximityMetadata');
exports.getCoFComponentProximityMetadata = (0, toolkit_1.createAction)('Comp/getCoFComponentProximityMetadata');
exports.getLoFComponentProximityAttrMetadata = (0, toolkit_1.createAction)('Comp/getLoFComponentProximityAttrMetadata');
exports.getCoFComponentProximityAttrMetadata = (0, toolkit_1.createAction)('Comp/getCoFComponentProximityAttrMetadata');
exports.getLoFComponentCustomTableMetadata = (0, toolkit_1.createAction)('Comp/getLoFComponentCustomTableMetadata');
exports.getCoFComponentCustomTableMetadata = (0, toolkit_1.createAction)('Comp/getCoFComponentCustomTableMetadata');
exports.getLoFComponentTaskMetadata = (0, toolkit_1.createAction)('Comp/getLoFComponentTaskMetadata');
exports.getCoFComponentTaskMetadata = (0, toolkit_1.createAction)('Comp/getCoFComponentTaskMetadata');
exports.getComponentMetadataResolved = (0, toolkit_1.createAction)('Comp/getComponentMetadataResolved');
exports.getComponentMetadataRejected = (0, toolkit_1.createAction)('Comp/getComponentMetadataRejected');


/***/ }),

/***/ "./actions/index.ts":
/*!**************************!*\
  !*** ./actions/index.ts ***!
  \**************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./LoF.actions */ "./actions/LoF.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./CoF.actions */ "./actions/CoF.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./Risk.actions */ "./actions/Risk.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./asset.actions */ "./actions/asset.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./component.actions */ "./actions/component.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./util.actions */ "./actions/util.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./map.actions */ "./actions/map.actions.ts"), exports);


/***/ }),

/***/ "./actions/map.actions.ts":
/*!********************************!*\
  !*** ./actions/map.actions.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.changeSpatialProximity = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.changeSpatialProximity = (0, toolkit_1.createAction)('spatialProximity/changeDataSource');


/***/ }),

/***/ "./actions/util.actions.ts":
/*!*********************************!*\
  !*** ./actions/util.actions.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setDataGridState = exports.setRiskLastRun = exports.setRiskRunning = exports.setRiskStatus = exports.setRiskNullScore = exports.updateRiskValuesDataGrid = exports.updateRiskScoreDataGrid = exports.updateRiskMultiScoreDataGridRow = exports.setRiskMultiScoreDataGrid = exports.setRiskScoreDataGrid = exports.setRiskScoreTable = exports.setRiskUnitScores = exports.setRiskEditScores = exports.setRiskScores = void 0;
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.setRiskScores = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskScores'));
exports.setRiskEditScores = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskEditScores'));
exports.setRiskUnitScores = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskUnitScores'));
exports.setRiskScoreTable = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskScoreTable'));
exports.setRiskScoreDataGrid = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskScoreDataGrid'));
exports.setRiskMultiScoreDataGrid = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskMultiScoreDataGrid'));
exports.updateRiskMultiScoreDataGridRow = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/updateRiskMultiScoreDataGridRow'));
exports.updateRiskScoreDataGrid = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/updateRiskScoreDataGrid'));
exports.updateRiskValuesDataGrid = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/updateRiskValuesDataGrid'));
exports.setRiskNullScore = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskNullScore'));
exports.setRiskStatus = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskStatus'));
exports.setRiskRunning = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskRunning'));
exports.setRiskLastRun = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskLastRun'));
exports.setDataGridState = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('dataGrid/state'));


/***/ }),

/***/ "./apis/assets.api.ts":
/*!****************************!*\
  !*** ./apis/assets.api.ts ***!
  \****************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var lib_get_service_1 = __webpack_require__(/*! @innovyze/lib_get_service */ "@innovyze/lib_get_service");
var config_api_1 = __importDefault(__webpack_require__(/*! ./config.api */ "./apis/config.api.ts"));
var assetsService = (0, lib_get_service_1.axiosWithHeaders)({
    config: config_api_1.default,
    service: 'assets',
    axiosCreateOpts: {
        timeout: 15000,
    },
});
exports["default"] = assetsService;


/***/ }),

/***/ "./apis/config.api.ts":
/*!****************************!*\
  !*** ./apis/config.api.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.apiEnv = void 0;
var lib_get_service_1 = __webpack_require__(/*! @innovyze/lib_get_service */ "@innovyze/lib_get_service");
var config = (_a = {},
    // Sample config for overwritting service endpoints
    _a[lib_get_service_1.Environments.LOCAL] = {
        amRisk: 'https://saas-risk-management.info360-dev.com/dev',
        looker: 'http://localhost:3276/dev/looker',
        amUpload: 'https://saas-upload-service.info360-dev.com/dev',
        tiles: 'https://tiles-dev.info360-dev.com/dev',
        export: 'https://saas-export-service.info360-dev.com/dev',
    },
    _a);
exports.apiEnv = localStorage.getItem('apiEnv') || undefined;
exports["default"] = config;


/***/ }),

/***/ "./apis/risks.api.ts":
/*!***************************!*\
  !*** ./apis/risks.api.ts ***!
  \***************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.riskBaseUrl = void 0;
var config_api_1 = __importStar(__webpack_require__(/*! ./config.api */ "./apis/config.api.ts"));
var urlFormatting_1 = __webpack_require__(/*! @Utils/urlFormatting */ "./utils/urlFormatting.ts");
var lib_get_service_1 = __webpack_require__(/*! @innovyze/lib_get_service */ "@innovyze/lib_get_service");
var riskService = (0, lib_get_service_1.axiosWithHeaders)({
    config: config_api_1.default,
    service: 'amRisk',
    axiosCreateOpts: {
        timeout: 15000,
    },
});
exports.riskBaseUrl = (0, urlFormatting_1.formatUrlTrailing)((0, lib_get_service_1.getService)('amRisk', config_api_1.default, config_api_1.apiEnv));
exports["default"] = riskService;


/***/ }),

/***/ "./reducers/RiskMatrixDefaultScores.ts":
/*!*********************************************!*\
  !*** ./reducers/RiskMatrixDefaultScores.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.defaultRiskMatrix = void 0;
exports.defaultRiskMatrix = {
    grades: {
        lofRanges: [2.0, 4.0, 6.0, 8.0, 10.0],
        cofRanges: [2.0, 4.0, 6.0, 8.0, 10.0],
    },
    grid: [
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'negligible',
            position: { x: 0, y: 0 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'negligible',
            position: { x: 0, y: 1 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'low',
            position: { x: 0, y: 2 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'medium',
            position: { x: 0, y: 3 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'medium',
            position: { x: 0, y: 4 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'negligible',
            position: { x: 1, y: 0 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'low',
            position: { x: 1, y: 1 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'medium',
            position: { x: 1, y: 2 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'medium',
            position: { x: 1, y: 3 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'medium',
            position: { x: 1, y: 4 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'low',
            position: { x: 2, y: 0 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'medium',
            position: { x: 2, y: 1 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'medium',
            position: { x: 2, y: 2 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'medium',
            position: { x: 2, y: 3 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'high',
            position: { x: 2, y: 4 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'medium',
            position: { x: 3, y: 0 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'medium',
            position: { x: 3, y: 1 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'medium',
            position: { x: 3, y: 2 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'high',
            position: { x: 3, y: 3 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'extreme',
            position: { x: 3, y: 4 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'medium',
            position: { x: 4, y: 0 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'medium',
            position: { x: 4, y: 1 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'high',
            position: { x: 4, y: 2 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'extreme',
            position: { x: 4, y: 3 },
        },
        {
            pipeCount: 0,
            pipeLength: 0,
            grade: 'extreme',
            position: { x: 4, y: 4 },
        },
    ],
};


/***/ }),

/***/ "./reducers/riskDetailsPagination.ts":
/*!*******************************************!*\
  !*** ./reducers/riskDetailsPagination.ts ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.paginationDefault = exports.headerReactNodes = exports.mapRowToCells = exports.ColumnNoCDFindAsset = exports.ColumnFindAsset = exports.ColumnNoCD = exports.Column = void 0;
var Reducers_1 = __webpack_require__(/*! @innovyze/lib-am-common/Reducers */ "@innovyze/lib-am-common/Reducers");
// Columns in order displayed by table
var Column;
(function (Column) {
    Column[Column["AssetId"] = 0] = "AssetId";
    Column[Column["RiskTrend"] = 1] = "RiskTrend";
    Column[Column["CurrentRisk"] = 2] = "CurrentRisk";
    Column[Column["CurrentLOF"] = 3] = "CurrentLOF";
    Column[Column["CurrentCOF"] = 4] = "CurrentCOF";
    Column[Column["ConditionData"] = 5] = "ConditionData";
    Column[Column["Grade"] = 6] = "Grade";
})(Column = exports.Column || (exports.Column = {}));
var ColumnNoCD;
(function (ColumnNoCD) {
    ColumnNoCD[ColumnNoCD["AssetId"] = 0] = "AssetId";
    ColumnNoCD[ColumnNoCD["RiskTrend"] = 1] = "RiskTrend";
    ColumnNoCD[ColumnNoCD["CurrentRisk"] = 2] = "CurrentRisk";
    ColumnNoCD[ColumnNoCD["CurrentLOF"] = 3] = "CurrentLOF";
    ColumnNoCD[ColumnNoCD["CurrentCOF"] = 4] = "CurrentCOF";
    ColumnNoCD[ColumnNoCD["Grade"] = 5] = "Grade";
})(ColumnNoCD = exports.ColumnNoCD || (exports.ColumnNoCD = {}));
var ColumnFindAsset;
(function (ColumnFindAsset) {
    ColumnFindAsset[ColumnFindAsset["AssetId"] = 0] = "AssetId";
    ColumnFindAsset[ColumnFindAsset["RiskTrend"] = 1] = "RiskTrend";
    ColumnFindAsset[ColumnFindAsset["CurrentRisk"] = 2] = "CurrentRisk";
    ColumnFindAsset[ColumnFindAsset["CurrentLOF"] = 3] = "CurrentLOF";
    ColumnFindAsset[ColumnFindAsset["CurrentCOF"] = 4] = "CurrentCOF";
    ColumnFindAsset[ColumnFindAsset["ConditionData"] = 5] = "ConditionData";
    ColumnFindAsset[ColumnFindAsset["Grade"] = 6] = "Grade";
    ColumnFindAsset[ColumnFindAsset["Menu"] = 7] = "Menu";
})(ColumnFindAsset = exports.ColumnFindAsset || (exports.ColumnFindAsset = {}));
var ColumnNoCDFindAsset;
(function (ColumnNoCDFindAsset) {
    ColumnNoCDFindAsset[ColumnNoCDFindAsset["AssetId"] = 0] = "AssetId";
    ColumnNoCDFindAsset[ColumnNoCDFindAsset["RiskTrend"] = 1] = "RiskTrend";
    ColumnNoCDFindAsset[ColumnNoCDFindAsset["CurrentRisk"] = 2] = "CurrentRisk";
    ColumnNoCDFindAsset[ColumnNoCDFindAsset["CurrentLOF"] = 3] = "CurrentLOF";
    ColumnNoCDFindAsset[ColumnNoCDFindAsset["CurrentCOF"] = 4] = "CurrentCOF";
    ColumnNoCDFindAsset[ColumnNoCDFindAsset["Grade"] = 5] = "Grade";
    ColumnNoCDFindAsset[ColumnNoCDFindAsset["Menu"] = 6] = "Menu";
})(ColumnNoCDFindAsset = exports.ColumnNoCDFindAsset || (exports.ColumnNoCDFindAsset = {}));
var mapRowToCells = function (row) {
    var _a, _b, _c, _d, _e, _f;
    return [
        (row === null || row === void 0 ? void 0 : row.ASSET_ID) || '',
        (row === null || row === void 0 ? void 0 : row.RISK_CHANGE) == null || (row === null || row === void 0 ? void 0 : row.RISK_CHANGE) == undefined
            ? ''
            : row === null || row === void 0 ? void 0 : row.RISK_CHANGE,
        (_a = row === null || row === void 0 ? void 0 : row.CURRENT_RISK) === null || _a === void 0 ? void 0 : _a.toString(),
        (_b = row === null || row === void 0 ? void 0 : row.CURRENT_LOF) === null || _b === void 0 ? void 0 : _b.toString(),
        (_c = row === null || row === void 0 ? void 0 : row.CURRENT_COF) === null || _c === void 0 ? void 0 : _c.toString(),
        (_e = (_d = row === null || row === void 0 ? void 0 : row.CONDITION_DATA) === null || _d === void 0 ? void 0 : _d.toString()) !== null && _e !== void 0 ? _e : '',
        (_f = row === null || row === void 0 ? void 0 : row.GRADE) === null || _f === void 0 ? void 0 : _f.toString(),
        '',
    ];
};
exports.mapRowToCells = mapRowToCells;
var headerReactNodes = function (noConditionData, showFindAsset, t) {
    var rows = [
        {
            key: 'ASSET_ID',
            cell: t ? t('Asset ID') : 'Asset ID',
            maxWidth: '200px',
            align: 'left',
            sortable: true,
            padding: '0 10px',
        },
        {
            key: 'RISK_CHANGE',
            cell: t ? t('Risk Trend') : 'Risk Trend',
            width: 'auto',
            align: 'left',
            sortable: true,
            padding: '0 10px',
        },
        {
            key: 'CURRENT_RISK',
            cell: t ? t('Risk Score') : 'Risk Score',
            width: 'auto',
            align: 'left',
            sortable: true,
            padding: '0 10px',
        },
        {
            key: 'CURRENT_LOF',
            cell: t ? t('Total LoF') : 'Total LoF',
            width: 'auto',
            align: 'left',
            sortable: true,
            padding: '0 10px',
        },
        {
            key: 'CURRENT_COF',
            cell: t ? t('Total CoF') : 'Total CoF',
            width: 'auto',
            align: 'left',
            sortable: true,
            padding: '0 10px',
        },
    ];
    if (!noConditionData) {
        rows.push({
            key: 'CONDITION_DATA',
            cell: t ? t('Condition Data') : 'Condition Data',
            width: 'auto',
            align: 'left',
            sortable: false,
            padding: '0 10px',
        });
    }
    rows.push({
        key: 'GRADE',
        cell: t ? t('Grade') : 'Grade',
        width: '150px',
        align: 'left',
        sortable: true,
        padding: '0 10px',
    });
    if (showFindAsset) {
        rows.push({
            key: 'MENU',
            cell: '',
            width: '68px',
            align: 'center',
            padding: '0 10px',
        });
    }
    return rows;
};
exports.headerReactNodes = headerReactNodes;
var paginationDefault = function () { return (__assign(__assign({}, Reducers_1.paginationInitialState), { sortKey: 'uploadDateTime', sortDescending: true })); };
exports.paginationDefault = paginationDefault;


/***/ }),

/***/ "./sagas/CoF.sagas.ts":
/*!****************************!*\
  !*** ./sagas/CoF.sagas.ts ***!
  \****************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var effects_1 = __webpack_require__(/*! @redux-saga/core/effects */ "@redux-saga/core/effects");
var _Selectors_1 = __webpack_require__(/*! @Selectors */ "./selectors/index.ts");
var CoF_services_1 = __webpack_require__(/*! @Services/CoF/CoF.services */ "./services/CoF/CoF.services.ts");
var axios_1 = __importDefault(__webpack_require__(/*! axios */ "../node_modules/axios/dist/browser/axios.cjs"));
var Risk_sagas_1 = __webpack_require__(/*! ./Risk.sagas */ "./sagas/Risk.sagas.ts");
var Risk_services_1 = __webpack_require__(/*! @Services/Risk/Risk.services */ "./services/Risk/Risk.services.ts");
var i18next_1 = __webpack_require__(/*! i18next */ "i18next");
function getCoFFieldsSaga(action) {
    var response, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 1500, CoF_services_1.getCoFFieldsApi, action.payload)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getCoFFieldsResolved)(response.data))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_1 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getCoFFieldsRejected)())];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function watchGetCoFConfig() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(_Actions_1.getCoFFields, getCoFFieldsSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function getProximityAttributeFieldsSaga(action) {
    var response, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 1500, CoF_services_1.getProximityAttributeFieldsApi, action.payload)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getProximityAttributeFieldsResolved)(response.data))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_2 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getProximityAttributeFieldsRejected)())];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function watchGetProximityAttributeConfig() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(_Actions_1.getProximityAttributeFields, getProximityAttributeFieldsSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function getCustomTableFieldsSaga(action) {
    var response, e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 1500, CoF_services_1.getCustomTableFieldsApi, action.payload)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getCustomTableFieldsResolved)(response.data))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_3 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getCustomTableFieldsRejected)())];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function watchGetCustomTableConfig() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(_Actions_1.getCustomTableFields, getCustomTableFieldsSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function saveRiskConfigSaga(action) {
    var riskConfig, cofConfig, finalRiskConfig, mongoRiskConfig, e_4, info, axiosError;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 6, , 9]);
                return [4 /*yield*/, (0, effects_1.select)(_Selectors_1.RiskConfigSelector)];
            case 1:
                riskConfig = _c.sent();
                return [4 /*yield*/, (0, effects_1.select)(_Selectors_1.CoFStoreSelector)];
            case 2:
                cofConfig = _c.sent();
                finalRiskConfig = __assign(__assign({}, riskConfig), { COFCategories: cofConfig.categories });
                mongoRiskConfig = (0, Risk_sagas_1.mapSnowCfgToMongoCfg)(finalRiskConfig);
                return [4 /*yield*/, (0, effects_1.retry)(5, 1500, Risk_services_1.saveRiskConfigApi, mongoRiskConfig)];
            case 3:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.saveCoFResolved)())];
            case 4:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.success)((0, i18next_1.t)('CoF configuration saved')))];
            case 5:
                _c.sent();
                action.payload.refresh();
                return [3 /*break*/, 9];
            case 6:
                e_4 = _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.saveCoFRejected)())];
            case 7:
                _c.sent();
                info = (0, i18next_1.t)('No additional information');
                if (axios_1.default.isAxiosError(e_4)) {
                    axiosError = e_4;
                    info = (_b = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.statusText) !== null && _b !== void 0 ? _b : info;
                }
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('CoF configuration failed to save: {{info}}', {
                        info: info,
                    })))];
            case 8:
                _c.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function watchSaveCoF() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(_Actions_1.saveCoF, saveRiskConfigSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
var sagaArray = [
    watchGetCoFConfig(),
    watchSaveCoF(),
    watchGetProximityAttributeConfig(),
    watchGetCustomTableConfig(),
];
exports["default"] = sagaArray;


/***/ }),

/***/ "./sagas/LoF.sagas.ts":
/*!****************************!*\
  !*** ./sagas/LoF.sagas.ts ***!
  \****************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var effects_1 = __webpack_require__(/*! @redux-saga/core/effects */ "@redux-saga/core/effects");
var _Selectors_1 = __webpack_require__(/*! @Selectors */ "./selectors/index.ts");
var LoF_services_1 = __webpack_require__(/*! @Services/LoF/LoF.services */ "./services/LoF/LoF.services.ts");
var axios_1 = __importDefault(__webpack_require__(/*! axios */ "../node_modules/axios/dist/browser/axios.cjs"));
var Risk_sagas_1 = __webpack_require__(/*! ./Risk.sagas */ "./sagas/Risk.sagas.ts");
var Risk_services_1 = __webpack_require__(/*! @Services/Risk/Risk.services */ "./services/Risk/Risk.services.ts");
var i18next_1 = __webpack_require__(/*! i18next */ "i18next");
function getLoFInspectionFieldsSaga(action) {
    var response, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 1500, LoF_services_1.getLoFInspectionFieldsApi, action.payload)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getLoFInspectionFieldsResolved)(response.data))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_1 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getLoFInspectionFieldsRejected)())];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function getLoFFieldsSaga(action) {
    var response, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 1500, LoF_services_1.getLoFFieldsApi, action.payload)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getLoFFieldsResolved)(response.data))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_2 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getLoFFieldsRejected)())];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function watchGetLoFConfig() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(_Actions_1.getLoFInspectionFields, getLoFInspectionFieldsSaga)];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(_Actions_1.getLoFFields, getLoFFieldsSaga)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function saveRiskConfigSaga(action) {
    var riskConfig, lofConfig, finalRiskConfig, mongoRiskConfig, e_3, info, axiosError;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 6, , 9]);
                return [4 /*yield*/, (0, effects_1.select)(_Selectors_1.RiskConfigSelector)];
            case 1:
                riskConfig = _c.sent();
                return [4 /*yield*/, (0, effects_1.select)(_Selectors_1.LoFStoreSelector)];
            case 2:
                lofConfig = _c.sent();
                finalRiskConfig = __assign(__assign({}, riskConfig), { LOFCategories: lofConfig.categories });
                mongoRiskConfig = (0, Risk_sagas_1.mapSnowCfgToMongoCfg)(finalRiskConfig);
                return [4 /*yield*/, (0, effects_1.retry)(5, 1500, Risk_services_1.saveRiskConfigApi, mongoRiskConfig)];
            case 3:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.saveLoFResolved)())];
            case 4:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.success)((0, i18next_1.t)('LoF configuration saved')))];
            case 5:
                _c.sent();
                action.payload.refresh();
                return [3 /*break*/, 9];
            case 6:
                e_3 = _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.saveLoFRejected)())];
            case 7:
                _c.sent();
                info = (0, i18next_1.t)('No additional information');
                if (axios_1.default.isAxiosError(e_3)) {
                    axiosError = e_3;
                    info = (_b = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.statusText) !== null && _b !== void 0 ? _b : info;
                }
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('LoF configuration failed to save: {{info}}', {
                        info: info,
                    })))];
            case 8:
                _c.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function watchSaveLoF() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(_Actions_1.saveLoF, saveRiskConfigSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
var sagaArray = [watchGetLoFConfig(), watchSaveLoF()];
exports["default"] = sagaArray;


/***/ }),

/***/ "./sagas/Risk.sagas.ts":
/*!*****************************!*\
  !*** ./sagas/Risk.sagas.ts ***!
  \*****************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getRiskMatrixPreviewSaga = exports.cancelRiskMatrixPreviewSaga = exports.initRiskMatrixPreviewSaga = exports.saveRiskConfigSaga = exports.renameRiskConfigSaga = exports.createRiskConfigSaga = exports.mapSnowCfgToMongoCfg = exports.getRiskConfigSaga = void 0;
var Risk_actions_1 = __webpack_require__(/*! @Actions/Risk.actions */ "./actions/Risk.actions.ts");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var effects_1 = __webpack_require__(/*! @redux-saga/core/effects */ "@redux-saga/core/effects");
var asset_services_1 = __webpack_require__(/*! @Services/asset/asset.services */ "./services/asset/asset.services.ts");
var Risk_services_1 = __webpack_require__(/*! @Services/Risk/Risk.services */ "./services/Risk/Risk.services.ts");
var axios_1 = __importDefault(__webpack_require__(/*! axios */ "../node_modules/axios/dist/browser/axios.cjs"));
var effects_2 = __webpack_require__(/*! redux-saga/effects */ "../node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js");
var _Selectors_1 = __webpack_require__(/*! @Selectors */ "./selectors/index.ts");
var i18next_1 = __webpack_require__(/*! i18next */ "i18next");
var LoF_actions_1 = __webpack_require__(/*! @Actions/LoF.actions */ "./actions/LoF.actions.ts");
var CoF_actions_1 = __webpack_require__(/*! @Actions/CoF.actions */ "./actions/CoF.actions.ts");
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var RiskMatrixDefaultScores_1 = __webpack_require__(/*! @Reducers/RiskMatrixDefaultScores */ "./reducers/RiskMatrixDefaultScores.ts");
var util_actions_1 = __webpack_require__(/*! @Actions/util.actions */ "./actions/util.actions.ts");
var Actions_1 = __webpack_require__(/*! @innovyze/lib-am-common/Actions */ "@innovyze/lib-am-common/Actions");
var lib_asset_schema_store_1 = __webpack_require__(/*! @innovyze/lib_asset_schema_store */ "@innovyze/lib_asset_schema_store");
function getRiskConfigSaga(action) {
    var configId, mongoRiskConfigResponse, snowRiskConfig, assetFilterId, assetFilterResponse, assetSchema, lofDefaultRiskCategories, defaultCategories, snowRiskConfigCategories, lofConfig;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                configId = action.payload;
                return [4 /*yield*/, (0, effects_2.call)(Risk_services_1.getRiskConfigApi, configId)];
            case 1:
                mongoRiskConfigResponse = _d.sent();
                snowRiskConfig = mapMongoCfgToSnowCfg(mongoRiskConfigResponse.data);
                assetFilterId = (_a = mongoRiskConfigResponse.data) === null || _a === void 0 ? void 0 : _a.assetFilterId;
                if (!assetFilterId) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, effects_2.call)(asset_services_1.getAssetFilterApi, assetFilterId)];
            case 2:
                assetFilterResponse = _d.sent();
                if (assetFilterId === ((_b = assetFilterResponse.data) === null || _b === void 0 ? void 0 : _b._id)) {
                    snowRiskConfig.assetFilter = assetFilterResponse.data;
                }
                _d.label = 3;
            case 3: return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.getRiskConfigResolved)(snowRiskConfig))];
            case 4:
                _d.sent();
                return [4 /*yield*/, (0, effects_2.select)(function (state) {
                        return (0, lib_asset_schema_store_1.assetSchemaSelectorByType)(state, snowRiskConfig.riskSetting.assetType);
                    })];
            case 5:
                assetSchema = _d.sent();
                lofDefaultRiskCategories = assetSchema === null || assetSchema === void 0 ? void 0 : assetSchema.getRiskCategories('Lof');
                defaultCategories = (_c = lofDefaultRiskCategories === null || lofDefaultRiskCategories === void 0 ? void 0 : lofDefaultRiskCategories.map(function (_a) {
                    var DisplayName = _a.DisplayName, Condition = _a.Condition;
                    return ({
                        name: (0, i18next_1.t)(DisplayName),
                        isCondition: Condition !== null && Condition !== void 0 ? Condition : false,
                        useThisOnly: false,
                        weighting: 100 / lofDefaultRiskCategories.length,
                        useHighestScore: false,
                        components: [],
                    });
                })) !== null && _c !== void 0 ? _c : [];
                snowRiskConfigCategories = snowRiskConfig.LOFCategories;
                if (snowRiskConfigCategories.length) {
                    // If there are no default categories, we need to remove the first category
                    // as the condition category was added even to the configs that
                    // should not have it e.g. WaterDistribution pipe should not have it
                    if (!defaultCategories.length &&
                        snowRiskConfigCategories[0].name === (0, i18next_1.t)('Condition Category')) {
                        lofConfig = snowRiskConfigCategories.slice(1);
                    }
                    else {
                        lofConfig = snowRiskConfigCategories;
                    }
                }
                else {
                    lofConfig = defaultCategories;
                }
                return [4 /*yield*/, (0, effects_1.put)((0, LoF_actions_1.getLoFConfigResolved)(lofConfig))];
            case 6:
                _d.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, CoF_actions_1.getCoFComponentsResolved)(snowRiskConfig.COFCategories))];
            case 7:
                _d.sent();
                return [2 /*return*/];
        }
    });
}
exports.getRiskConfigSaga = getRiskConfigSaga;
var mapMongoCfgToSnowCfg = function (mongoCfg) {
    var _a, _b, _c;
    var result = {
        riskSetting: {
            configId: mongoCfg.configId,
            inspectionStandard: mongoCfg.inspectionStandard,
            publishState: mongoCfg.publishState,
            RiskMethod: mongoCfg.riskMethod,
            COFWeighting: mongoCfg.cofWeighting,
            LOFWeighting: mongoCfg.lofWeighting,
            LastRun: mongoCfg.lastRun,
            // Use the lastRun if the completed date isn't there for older runs
            lastRunCompleted: (_a = mongoCfg.lastRunCompleted) !== null && _a !== void 0 ? _a : mongoCfg.lastRun,
            Grades: {
                Low: mongoCfg.grades.low,
                Medium: mongoCfg.grades.medium,
                High: mongoCfg.grades.high,
                Max: mongoCfg.grades.max,
                Extreme: mongoCfg.grades.extreme,
            },
            assetType: mongoCfg.assetType,
            assetFilterId: mongoCfg.assetFilterId,
            name: mongoCfg.name,
            assetCount: mongoCfg.assetCount,
            runBy: mongoCfg.runBy,
            status: mongoCfg.status,
            riskType: (_b = mongoCfg.riskType) !== null && _b !== void 0 ? _b : 'linear',
            matrix: (_c = mongoCfg.matrix) !== null && _c !== void 0 ? _c : __assign({}, RiskMatrixDefaultScores_1.defaultRiskMatrix),
            maxOverallRiskScore: mongoCfg.maxOverallRiskScore,
            postProcessing: mongoCfg.postProcessing,
        },
        LOFCategories: mongoCfg.lofCfgCategories,
        COFCategories: mongoCfg.cofCfgCategories,
    };
    return result;
};
var mapSnowCfgToMongoCfg = function (snowCfg) {
    var _a, _b;
    var result = {
        publishState: snowCfg.riskSetting.publishState,
        inspectionStandard: snowCfg.riskSetting.inspectionStandard,
        configId: snowCfg.riskSetting.configId,
        name: snowCfg.riskSetting.name,
        cofWeighting: snowCfg.riskSetting.COFWeighting,
        lofWeighting: snowCfg.riskSetting.LOFWeighting,
        riskMethod: snowCfg.riskSetting.RiskMethod,
        lastRun: snowCfg.riskSetting.LastRun,
        grades: {
            low: snowCfg.riskSetting.Grades.Low,
            medium: snowCfg.riskSetting.Grades.Medium,
            high: snowCfg.riskSetting.Grades.High,
            extreme: snowCfg.riskSetting.Grades.Extreme,
            max: snowCfg.riskSetting.Grades.Max,
        },
        assetType: snowCfg.riskSetting.assetType,
        assetFilterId: snowCfg.riskSetting.assetFilterId,
        assetCount: snowCfg.riskSetting.assetCount,
        runBy: snowCfg.riskSetting.runBy,
        status: snowCfg.riskSetting.status,
        lofCfgCategories: snowCfg.LOFCategories.map(function (cat) { return (__assign(__assign({}, cat), { components: cat.components.map(function (comp) { return (__assign(__assign({}, comp), { inspectionType: 'PACP' })); }) })); }),
        cofCfgCategories: snowCfg.COFCategories,
        riskType: (_a = snowCfg.riskSetting.riskType) !== null && _a !== void 0 ? _a : 'linear',
        matrix: (_b = snowCfg.riskSetting.matrix) !== null && _b !== void 0 ? _b : __assign({}, RiskMatrixDefaultScores_1.defaultRiskMatrix),
        maxOverallRiskScore: snowCfg.riskSetting.maxOverallRiskScore,
        postProcessing: snowCfg.riskSetting.postProcessing,
    };
    return result;
};
exports.mapSnowCfgToMongoCfg = mapSnowCfgToMongoCfg;
function watchGetRiskConfig() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(Risk_actions_1.getRiskConfig, getRiskConfigSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function createRiskConfigSaga(action) {
    var config, response, e_1, axiosError, data;
    var _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _e.trys.push([0, 5, , 14]);
                config = __assign(__assign({}, action.payload.config), { publishState: 'unpublished' });
                return [4 /*yield*/, (0, effects_2.call)(Risk_services_1.createRiskConfigApi, config)];
            case 1:
                response = _e.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskConfigNameError)((0, i18next_1.t)('')))];
            case 2:
                _e.sent();
                action.payload.history.push((0, actions_1.addRouteNamespace)("results/".concat(response.data.insertedId)));
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskConfigIsCreating)(false))];
            case 3:
                _e.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Actions_1.changeRiskConfigsPage)(action.payload.page))];
            case 4:
                _e.sent();
                return [3 /*break*/, 14];
            case 5:
                e_1 = _e.sent();
                if (!axios_1.default.isAxiosError(e_1)) return [3 /*break*/, 10];
                axiosError = e_1;
                data = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data;
                if (!((data === null || data === void 0 ? void 0 : data.errorMessage) === '[400] Duplicate config name')) return [3 /*break*/, 7];
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskConfigNameError)((0, i18next_1.t)('Enter a unique name')))];
            case 6:
                _e.sent();
                return [3 /*break*/, 9];
            case 7: return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Failed to create risk model: {{info}}', {
                    info: (_d = (_c = (_b = axiosError.response) === null || _b === void 0 ? void 0 : _b.statusText) !== null && _c !== void 0 ? _c : data === null || data === void 0 ? void 0 : data.errorMessage) !== null && _d !== void 0 ? _d : (0, i18next_1.t)('No additional information'),
                })))];
            case 8:
                _e.sent();
                _e.label = 9;
            case 9: return [3 /*break*/, 12];
            case 10: return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Failed to create risk model: {{info}}', {
                    info: (0, i18next_1.t)('No additional information'),
                })))];
            case 11:
                _e.sent();
                _e.label = 12;
            case 12: return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskConfigIsCreating)(false))];
            case 13:
                _e.sent();
                return [3 /*break*/, 14];
            case 14: return [2 /*return*/];
        }
    });
}
exports.createRiskConfigSaga = createRiskConfigSaga;
function duplicateRiskConfigSaga(action) {
    var response, configId, e_2, axiosError, data;
    var _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _e.trys.push([0, 6, , 12]);
                return [4 /*yield*/, (0, effects_2.call)(Risk_services_1.duplicateRiskConfigApi, action.payload.configId, action.payload.config)];
            case 1:
                response = _e.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskConfigIsCreating)(false))];
            case 2:
                _e.sent();
                configId = response.data.configId;
                if (!configId) return [3 /*break*/, 5];
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.clearRiskConfig)())];
            case 3:
                _e.sent();
                action.payload.history.push((0, actions_1.addRouteNamespace)("results/".concat(configId)));
                return [4 /*yield*/, (0, effects_1.put)((0, Actions_1.changeRiskConfigsPage)(1))];
            case 4:
                _e.sent();
                _e.label = 5;
            case 5: return [3 /*break*/, 12];
            case 6:
                e_2 = _e.sent();
                if (!axios_1.default.isAxiosError(e_2)) return [3 /*break*/, 8];
                axiosError = e_2;
                data = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data;
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Failed to create risk model: {{info}}', {
                        info: (_d = (_c = (_b = axiosError.response) === null || _b === void 0 ? void 0 : _b.statusText) !== null && _c !== void 0 ? _c : data === null || data === void 0 ? void 0 : data.errorMessage) !== null && _d !== void 0 ? _d : (0, i18next_1.t)('No additional information'),
                    })))];
            case 7:
                _e.sent();
                return [3 /*break*/, 10];
            case 8: return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Failed to create risk model: {{info}}', {
                    info: (0, i18next_1.t)('No additional information'),
                })))];
            case 9:
                _e.sent();
                _e.label = 10;
            case 10: return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskConfigIsCreating)(false))];
            case 11:
                _e.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
function watchCreateRiskConfig() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(Risk_actions_1.duplicateRiskConfig, duplicateRiskConfigSaga)];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(Risk_actions_1.createRiskConfig, createRiskConfigSaga)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function renameRiskConfigSaga(action) {
    var snowRiskConfig, mongoRiskConfig, e_3, axiosError, data;
    var _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _e.trys.push([0, 6, , 15]);
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskIsSaving)(true))];
            case 1:
                _e.sent();
                snowRiskConfig = action.payload;
                mongoRiskConfig = (0, exports.mapSnowCfgToMongoCfg)(snowRiskConfig);
                return [4 /*yield*/, (0, effects_2.call)(Risk_services_1.saveRiskConfigApi, mongoRiskConfig)];
            case 2:
                _e.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.success)((0, i18next_1.t)('Risk model renamed')))];
            case 3:
                _e.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.getRiskConfigResolved)(snowRiskConfig))];
            case 4:
                _e.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskIsSaving)(false))];
            case 5:
                _e.sent();
                return [3 /*break*/, 15];
            case 6:
                e_3 = _e.sent();
                if (!axios_1.default.isAxiosError(e_3)) return [3 /*break*/, 11];
                axiosError = e_3;
                data = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data;
                if (!((data === null || data === void 0 ? void 0 : data.errorMessage) === '[400] Duplicate config name')) return [3 /*break*/, 8];
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskConfigNameError)((0, i18next_1.t)('Enter a unique name')))];
            case 7:
                _e.sent();
                return [3 /*break*/, 10];
            case 8: return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Risk model failed to save: {{info}}', {
                    info: (_d = (_c = (_b = axiosError.response) === null || _b === void 0 ? void 0 : _b.statusText) !== null && _c !== void 0 ? _c : data === null || data === void 0 ? void 0 : data.errorMessage) !== null && _d !== void 0 ? _d : (0, i18next_1.t)('No additional information'),
                })))];
            case 9:
                _e.sent();
                _e.label = 10;
            case 10: return [3 /*break*/, 13];
            case 11: return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Risk model failed to save: {{info}}', {
                    info: (0, i18next_1.t)('No additional information'),
                })))];
            case 12:
                _e.sent();
                _e.label = 13;
            case 13: return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskIsSaving)(false))];
            case 14:
                _e.sent();
                return [3 /*break*/, 15];
            case 15: return [2 /*return*/];
        }
    });
}
exports.renameRiskConfigSaga = renameRiskConfigSaga;
function saveRiskConfigSaga(action) {
    var snowRiskConfig, mongoRiskConfig, e_4, axiosError, data;
    var _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _e.trys.push([0, 6, , 15]);
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskIsSaving)(true))];
            case 1:
                _e.sent();
                snowRiskConfig = action.payload;
                mongoRiskConfig = (0, exports.mapSnowCfgToMongoCfg)(snowRiskConfig);
                return [4 /*yield*/, (0, effects_2.call)(Risk_services_1.saveRiskConfigApi, mongoRiskConfig)];
            case 2:
                _e.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.success)((0, i18next_1.t)('Risk model saved')))];
            case 3:
                _e.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskSetupDirty)(false))];
            case 4:
                _e.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskIsSaving)(false))];
            case 5:
                _e.sent();
                return [3 /*break*/, 15];
            case 6:
                e_4 = _e.sent();
                if (!axios_1.default.isAxiosError(e_4)) return [3 /*break*/, 11];
                axiosError = e_4;
                data = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.data;
                if (!((data === null || data === void 0 ? void 0 : data.errorMessage) === '[400] Duplicate config name')) return [3 /*break*/, 8];
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskConfigNameError)((0, i18next_1.t)('Enter a unique name')))];
            case 7:
                _e.sent();
                return [3 /*break*/, 10];
            case 8: return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Risk model failed to save: {{info}}', {
                    info: (_d = (_c = (_b = axiosError.response) === null || _b === void 0 ? void 0 : _b.statusText) !== null && _c !== void 0 ? _c : data === null || data === void 0 ? void 0 : data.errorMessage) !== null && _d !== void 0 ? _d : (0, i18next_1.t)('No additional information'),
                })))];
            case 9:
                _e.sent();
                _e.label = 10;
            case 10: return [3 /*break*/, 13];
            case 11: return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Risk model failed to save: {{info}}', {
                    info: (0, i18next_1.t)('No additional information'),
                })))];
            case 12:
                _e.sent();
                _e.label = 13;
            case 13: return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskIsSaving)(false))];
            case 14:
                _e.sent();
                return [3 /*break*/, 15];
            case 15: return [2 /*return*/];
        }
    });
}
exports.saveRiskConfigSaga = saveRiskConfigSaga;
function watchStoreRiskConfig() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(Risk_actions_1.renameRiskConfigAction, renameRiskConfigSaga)];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(Risk_actions_1.saveRiskConfigAction, saveRiskConfigSaga)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function getRiskDetailsSaga() {
    var query, payload, rows, data, e_5, axiosError;
    var _a, _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                _e.trys.push([0, 7, , 13]);
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskDetailsIsBusy)(true))];
            case 1:
                _e.sent();
                return [4 /*yield*/, (0, effects_2.select)(_Selectors_1.riskDetailsQuerySelector)];
            case 2:
                query = _e.sent();
                return [4 /*yield*/, (0, effects_1.retry)(2, 1500, Risk_services_1.getRiskDetailsApi, query)];
            case 3:
                payload = _e.sent();
                rows = payload.data.data;
                data = __assign(__assign({}, payload.data), { data: rows.map(function (riskDetail) {
                        if (riskDetail.ASSET_ID.indexOf('#') > 0) {
                            return __assign(__assign({}, riskDetail), { ASSET_ID: riskDetail.ASSET_ID.split('#')[1] });
                        }
                        else {
                            return riskDetail;
                        }
                    }) });
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.getRiskDetailsResolved)(data))];
            case 4:
                _e.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskDetailsIsBusy)(false))];
            case 5:
                _e.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setSearchStartSaga)(false))];
            case 6:
                _e.sent();
                return [3 /*break*/, 13];
            case 7:
                e_5 = _e.sent();
                if (!axios_1.default.isAxiosError(e_5)) return [3 /*break*/, 10];
                axiosError = e_5;
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Failed to get risk details')))];
            case 8:
                _e.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.getRiskDetailsRejected)({
                        code: (_b = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : -1,
                        text: (_d = (_c = axiosError.response) === null || _c === void 0 ? void 0 : _c.statusText) !== null && _d !== void 0 ? _d : (0, i18next_1.t)('No additional information'),
                    }))];
            case 9:
                _e.sent();
                _e.label = 10;
            case 10: return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskDetailsIsBusy)(false))];
            case 11:
                _e.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setSearchStartSaga)(false))];
            case 12:
                _e.sent();
                return [3 /*break*/, 13];
            case 13: return [2 /*return*/];
        }
    });
}
function watchGetRiskDetails() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)([
                    Risk_actions_1.getRiskDetails,
                    Risk_actions_1.reloadRiskDetails,
                    Risk_actions_1.changePage,
                    Risk_actions_1.changeSlice,
                    Risk_actions_1.changePagination,
                    Risk_actions_1.changeSort,
                    Risk_actions_1.changeFilterSelect,
                    Risk_actions_1.changeFiltersSelect,
                ], getRiskDetailsSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function getLogSaga(action) {
    var configId, response, e_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                configId = action.payload;
                return [4 /*yield*/, (0, effects_1.retry)(5, 1500, Risk_services_1.getRiskCalcLogApi, configId)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.getLogResolved)(response.data))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_6 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.getLogRejected)())];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function watchGetLog() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(Risk_actions_1.getLog, getLogSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function runRiskSaga(action) {
    var configId, riskSettingResponse, reply, _a, e_7;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 8, , 10]);
                configId = action.payload;
                return [4 /*yield*/, (0, effects_1.retry)(1, // Take this down to 1 retry for the 404 fix
                    1500, Risk_services_1.startRiskCalculationApi, configId)];
            case 1:
                riskSettingResponse = _b.sent();
                reply = riskSettingResponse.data;
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.runRiskResolved)())];
            case 2:
                _b.sent();
                _a = reply.calcStatus;
                switch (_a) {
                    case 'risk-calc-in-progress': return [3 /*break*/, 3];
                    case 'risk-calc-post-processing-normalize': return [3 /*break*/, 3];
                }
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Risk calculation already in progress')))];
            case 4:
                _b.sent();
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.success)((0, i18next_1.t)('Risk calculation requested')))];
            case 6:
                _b.sent();
                return [3 /*break*/, 7];
            case 7: return [3 /*break*/, 10];
            case 8:
                e_7 = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.runRiskRejected)())];
            case 9:
                _b.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
function watchRunRisk() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(Risk_actions_1.runRisk, runRiskSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function resetRiskSaga(action) {
    var configId, e_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 9]);
                configId = action.payload;
                return [4 /*yield*/, (0, effects_1.retry)(1, // Take this down to 1 retry for the 404 fix
                    1500, Risk_services_1.resetRiskCalculationApi, configId)];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, util_actions_1.setRiskRunning)(false))];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.resetRiskResolved)())];
            case 3:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.success)((0, i18next_1.t)('Risk calculation cancel requested')))];
            case 4:
                _a.sent();
                return [3 /*break*/, 9];
            case 5:
                e_8 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, util_actions_1.setRiskRunning)(false))];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.resetRiskRejected)())];
            case 7:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.success)((0, i18next_1.t)('Risk calculation failed')))];
            case 8:
                _a.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function watchResetRisk() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(Risk_actions_1.resetRisk, resetRiskSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function deleteRiskSaga(action) {
    var e_9, axiosError;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 4, , 10]);
                return [4 /*yield*/, (0, effects_1.retry)(3, 1500, Risk_services_1.deleteRiskApi, action.payload.configId)];
            case 1:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.success)((0, i18next_1.t)('Risk model deleted successfully')))];
            case 2:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskIsDeleting)(false))];
            case 3:
                _c.sent();
                action.payload.refresh();
                return [3 /*break*/, 10];
            case 4:
                e_9 = _c.sent();
                if (!axios_1.default.isAxiosError(e_9)) return [3 /*break*/, 6];
                axiosError = e_9;
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Risk model failed to delete: {{info}}', {
                        info: (_b = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.statusText) !== null && _b !== void 0 ? _b : (0, i18next_1.t)('No additional information'),
                    })))];
            case 5:
                _c.sent();
                return [3 /*break*/, 8];
            case 6: return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Risk model failed to delete: {{info}}', {
                    info: (0, i18next_1.t)('No additional information'),
                })))];
            case 7:
                _c.sent();
                _c.label = 8;
            case 8: return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskIsDeleting)(false))];
            case 9:
                _c.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
function watchDeleteRiskeSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(Risk_actions_1.deleteRisk, deleteRiskSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function changeRiskConfigPublishStateSaga(action) {
    var _a, newPublishState, configId, err_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, newPublishState = _a.newPublishState, configId = _a.configId;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 6]);
                return [4 /*yield*/, (0, effects_2.call)(Risk_services_1.changeRiskConfigPublishStateApi, newPublishState, configId)];
            case 2:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.success)((0, i18next_1.t)('Risk model {{newPublishState}}', { newPublishState: newPublishState })))];
            case 3:
                _b.sent();
                action.payload.refresh();
                return [3 /*break*/, 6];
            case 4:
                err_1 = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Failed to {{newPublishState}} risk model', {
                        newPublishState: newPublishState,
                    })))];
            case 5:
                _b.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function watchChangeRiskConfigPublishStateSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(Risk_actions_1.changeRiskConfigPublishState, changeRiskConfigPublishStateSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function getRiskCountInspectionSaga(action) {
    var _a, key, metadata, metadataType, assetType, assetFilterId, fieldName, inspectionType, response, err_2;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, key = _a.key, metadata = _a.metadata, metadataType = _a.metadataType, assetType = _a.assetType, assetFilterId = _a.assetFilterId, fieldName = _a.fieldName, inspectionType = _a.inspectionType;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 7, , 9]);
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.getRiskCountResolved)({ key: key, values: undefined }))];
            case 2:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskCountIsLoading)({ key: key, loading: true }))];
            case 3:
                _b.sent();
                return [4 /*yield*/, (0, effects_2.call)(Risk_services_1.getRiskCountInspectionApi, metadata, metadataType, assetType, assetFilterId, fieldName, inspectionType)];
            case 4:
                response = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.getRiskCountResolved)({
                        key: key,
                        values: response.data,
                    }))];
            case 5:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskCountIsLoading)({ key: key, loading: false }))];
            case 6:
                _b.sent();
                return [3 /*break*/, 9];
            case 7:
                err_2 = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskCountIsLoading)({ key: key, loading: false }))];
            case 8:
                _b.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function getRiskCountAttributeSaga(action) {
    var _a, key, metadata, metadataType, assetType, assetFilterId, fieldName, response, err_3;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, key = _a.key, metadata = _a.metadata, metadataType = _a.metadataType, assetType = _a.assetType, assetFilterId = _a.assetFilterId, fieldName = _a.fieldName;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 7, , 9]);
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.getRiskCountResolved)({ key: key, values: undefined }))];
            case 2:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskCountIsLoading)({ key: key, loading: true }))];
            case 3:
                _b.sent();
                return [4 /*yield*/, (0, effects_2.call)(Risk_services_1.getRiskCountAtributeApi, metadata, metadataType, assetType, assetFilterId, fieldName)];
            case 4:
                response = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.getRiskCountResolved)({
                        key: key,
                        values: response.data,
                    }))];
            case 5:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskCountIsLoading)({ key: key, loading: false }))];
            case 6:
                _b.sent();
                return [3 /*break*/, 9];
            case 7:
                err_3 = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskCountIsLoading)({ key: key, loading: false }))];
            case 8:
                _b.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function getRiskCountObservationSaga(action) {
    var _a, key, metadata, metadataType, assetType, assetFilterId, fieldName, response, err_4;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, key = _a.key, metadata = _a.metadata, metadataType = _a.metadataType, assetType = _a.assetType, assetFilterId = _a.assetFilterId, fieldName = _a.fieldName;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 7, , 9]);
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.getRiskCountResolved)({ key: key, values: undefined }))];
            case 2:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskCountIsLoading)({ key: key, loading: true }))];
            case 3:
                _b.sent();
                return [4 /*yield*/, (0, effects_2.call)(Risk_services_1.getRiskCountObservationApi, metadata, metadataType, assetType, assetFilterId, fieldName)];
            case 4:
                response = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.getRiskCountResolved)({
                        key: key,
                        values: response.data,
                    }))];
            case 5:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskCountIsLoading)({ key: key, loading: false }))];
            case 6:
                _b.sent();
                return [3 /*break*/, 9];
            case 7:
                err_4 = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskCountIsLoading)({ key: key, loading: false }))];
            case 8:
                _b.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function getRiskCountProximitySaga(action) {
    var _a, key, metadata, metadataType, assetType, assetFilterId, layerName, response, err_5;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, key = _a.key, metadata = _a.metadata, metadataType = _a.metadataType, assetType = _a.assetType, assetFilterId = _a.assetFilterId, layerName = _a.layerName;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 7, , 9]);
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.getRiskCountResolved)({ key: key, values: undefined }))];
            case 2:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskCountIsLoading)({ key: key, loading: true }))];
            case 3:
                _b.sent();
                return [4 /*yield*/, (0, effects_2.call)(Risk_services_1.getRiskCountProximityApi, metadata, metadataType, assetType, assetFilterId, layerName)];
            case 4:
                response = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.getRiskCountResolved)({
                        key: key,
                        values: response.data,
                    }))];
            case 5:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskCountIsLoading)({ key: key, loading: false }))];
            case 6:
                _b.sent();
                return [3 /*break*/, 9];
            case 7:
                err_5 = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskCountIsLoading)({ key: key, loading: false }))];
            case 8:
                _b.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function getRiskCountProximityAttributeSaga(action) {
    var _a, key, metadata, metadataType, assetType, assetFilterId, layerName, fieldName, valueType, distance, response, err_6;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, key = _a.key, metadata = _a.metadata, metadataType = _a.metadataType, assetType = _a.assetType, assetFilterId = _a.assetFilterId, layerName = _a.layerName, fieldName = _a.fieldName, valueType = _a.valueType, distance = _a.distance;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 7, , 9]);
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.getRiskCountResolved)({ key: key, values: undefined }))];
            case 2:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskCountIsLoading)({ key: key, loading: true }))];
            case 3:
                _b.sent();
                return [4 /*yield*/, (0, effects_2.call)(Risk_services_1.getRiskCountProximityAtributeApi, metadata, metadataType, assetType, assetFilterId, layerName, fieldName, valueType, distance)];
            case 4:
                response = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.getRiskCountResolved)({
                        key: key,
                        values: response.data,
                    }))];
            case 5:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskCountIsLoading)({ key: key, loading: false }))];
            case 6:
                _b.sent();
                return [3 /*break*/, 9];
            case 7:
                err_6 = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskCountIsLoading)({ key: key, loading: false }))];
            case 8:
                _b.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function getSimulationDataSaga() {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.retry)(5, 1500, Risk_services_1.getSimulationDataApi)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.getSimulationDataResolved)(response.data))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function watchGetSimulationData() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(Risk_actions_1.getSimulationData, getSimulationDataSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function getTaskDataSaga(action) {
    var assetType, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                assetType = action.payload;
                return [4 /*yield*/, (0, effects_1.retry)(5, 1500, Risk_services_1.getTaskDataApi, assetType)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.getTaskDataResolved)(response.data))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function watchGetTaskData() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(Risk_actions_1.getTaskData, getTaskDataSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function getRiskCountCustomTableSaga(action) {
    var _a, key, metadata, metadataType, assetType, assetFilterId, fieldName, tableName, valueType, response, err_7;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, key = _a.key, metadata = _a.metadata, metadataType = _a.metadataType, assetType = _a.assetType, assetFilterId = _a.assetFilterId, fieldName = _a.fieldName, tableName = _a.tableName, valueType = _a.valueType;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 7, , 9]);
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.getRiskCountResolved)({ key: key, values: undefined }))];
            case 2:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskCountIsLoading)({ key: key, loading: true }))];
            case 3:
                _b.sent();
                return [4 /*yield*/, (0, effects_2.call)(Risk_services_1.getRiskCountCustomTableApi, metadata, metadataType, assetType, assetFilterId, fieldName, tableName, valueType)];
            case 4:
                response = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.getRiskCountResolved)({
                        key: key,
                        values: response.data,
                    }))];
            case 5:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskCountIsLoading)({ key: key, loading: false }))];
            case 6:
                _b.sent();
                return [3 /*break*/, 9];
            case 7:
                err_7 = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskCountIsLoading)({ key: key, loading: false }))];
            case 8:
                _b.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function getRiskCountTaskSaga(action) {
    var _a, key, metadata, metadataType, assetType, assetFilterId, fieldName, tableName, valueType, inspectionType, response, err_8;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, key = _a.key, metadata = _a.metadata, metadataType = _a.metadataType, assetType = _a.assetType, assetFilterId = _a.assetFilterId, fieldName = _a.fieldName, tableName = _a.tableName, valueType = _a.valueType, inspectionType = _a.inspectionType;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 7, , 9]);
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.getRiskCountResolved)({ key: key, values: undefined }))];
            case 2:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskCountIsLoading)({ key: key, loading: true }))];
            case 3:
                _b.sent();
                return [4 /*yield*/, (0, effects_2.call)(Risk_services_1.getRiskCountTaskApi, metadata, metadataType, assetType, assetFilterId, fieldName, tableName, valueType, inspectionType)];
            case 4:
                response = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.getRiskCountResolved)({
                        key: key,
                        values: response.data,
                    }))];
            case 5:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskCountIsLoading)({ key: key, loading: false }))];
            case 6:
                _b.sent();
                return [3 /*break*/, 9];
            case 7:
                err_8 = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskCountIsLoading)({ key: key, loading: false }))];
            case 8:
                _b.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function getRiskCountScoreMatrixSaga(action) {
    var _a, key, components, scoreMatrix, assetType, assetFilterId, inspectionType, response, err_9;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, key = _a.key, components = _a.components, scoreMatrix = _a.scoreMatrix, assetType = _a.assetType, assetFilterId = _a.assetFilterId, inspectionType = _a.inspectionType;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 7, , 9]);
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.getRiskCountResolved)({ key: key, values: undefined }))];
            case 2:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskCountIsLoading)({ key: key, loading: true }))];
            case 3:
                _b.sent();
                return [4 /*yield*/, (0, effects_2.call)(Risk_services_1.getRiskCountScoreMatrixApi, components, scoreMatrix, assetType, assetFilterId, inspectionType)];
            case 4:
                response = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.getRiskCountResolved)({
                        key: key,
                        values: response.data,
                    }))];
            case 5:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskCountIsLoading)({ key: key, loading: false }))];
            case 6:
                _b.sent();
                return [3 /*break*/, 9];
            case 7:
                err_9 = _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskCountIsLoading)({ key: key, loading: false }))];
            case 8:
                _b.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function watchGetRiskCount() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(Risk_actions_1.getRiskCountInspection, getRiskCountInspectionSaga)];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(Risk_actions_1.getRiskCountAttribute, getRiskCountAttributeSaga)];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(Risk_actions_1.getRiskCountProximity, getRiskCountProximitySaga)];
            case 3:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(Risk_actions_1.getRiskCountObservation, getRiskCountObservationSaga)];
            case 4:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(Risk_actions_1.getRiskCountProximityAttribute, getRiskCountProximityAttributeSaga)];
            case 5:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(Risk_actions_1.getRiskCountCustomTable, getRiskCountCustomTableSaga)];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(Risk_actions_1.getRiskCountTask, getRiskCountTaskSaga)];
            case 7:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(Risk_actions_1.getRiskCountScoreMatrix, getRiskCountScoreMatrixSaga)];
            case 8:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function initRiskMatrixPreviewSaga(action) {
    var _a, cofWeighting, lofWeighting, riskMethod, grades, grid, preview, configId, initialLoad, previewPostresponse, err_10;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = action.payload, cofWeighting = _a.cofWeighting, lofWeighting = _a.lofWeighting, riskMethod = _a.riskMethod, grades = _a.grades, grid = _a.grid, preview = _a.preview, configId = _a.configId, initialLoad = _a.initialLoad;
                _c.label = 1;
            case 1:
                _c.trys.push([1, 11, , 18]);
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setCancellPreview)(false))];
            case 2:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setIsPreviewLoading)(true))];
            case 3:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setIsPreviewOnLoad)(initialLoad))];
            case 4:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setMatrixPreviewStatus)('started'))];
            case 5:
                _c.sent();
                return [4 /*yield*/, (0, effects_2.call)(Risk_services_1.initRiskPreviewApi, cofWeighting, lofWeighting, riskMethod, grades, grid, preview, configId)];
            case 6:
                previewPostresponse = _c.sent();
                if (!((previewPostresponse === null || previewPostresponse === void 0 ? void 0 : previewPostresponse.data) &&
                    [
                        'risk-calc-matrix-preview-start',
                        'risk-calc-matrix-preview-in-progress',
                        'risk-calc-matrix-preview-initiated',
                    ].includes((_b = previewPostresponse === null || previewPostresponse === void 0 ? void 0 : previewPostresponse.data) === null || _b === void 0 ? void 0 : _b.calcStatus))) return [3 /*break*/, 10];
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.success)((0, i18next_1.t)('Risk Preview is being calculated.')))];
            case 7:
                _c.sent();
                // This is needed so that the config has time to set its status to start.
                // Otherwise, when polling immediately, its in a previous completed state.
                return [4 /*yield*/, (0, effects_2.delay)(1000)];
            case 8:
                // This is needed so that the config has time to set its status to start.
                // Otherwise, when polling immediately, its in a previous completed state.
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.getRiskMatrixPreview)({ configId: configId, initialLoad: initialLoad }))];
            case 9:
                _c.sent();
                _c.label = 10;
            case 10: return [3 /*break*/, 18];
            case 11:
                err_10 = _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setCancellPreview)(false))];
            case 12:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setEnablePreview)(false))];
            case 13:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setIsPreviewLoading)(false))];
            case 14:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setOnlyGradesUpdated)(false))];
            case 15:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setDidMatrixUpdate)(false))];
            case 16:
                _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Preview calculation failed')))];
            case 17:
                _c.sent();
                return [3 /*break*/, 18];
            case 18: return [2 /*return*/];
        }
    });
}
exports.initRiskMatrixPreviewSaga = initRiskMatrixPreviewSaga;
function cancelRiskMatrixPreviewSaga(action) {
    var _a, configId, matrix;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, configId = _a.configId, matrix = _a.matrix;
                // Use the configId to cancel the request on the server
                return [4 /*yield*/, (0, effects_2.call)(Risk_services_1.resetRiskPreviewCalculationApi, configId)];
            case 1:
                // Use the configId to cancel the request on the server
                _b.sent();
                // Set the results to what the preview was asked for
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskMatrixAfterPreview)(matrix))];
            case 2:
                // Set the results to what the preview was asked for
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setCancellPreview)(true))];
            case 3:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setEnablePreview)(false))];
            case 4:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setIsPreviewLoading)(false))];
            case 5:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setOnlyGradesUpdated)(false))];
            case 6:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setDidMatrixUpdate)(false))];
            case 7:
                _b.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Preview calculation cancelled')))];
            case 8:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
exports.cancelRiskMatrixPreviewSaga = cancelRiskMatrixPreviewSaga;
function getRiskMatrixPreviewSaga(action) {
    var _a, configId, initialLoad, getPreviewResponse, err_11;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    return __generator(this, function (_s) {
        switch (_s.label) {
            case 0:
                _a = action.payload, configId = _a.configId, initialLoad = _a.initialLoad;
                _s.label = 1;
            case 1:
                _s.trys.push([1, 26, , 35]);
                return [4 /*yield*/, (0, effects_2.call)(Risk_services_1.getRiskPreviewApi, configId)];
            case 2:
                getPreviewResponse = _s.sent();
                if (!((_b = getPreviewResponse === null || getPreviewResponse === void 0 ? void 0 : getPreviewResponse.data) === null || _b === void 0 ? void 0 : _b.calcStatus)) return [3 /*break*/, 25];
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setMatrixPreviewStatus)((_c = getPreviewResponse === null || getPreviewResponse === void 0 ? void 0 : getPreviewResponse.data) === null || _c === void 0 ? void 0 : _c.calcStatus))];
            case 3:
                _s.sent();
                if (!(((_d = getPreviewResponse === null || getPreviewResponse === void 0 ? void 0 : getPreviewResponse.data) === null || _d === void 0 ? void 0 : _d.calcStatus) ===
                    'risk-calc-matrix-preview-failed')) return [3 /*break*/, 10];
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setEnablePreview)(false))];
            case 4:
                _s.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setIsPreviewLoading)(false))];
            case 5:
                _s.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setOnlyGradesUpdated)(false))];
            case 6:
                _s.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setDidMatrixUpdate)(false))];
            case 7:
                _s.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskSetupDirty)(false))];
            case 8:
                _s.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Preview calculation failed')))];
            case 9:
                _s.sent();
                _s.label = 10;
            case 10:
                if (!(((_e = getPreviewResponse === null || getPreviewResponse === void 0 ? void 0 : getPreviewResponse.data) === null || _e === void 0 ? void 0 : _e.calcStatus) ===
                    'risk-calc-matrix-preview-complete')) return [3 /*break*/, 25];
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setCancellPreview)(false))];
            case 11:
                _s.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setEnablePreview)(false))];
            case 12:
                _s.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setIsPreviewLoading)(false))];
            case 13:
                _s.sent();
                if (!(((_j = (_h = (_g = (_f = getPreviewResponse === null || getPreviewResponse === void 0 ? void 0 : getPreviewResponse.data) === null || _f === void 0 ? void 0 : _f.preview) === null || _g === void 0 ? void 0 : _g.grades) === null || _h === void 0 ? void 0 : _h.cofRanges) === null || _j === void 0 ? void 0 : _j.length) > 0 &&
                    ((_o = (_m = (_l = (_k = getPreviewResponse === null || getPreviewResponse === void 0 ? void 0 : getPreviewResponse.data) === null || _k === void 0 ? void 0 : _k.preview) === null || _l === void 0 ? void 0 : _l.grades) === null || _m === void 0 ? void 0 : _m.lofRanges) === null || _o === void 0 ? void 0 : _o.length) > 0 &&
                    ((_r = (_q = (_p = getPreviewResponse === null || getPreviewResponse === void 0 ? void 0 : getPreviewResponse.data) === null || _p === void 0 ? void 0 : _p.preview) === null || _q === void 0 ? void 0 : _q.grid) === null || _r === void 0 ? void 0 : _r.length) > 0)) return [3 /*break*/, 19];
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskMatrixAfterPreview)(getPreviewResponse.data.preview))];
            case 14:
                _s.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setOnlyGradesUpdated)(false))];
            case 15:
                _s.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setDidMatrixUpdate)(true))];
            case 16:
                _s.sent();
                if (!!initialLoad) return [3 /*break*/, 18];
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskSetupDirty)(true))];
            case 17:
                _s.sent();
                _s.label = 18;
            case 18: return [3 /*break*/, 25];
            case 19: return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setOnlyGradesUpdated)(false))];
            case 20:
                _s.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setDidMatrixUpdate)(false))];
            case 21:
                _s.sent();
                if (!!initialLoad) return [3 /*break*/, 23];
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskSetupDirty)(true))];
            case 22:
                _s.sent();
                _s.label = 23;
            case 23: return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Preview calculation failed')))];
            case 24:
                _s.sent();
                _s.label = 25;
            case 25: return [3 /*break*/, 35];
            case 26:
                err_11 = _s.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setCancellPreview)(false))];
            case 27:
                _s.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setEnablePreview)(false))];
            case 28:
                _s.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setIsPreviewLoading)(false))];
            case 29:
                _s.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setOnlyGradesUpdated)(false))];
            case 30:
                _s.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setDidMatrixUpdate)(false))];
            case 31:
                _s.sent();
                if (!!initialLoad) return [3 /*break*/, 33];
                return [4 /*yield*/, (0, effects_1.put)((0, Risk_actions_1.setRiskSetupDirty)(true))];
            case 32:
                _s.sent();
                _s.label = 33;
            case 33: return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Preview calculation failed')))];
            case 34:
                _s.sent();
                return [3 /*break*/, 35];
            case 35: return [2 /*return*/];
        }
    });
}
exports.getRiskMatrixPreviewSaga = getRiskMatrixPreviewSaga;
function watchGetRiskMatrix() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(Risk_actions_1.initRiskMatrixPreview, initRiskMatrixPreviewSaga)];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(Risk_actions_1.cancelRiskMatrixPreview, cancelRiskMatrixPreviewSaga)];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(Risk_actions_1.getRiskMatrixPreview, getRiskMatrixPreviewSaga)];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
var sagaArray = [
    watchRunRisk(),
    watchCreateRiskConfig(),
    watchGetRiskConfig(),
    watchStoreRiskConfig(),
    watchGetRiskDetails(),
    watchGetLog(),
    watchResetRisk(),
    watchDeleteRiskeSaga(),
    watchChangeRiskConfigPublishStateSaga(),
    watchGetRiskCount(),
    watchGetRiskMatrix(),
    watchGetSimulationData(),
    watchGetTaskData(),
];
exports["default"] = sagaArray;


/***/ }),

/***/ "./sagas/asset.sagas.ts":
/*!******************************!*\
  !*** ./sagas/asset.sagas.ts ***!
  \******************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var asset_actions_1 = __webpack_require__(/*! @Actions/asset.actions */ "./actions/asset.actions.ts");
var effects_1 = __webpack_require__(/*! @redux-saga/core/effects */ "@redux-saga/core/effects");
var asset_services_1 = __webpack_require__(/*! @Services/asset/asset.services */ "./services/asset/asset.services.ts");
var Risk_services_1 = __webpack_require__(/*! @Services/Risk/Risk.services */ "./services/Risk/Risk.services.ts");
var lib_asset_schema_1 = __webpack_require__(/*! @innovyze/lib_asset_schema */ "@innovyze/lib_asset_schema");
function getAssetFieldsSaga(action) {
    var _a, systemType, assetType, assetSchema, properties, result, e_1;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, , 5]);
                _a = action.payload, systemType = _a.systemType, assetType = _a.assetType;
                return [4 /*yield*/, (0, effects_1.call)(lib_asset_schema_1.getAssetSchema, {
                        systemTypeId: systemType,
                        assetTypeId: assetType,
                    })];
            case 1:
                assetSchema = _c.sent();
                properties = (_b = assetSchema === null || assetSchema === void 0 ? void 0 : assetSchema.getProperties()) === null || _b === void 0 ? void 0 : _b.flatMap(function (p) {
                    var _a;
                    return (_a = p.properties) !== null && _a !== void 0 ? _a : p;
                });
                result = properties === null || properties === void 0 ? void 0 : properties.map(function (property) {
                    var p = property;
                    return {
                        name: p.id,
                        type: p.type,
                        precision: p.precision,
                        displayName: p.displayName,
                        units: p.units,
                    };
                });
                return [4 /*yield*/, (0, effects_1.put)((0, asset_actions_1.getAssetFieldsResolved)(result))];
            case 2:
                _c.sent();
                return [3 /*break*/, 5];
            case 3:
                e_1 = _c.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, asset_actions_1.getAssetFieldsRejected)())];
            case 4:
                _c.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function watchGetAssetFields() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(asset_actions_1.getAssetFields, getAssetFieldsSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function getAssetFilterListSaga() {
    var payload, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 1500, asset_services_1.getAssetFilterListApi)];
            case 1:
                payload = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, asset_actions_1.getAssetFilterListResolved)(payload.data))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_2 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, asset_actions_1.getAssetFilterListRejected)())];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function watchGetAssetFilterList() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.throttle)(5 * 1000, asset_actions_1.getAssetFilterList, getAssetFilterListSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function getSpatialLayerListSaga() {
    var payload, e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 5]);
                return [4 /*yield*/, (0, effects_1.retry)(5, 1500, Risk_services_1.getSpatialLayerListApi)];
            case 1:
                payload = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, asset_actions_1.getSpatialLayerListResolved)(payload.data))];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3:
                e_3 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, asset_actions_1.getSpatialLayerListRejected)())];
            case 4:
                _a.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}
function watchGetSpatialLayerList() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(asset_actions_1.getSpatialLayerList, getSpatialLayerListSaga)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
var sagaArray = [
    watchGetAssetFields(),
    watchGetAssetFilterList(),
    watchGetSpatialLayerList(),
];
exports["default"] = sagaArray;


/***/ }),

/***/ "./sagas/component.saga.ts":
/*!*********************************!*\
  !*** ./sagas/component.saga.ts ***!
  \*********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var effects_1 = __webpack_require__(/*! @redux-saga/core/effects */ "@redux-saga/core/effects");
var LoF_services_1 = __webpack_require__(/*! @Services/LoF/LoF.services */ "./services/LoF/LoF.services.ts");
var CoF_services_1 = __webpack_require__(/*! @Services/CoF/CoF.services */ "./services/CoF/CoF.services.ts");
var effects_2 = __webpack_require__(/*! redux-saga/effects */ "../node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var i18next_1 = __webpack_require__(/*! i18next */ "i18next");
var multiParamUniqueLimit = 30;
var singleParamUniqueLimit = 100;
function getLoFComponentInspectionMetadataSaga(action) {
    var response, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 9]);
                return [4 /*yield*/, (0, effects_2.retry)(5, 1500, LoF_services_1.getLoFComponentInspectionMetadataApi, action.payload.assetType, action.payload.field)];
            case 1:
                response = _a.sent();
                if (!response.data.unique) return [3 /*break*/, 4];
                if (!(response.data.unique.length >
                    (action.payload.multiParam
                        ? multiParamUniqueLimit
                        : singleParamUniqueLimit))) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Too many unique values for {{field}}', {
                        field: action.payload.fieldAlias,
                    })))];
            case 2:
                _a.sent();
                delete response.data.unique;
                return [3 /*break*/, 4];
            case 3:
                if (response.data.unique.length === 0)
                    delete response.data.unique;
                _a.label = 4;
            case 4: return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getComponentMetadataResolved)(response.data))];
            case 5:
                _a.sent();
                return [3 /*break*/, 9];
            case 6:
                e_1 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Scoring cannot be set due insufficient data for {{field}}', {
                        field: action.payload.fieldAlias,
                    })))];
            case 7:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getComponentMetadataRejected)())];
            case 8:
                _a.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function getLoFComponentAssetMetadataSaga(action) {
    var response, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 9]);
                return [4 /*yield*/, (0, effects_2.retry)(5, 1500, LoF_services_1.getLoFComponentAssetMetadataApi, action.payload.assetType, action.payload.field)];
            case 1:
                response = _a.sent();
                if (!response.data.unique) return [3 /*break*/, 4];
                if (!(response.data.unique.length >
                    (action.payload.multiParam
                        ? multiParamUniqueLimit
                        : singleParamUniqueLimit))) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Too many unique values for {{field}}', {
                        field: action.payload.fieldAlias,
                    })))];
            case 2:
                _a.sent();
                delete response.data.unique;
                return [3 /*break*/, 4];
            case 3:
                if (response.data.unique.length === 0)
                    delete response.data.unique;
                _a.label = 4;
            case 4: return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getComponentMetadataResolved)(response.data))];
            case 5:
                _a.sent();
                return [3 /*break*/, 9];
            case 6:
                e_2 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Scoring cannot be set due insufficient data for {{field}}', {
                        field: action.payload.fieldAlias,
                    })))];
            case 7:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getComponentMetadataRejected)())];
            case 8:
                _a.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function getCoFComponentAssetMetadataSaga(action) {
    var response, e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 9]);
                return [4 /*yield*/, (0, effects_2.retry)(5, 1500, CoF_services_1.getCoFComponentAssetMetadataApi, action.payload.assetType, action.payload.field)];
            case 1:
                response = _a.sent();
                if (!response.data.unique) return [3 /*break*/, 4];
                if (!(response.data.unique.length >
                    (action.payload.multiParam
                        ? multiParamUniqueLimit
                        : singleParamUniqueLimit))) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Too many unique values for {{field}}', {
                        field: action.payload.fieldAlias,
                    })))];
            case 2:
                _a.sent();
                delete response.data.unique;
                return [3 /*break*/, 4];
            case 3:
                if (response.data.unique.length === 0)
                    delete response.data.unique;
                _a.label = 4;
            case 4: return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getComponentMetadataResolved)(response.data))];
            case 5:
                _a.sent();
                return [3 /*break*/, 9];
            case 6:
                e_3 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Scoring cannot be set due insufficient data for {{field}}', {
                        field: action.payload.fieldAlias,
                    })))];
            case 7:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getComponentMetadataRejected)())];
            case 8:
                _a.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function getLoFComponentProximityMetadataSaga(action) {
    var response, e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 8]);
                return [4 /*yield*/, (0, effects_2.retry)(5, 1500, CoF_services_1.getCoFComponentProximityMetadataApi, action.payload)];
            case 1:
                response = _a.sent();
                if (!response.data.unique) return [3 /*break*/, 4];
                if (!(response.data.unique.length >
                    (action.payload.multiParam
                        ? multiParamUniqueLimit
                        : singleParamUniqueLimit))) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Too many unique values for {{field}}', {
                        field: action.payload.fieldAlias,
                    })))];
            case 2:
                _a.sent();
                delete response.data.unique;
                return [3 /*break*/, 4];
            case 3:
                if (response.data.unique.length === 0)
                    delete response.data.unique;
                _a.label = 4;
            case 4: return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getComponentMetadataResolved)(response.data))];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6:
                e_4 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getComponentMetadataRejected)())];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function getCoFComponentProximityMetadataSaga(action) {
    var response, e_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 8]);
                return [4 /*yield*/, (0, effects_2.retry)(5, 1500, CoF_services_1.getCoFComponentProximityMetadataApi, action.payload)];
            case 1:
                response = _a.sent();
                if (!response.data.unique) return [3 /*break*/, 4];
                if (!(response.data.unique.length >
                    (action.payload.multiParam
                        ? multiParamUniqueLimit
                        : singleParamUniqueLimit))) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Too many unique values for {{field}}', {
                        field: action.payload.fieldAlias,
                    })))];
            case 2:
                _a.sent();
                delete response.data.unique;
                return [3 /*break*/, 4];
            case 3:
                if (response.data.unique.length === 0)
                    delete response.data.unique;
                _a.label = 4;
            case 4: return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getComponentMetadataResolved)(response.data))];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6:
                e_5 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getComponentMetadataRejected)())];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function getLoFComponentProximityAttrMetadataSaga(action) {
    var response, e_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 8]);
                return [4 /*yield*/, (0, effects_2.retry)(5, 1500, LoF_services_1.getLoFComponentProximityAttrMetadataApi, action.payload.assetType, action.payload.field, action.payload.layerName)];
            case 1:
                response = _a.sent();
                if (!response.data.unique) return [3 /*break*/, 4];
                if (!(response.data.unique.length >
                    (action.payload.multiParam
                        ? multiParamUniqueLimit
                        : singleParamUniqueLimit))) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Too many unique values for {{field}}', {
                        field: action.payload.fieldAlias,
                    })))];
            case 2:
                _a.sent();
                delete response.data.unique;
                return [3 /*break*/, 4];
            case 3:
                if (response.data.unique.length === 0)
                    delete response.data.unique;
                _a.label = 4;
            case 4: return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getComponentMetadataResolved)(response.data))];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6:
                e_6 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getComponentMetadataRejected)())];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function getCoFComponentProximityAttrMetadataSaga(action) {
    var response, e_7;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 8]);
                return [4 /*yield*/, (0, effects_2.retry)(5, 1500, CoF_services_1.getCoFComponentProximityAttrMetadataApi, action.payload.assetType, action.payload.field, action.payload.layerName)];
            case 1:
                response = _a.sent();
                if (!response.data.unique) return [3 /*break*/, 4];
                if (!(response.data.unique.length >
                    (action.payload.multiParam
                        ? multiParamUniqueLimit
                        : singleParamUniqueLimit))) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Too many unique values for {{field}}', {
                        field: action.payload.fieldAlias,
                    })))];
            case 2:
                _a.sent();
                delete response.data.unique;
                return [3 /*break*/, 4];
            case 3:
                if (response.data.unique.length === 0)
                    delete response.data.unique;
                _a.label = 4;
            case 4: return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getComponentMetadataResolved)(response.data))];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6:
                e_7 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getComponentMetadataRejected)())];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function getLoFComponentCustomTableMetadataSaga(action) {
    var response, e_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 8]);
                return [4 /*yield*/, (0, effects_2.retry)(5, 1500, LoF_services_1.getLoFComponentCustomTableMetadataApi, action.payload.assetType, action.payload.field, action.payload.layerName)];
            case 1:
                response = _a.sent();
                if (!response.data.unique) return [3 /*break*/, 4];
                if (!(response.data.unique.length >
                    (action.payload.multiParam
                        ? multiParamUniqueLimit
                        : singleParamUniqueLimit))) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Too many unique values for {{field}}', {
                        field: action.payload.fieldAlias,
                    })))];
            case 2:
                _a.sent();
                delete response.data.unique;
                return [3 /*break*/, 4];
            case 3:
                if (response.data.unique.length === 0)
                    delete response.data.unique;
                _a.label = 4;
            case 4: return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getComponentMetadataResolved)(response.data))];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6:
                e_8 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getComponentMetadataRejected)())];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function getCoFComponentCustomTableMetadataSaga(action) {
    var response, e_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 8]);
                return [4 /*yield*/, (0, effects_2.retry)(5, 1500, CoF_services_1.getCoFComponentCustomTableMetadataApi, action.payload.assetType, action.payload.field, action.payload.layerName)];
            case 1:
                response = _a.sent();
                if (!response.data.unique) return [3 /*break*/, 4];
                if (!(response.data.unique.length >
                    (action.payload.multiParam
                        ? multiParamUniqueLimit
                        : singleParamUniqueLimit))) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Too many unique values for {{field}}', {
                        field: action.payload.fieldAlias,
                    })))];
            case 2:
                _a.sent();
                delete response.data.unique;
                return [3 /*break*/, 4];
            case 3:
                if (response.data.unique.length === 0)
                    delete response.data.unique;
                _a.label = 4;
            case 4: return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getComponentMetadataResolved)(response.data))];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6:
                e_9 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getComponentMetadataRejected)())];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function getLoFComponentTaskMetadataSaga(action) {
    var response, e_10;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 8]);
                return [4 /*yield*/, (0, effects_2.retry)(5, 1500, LoF_services_1.getLoFComponentTaskMetadataApi, action.payload.assetType, action.payload.field, action.payload.layerName)];
            case 1:
                response = _a.sent();
                if (!response.data.unique) return [3 /*break*/, 4];
                if (!(response.data.unique.length >
                    (action.payload.multiParam
                        ? multiParamUniqueLimit
                        : singleParamUniqueLimit))) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Too many unique values for {{field}}', {
                        field: action.payload.fieldAlias,
                    })))];
            case 2:
                _a.sent();
                delete response.data.unique;
                return [3 /*break*/, 4];
            case 3:
                if (response.data.unique.length === 0)
                    delete response.data.unique;
                _a.label = 4;
            case 4: return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getComponentMetadataResolved)(response.data))];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6:
                e_10 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getComponentMetadataRejected)())];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function getCoFComponentTaskMetadataSaga(action) {
    var response, e_11;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 8]);
                return [4 /*yield*/, (0, effects_2.retry)(5, 1500, CoF_services_1.getCoFComponentTaskMetadataApi, action.payload.assetType, action.payload.field, action.payload.layerName)];
            case 1:
                response = _a.sent();
                if (!response.data.unique) return [3 /*break*/, 4];
                if (!(response.data.unique.length >
                    (action.payload.multiParam
                        ? multiParamUniqueLimit
                        : singleParamUniqueLimit))) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, effects_1.put)((0, stylovyze_1.error)((0, i18next_1.t)('Too many unique values for {{field}}', {
                        field: action.payload.fieldAlias,
                    })))];
            case 2:
                _a.sent();
                delete response.data.unique;
                return [3 /*break*/, 4];
            case 3:
                if (response.data.unique.length === 0)
                    delete response.data.unique;
                _a.label = 4;
            case 4: return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getComponentMetadataResolved)(response.data))];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6:
                e_11 = _a.sent();
                return [4 /*yield*/, (0, effects_1.put)((0, _Actions_1.getComponentMetadataRejected)())];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function watchGetComponentMetadata() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.takeLatest)(_Actions_1.getLoFComponentInspectionMetadata, getLoFComponentInspectionMetadataSaga)];
            case 1:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(_Actions_1.getLoFComponentAssetMetadata, getLoFComponentAssetMetadataSaga)];
            case 2:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(_Actions_1.getCoFComponentAssetMetadata, getCoFComponentAssetMetadataSaga)];
            case 3:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(_Actions_1.getLoFComponentProximityMetadata, getLoFComponentProximityMetadataSaga)];
            case 4:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(_Actions_1.getCoFComponentProximityMetadata, getCoFComponentProximityMetadataSaga)];
            case 5:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(_Actions_1.getLoFComponentProximityAttrMetadata, getLoFComponentProximityAttrMetadataSaga)];
            case 6:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(_Actions_1.getCoFComponentProximityAttrMetadata, getCoFComponentProximityAttrMetadataSaga)];
            case 7:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(_Actions_1.getLoFComponentCustomTableMetadata, getLoFComponentCustomTableMetadataSaga)];
            case 8:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(_Actions_1.getCoFComponentCustomTableMetadata, getCoFComponentCustomTableMetadataSaga)];
            case 9:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(_Actions_1.getLoFComponentTaskMetadata, getLoFComponentTaskMetadataSaga)];
            case 10:
                _a.sent();
                return [4 /*yield*/, (0, effects_1.takeLatest)(_Actions_1.getCoFComponentTaskMetadata, getCoFComponentTaskMetadataSaga)];
            case 11:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
var sagaArray = [watchGetComponentMetadata()];
exports["default"] = sagaArray;


/***/ }),

/***/ "./sagas/index.ts":
/*!************************!*\
  !*** ./sagas/index.ts ***!
  \************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var effects_1 = __webpack_require__(/*! redux-saga/effects */ "../node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js");
var LoF_sagas_1 = __importDefault(__webpack_require__(/*! ./LoF.sagas */ "./sagas/LoF.sagas.ts"));
var CoF_sagas_1 = __importDefault(__webpack_require__(/*! ./CoF.sagas */ "./sagas/CoF.sagas.ts"));
var Risk_sagas_1 = __importDefault(__webpack_require__(/*! ./Risk.sagas */ "./sagas/Risk.sagas.ts"));
var asset_sagas_1 = __importDefault(__webpack_require__(/*! ./asset.sagas */ "./sagas/asset.sagas.ts"));
var component_saga_1 = __importDefault(__webpack_require__(/*! ./component.saga */ "./sagas/component.saga.ts"));
function rootSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, effects_1.all)(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], LoF_sagas_1.default, true), CoF_sagas_1.default, true), Risk_sagas_1.default, true), asset_sagas_1.default, true), component_saga_1.default, true))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
exports["default"] = rootSaga;


/***/ }),

/***/ "./selectors/CoF.selectors.ts":
/*!************************************!*\
  !*** ./selectors/CoF.selectors.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.selectMaxCoFValue = exports.selectorMaxCoFValue = exports.selectCoFComponentFields = exports.selectorCoFConfigChanged = exports.selectCofStore = exports.CoFComponentFieldsSelector = exports.CoFConfigChanged = exports.CoFStoreSelector = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var parseNamespace = function (state) { return state[config_store_1.moduleNamespace]; };
exports.CoFStoreSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.CoFConfig; });
exports.CoFConfigChanged = (0, toolkit_1.createSelector)(exports.CoFStoreSelector, function (cofStore) { return cofStore.isChanged; });
exports.CoFComponentFieldsSelector = (0, toolkit_1.createSelector)(exports.CoFStoreSelector, function (cofStore) { return cofStore.componentFields; });
var selectCofStore = function () { return (0, react_redux_1.useSelector)(exports.CoFStoreSelector); };
exports.selectCofStore = selectCofStore;
var selectorCoFConfigChanged = function () { return (0, react_redux_1.useSelector)(exports.CoFConfigChanged); };
exports.selectorCoFConfigChanged = selectorCoFConfigChanged;
var selectCoFComponentFields = function () {
    return (0, react_redux_1.useSelector)(exports.CoFComponentFieldsSelector);
};
exports.selectCoFComponentFields = selectCoFComponentFields;
exports.selectorMaxCoFValue = (0, toolkit_1.createSelector)(exports.CoFStoreSelector, function (cofStore) {
    var maxValue = 10;
    cofStore.categories.forEach(function (category) {
        category.components.forEach(function (component) {
            if (component.select) {
                if (component.type === _Types_1.ComponentType.MultiParam &&
                    component.scoreMatrix) {
                    component.scoreMatrix.forEach(function (data) {
                        if (data.score > maxValue)
                            maxValue = data.score;
                    });
                }
                else if (component.metadata) {
                    component.metadata.forEach(function (data) {
                        if (data.value > maxValue)
                            maxValue = data.value;
                    });
                }
            }
        });
    });
    return maxValue;
});
var selectMaxCoFValue = function () { return (0, react_redux_1.useSelector)(exports.selectorMaxCoFValue); };
exports.selectMaxCoFValue = selectMaxCoFValue;


/***/ }),

/***/ "./selectors/LoF.selectors.ts":
/*!************************************!*\
  !*** ./selectors/LoF.selectors.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.selectMaxLoFValue = exports.selectorMaxLoFValue = exports.selectLoFComponentFields = exports.selectLoFComponentInspectionFields = exports.selectorLoFConfigChanged = exports.selectLofConfig = exports.selectLofStore = exports.LoFComponentFieldsSelector = exports.LoFComponentInspectionFieldsSelector = exports.LoFConfigChanged = exports.LoFStoreSelector = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var parseNamespace = function (state) { return state[config_store_1.moduleNamespace]; };
exports.LoFStoreSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.LoFConfig; });
var LoFConfigSelector = (0, toolkit_1.createSelector)(exports.LoFStoreSelector, function (lofStore) { return lofStore.categories; });
exports.LoFConfigChanged = (0, toolkit_1.createSelector)(exports.LoFStoreSelector, function (lofStore) { return lofStore.isChanged; });
exports.LoFComponentInspectionFieldsSelector = (0, toolkit_1.createSelector)(exports.LoFStoreSelector, function (lofStore) { return lofStore.componentInspectionFields; });
exports.LoFComponentFieldsSelector = (0, toolkit_1.createSelector)(exports.LoFStoreSelector, function (lofStore) { return lofStore.componentFields; });
var selectLofStore = function () { return (0, react_redux_1.useSelector)(exports.LoFStoreSelector); };
exports.selectLofStore = selectLofStore;
var selectLofConfig = function () { return (0, react_redux_1.useSelector)(LoFConfigSelector); };
exports.selectLofConfig = selectLofConfig;
var selectorLoFConfigChanged = function () { return (0, react_redux_1.useSelector)(exports.LoFConfigChanged); };
exports.selectorLoFConfigChanged = selectorLoFConfigChanged;
var selectLoFComponentInspectionFields = function () {
    return (0, react_redux_1.useSelector)(exports.LoFComponentInspectionFieldsSelector);
};
exports.selectLoFComponentInspectionFields = selectLoFComponentInspectionFields;
var selectLoFComponentFields = function () {
    return (0, react_redux_1.useSelector)(exports.LoFComponentFieldsSelector);
};
exports.selectLoFComponentFields = selectLoFComponentFields;
exports.selectorMaxLoFValue = (0, toolkit_1.createSelector)(exports.LoFStoreSelector, function (lofStore) {
    var maxValue = 10;
    lofStore.categories.forEach(function (category) {
        category.components.forEach(function (component) {
            if (component.select) {
                if (component.type === _Types_1.ComponentType.MultiParam &&
                    component.scoreMatrix) {
                    component.scoreMatrix.forEach(function (data) {
                        if (data.score > maxValue)
                            maxValue = data.score;
                    });
                }
                else if (component.metadata) {
                    component.metadata.forEach(function (data) {
                        if (data.value > maxValue)
                            maxValue = data.value;
                    });
                }
            }
        });
    });
    return maxValue;
});
var selectMaxLoFValue = function () { return (0, react_redux_1.useSelector)(exports.selectorMaxLoFValue); };
exports.selectMaxLoFValue = selectMaxLoFValue;


/***/ }),

/***/ "./selectors/Risk.selectors.ts":
/*!*************************************!*\
  !*** ./selectors/Risk.selectors.ts ***!
  \*************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.selectRefreshMatrixGrid = exports.selectorRefreshMatrixGrid = exports.selectPreviewStatus = exports.selectRiskType = exports.selectUpdatedRiskMatrixGrid = exports.selectUpdatedRiskRanges = exports.selectOnlyGradesUpdated = exports.selectIsPreviewOnLoad = exports.selectIsPreviewLoading = exports.selectPreviewCancelled = exports.selectEnablePreview = exports.selectDidMatrixUpdate = exports.selectRiskMatrix = exports.selectRiskCount = exports.useSelectIsCountLoading = exports.selectorIsCountLoading = exports.selectRiskDetailsStatus = exports.selectRiskIsDeleting = exports.selectRiskIsSaving = exports.selectRiskConfigIsCreating = exports.selectRiskConfigNameError = exports.selectIsRiskSetupDirty = exports.selectRiskDetailsFilterProps = exports.selectRiskDetailsSearch = exports.selectSaveRunSettings = exports.selectRiskDetailsIsWaiting = exports.selectIsLoading = exports.selectRiskDetailsIsLoading = exports.selectRowsPerPage = exports.selectRiskDetailsPagination = exports.selectRiskDetailsTablePage = exports.selectRiskDetailsStartSearch = exports.selectRiskDetailsQueryObj = exports.selectRiskDetailsQuery = exports.selectRiskTab = exports.selectRiskSetting = exports.selectRiskConfig = exports.selectRiskStore = exports.selectRefreshList = exports.selectRunCompleteReload = exports.selectorRowsPerPage = exports.selectCanReload = exports.selectSelectedRiskRows = exports.selectSelectionGridRows = exports.riskDetailsQuerySelectorObj = exports.riskDetailsQuerySelector = exports.searchQuerySelector = exports.selectorRiskDetailsRows = exports.selectorRiskDetailsPagination = exports.RiskConfigSelector = void 0;
exports.useSelectCofCategories = exports.useSelectLofCategories = exports.selectOverallRisk = exports.selectorOverallRisk = exports.selectEditedCellsList = exports.selectorEditedCellsList = void 0;
/*eslint import/no-unresolved: [2, { ignore: ['\\.lib-am-common/Reducers$'] }]*/
var AM_COMMON = __importStar(__webpack_require__(/*! @innovyze/lib-am-common/Reducers */ "@innovyze/lib-am-common/Reducers"));
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var riskDetailsPagination_1 = __webpack_require__(/*! @Reducers/riskDetailsPagination */ "./reducers/riskDetailsPagination.ts");
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var parseNamespace = function (state) { return state[config_store_1.moduleNamespace]; };
var riskStoreSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.RiskStore; });
exports.RiskConfigSelector = (0, toolkit_1.createSelector)(riskStoreSelector, function (RiskStore) { return RiskStore.riskConfig; });
var RiskSettingSelector = (0, toolkit_1.createSelector)(riskStoreSelector, function (RiskStore) { return RiskStore.riskConfig.riskSetting; });
var RiskTabSelector = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.tab; });
var cofCategoriesSelector = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskConfig.COFCategories; });
var lofCategoriesSelector = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskConfig.LOFCategories; });
exports.selectorRiskDetailsPagination = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { var _a; return (_a = riskStore.riskDetails) === null || _a === void 0 ? void 0 : _a.pagination; });
exports.selectorRiskDetailsRows = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { var _a; return (_a = riskStore.riskDetails) === null || _a === void 0 ? void 0 : _a.rows; });
var selectorPaginationQuery = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskDetails.query; });
var selectorFilterQuery = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.dropdownFilters.query; });
var selectorIsRiskSetupDirty = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.isSetupDirty; });
exports.searchQuerySelector = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) {
    return riskStore.search.length
        ? "&search=".concat(encodeURIComponent(riskStore.search))
        : '';
});
exports.riskDetailsQuerySelector = (0, toolkit_1.createSelector)(riskStoreSelector, selectorPaginationQuery, selectorFilterQuery, exports.searchQuerySelector, function (riskStore, pag, filters, search) {
    var settings = riskStore.riskConfig.riskSetting;
    var riskDetails = riskStore.riskDetails;
    var q = pag;
    q = q.length
        ? q + "&configId=".concat(settings.configId)
        : "?configId=".concat(settings.configId);
    if (riskDetails.scanId) {
        q = q.length
            ? q + "&scanId=".concat(riskDetails.scanId)
            : "?scanId=".concat(riskDetails.scanId);
    }
    if (filters.length) {
        q += filters;
    }
    if (search.length) {
        q += search;
    }
    q = q + '&includeScores=true';
    return q;
});
exports.riskDetailsQuerySelectorObj = (0, toolkit_1.createSelector)(riskStoreSelector, selectorPaginationQuery, selectorFilterQuery, exports.searchQuerySelector, function (riskStore, pag, filters, search) {
    var _a, _b, _c, _d, _e;
    var settings = riskStore.riskConfig.riskSetting;
    var riskDetails = riskStore.riskDetails;
    var obj = {};
    if (pag === null || pag === void 0 ? void 0 : pag.length) {
        obj['sort'] = (_b = (_a = riskStore.riskDetails) === null || _a === void 0 ? void 0 : _a.pagination) === null || _b === void 0 ? void 0 : _b.sortKey;
        obj['sortDescending'] =
            (_e = (_d = (_c = riskStore.riskDetails) === null || _c === void 0 ? void 0 : _c.pagination) === null || _d === void 0 ? void 0 : _d.sortDescending) !== null && _e !== void 0 ? _e : false;
    }
    obj['configId'] = settings.configId;
    if (riskDetails.scanId) {
        obj['scanId'] = riskDetails.scanId;
    }
    if (filters.length) {
        obj['filters'] = riskStore.dropdownFilters.filters;
    }
    if (search.length) {
        obj['search'] = encodeURIComponent(riskStore.search);
    }
    obj['includeScores'] = true;
    return obj;
});
var riskDetailsStartSeachSelector = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.startSearch; });
var selectorRiskDetailsTablePage = (0, toolkit_1.createSelector)([exports.selectorRiskDetailsPagination, exports.selectorRiskDetailsRows], function (pagination, rows) { return ({
    pages: pagination.pages,
    page: pagination.page,
    cells: rows.map(function (r) { return (0, riskDetailsPagination_1.mapRowToCells)(r); }),
    rowIds: rows.map(function (r) { return (r === null || r === void 0 ? void 0 : r._id) || ''; }),
    sortKey: pagination.sortKey,
    sortDescending: pagination.sortDescending,
    total: pagination.total,
}); });
var selectorCanReload = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { var _a, _b; return ((_b = (_a = riskStore.riskDetails) === null || _a === void 0 ? void 0 : _a.pagination) === null || _b === void 0 ? void 0 : _b.total) > 0; });
var selectorRunCompleteReload = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.runCompleteReload; });
var selectorRiskDetailsSlice = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskDetails.pagination.slice; });
var selectorRiskDetailsIsLoading = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskDetails.isLoading; });
var selectorIsLoading = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.isLoading; });
var selectorRiskDetailsIsWaiting = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskDetails.isWaiting; });
var selectorSaveRunSettings = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.saveRun; });
var selectorRiskDetailsSearch = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.search; });
var selectorRiskConfigNameError = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskConfigNameError; });
var selectorRiskConfigIsCreating = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.isCreating; });
var selectorRiskConfigIsSaving = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.isSaving; });
var selectorRiskIsDeleting = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.isDeleting; });
var riskDetailsStatusSelector = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskDetails.status; });
var selectorRefreshList = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.refreshList; });
var RiskIsCountLoadingStoreSelector = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.isCountLoading; });
var RiskCountStoreSelector = (0, toolkit_1.createSelector)(riskStoreSelector, function (state) { return state.riskCount; });
var selectorFilterProps = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) {
    return Object.values(riskStore.dropdownFilters.selects);
});
var passInSelection = function (state, selectedItems) { return selectedItems; };
exports.selectSelectionGridRows = (0, toolkit_1.createSelector)([exports.selectorRiskDetailsRows, passInSelection], function (rows, selection) { return rows === null || rows === void 0 ? void 0 : rows.filter(function (_a) {
    var _id = _a._id;
    return selection.includes(_id);
}); });
exports.selectSelectedRiskRows = (0, toolkit_1.createSelector)([exports.selectSelectionGridRows], function (rows) {
    return rows.map(function (_a) {
        var _id = _a._id;
        return ({
            _id: _id,
        });
    });
});
var selectCanReload = function () { return (0, react_redux_1.useSelector)(selectorCanReload); };
exports.selectCanReload = selectCanReload;
var selectorRowsPerPage = function (dispatchSliceFn) {
    return (0, toolkit_1.createSelector)(selectorRiskDetailsSlice, function (slice) {
        return AM_COMMON.rowsPerPage(slice || 10, dispatchSliceFn);
    });
};
exports.selectorRowsPerPage = selectorRowsPerPage;
var selectRunCompleteReload = function () {
    return (0, react_redux_1.useSelector)(selectorRunCompleteReload);
};
exports.selectRunCompleteReload = selectRunCompleteReload;
var selectRefreshList = function () { return (0, react_redux_1.useSelector)(selectorRefreshList); };
exports.selectRefreshList = selectRefreshList;
var selectRiskStore = function () { return (0, react_redux_1.useSelector)(riskStoreSelector); };
exports.selectRiskStore = selectRiskStore;
var selectRiskConfig = function () { return (0, react_redux_1.useSelector)(exports.RiskConfigSelector); };
exports.selectRiskConfig = selectRiskConfig;
var selectRiskSetting = function () { return (0, react_redux_1.useSelector)(RiskSettingSelector); };
exports.selectRiskSetting = selectRiskSetting;
var selectRiskTab = function () { return (0, react_redux_1.useSelector)(RiskTabSelector); };
exports.selectRiskTab = selectRiskTab;
var selectRiskDetailsQuery = function () {
    return (0, react_redux_1.useSelector)(exports.riskDetailsQuerySelector);
};
exports.selectRiskDetailsQuery = selectRiskDetailsQuery;
var selectRiskDetailsQueryObj = function () {
    return (0, react_redux_1.useSelector)(exports.riskDetailsQuerySelectorObj);
};
exports.selectRiskDetailsQueryObj = selectRiskDetailsQueryObj;
var selectRiskDetailsStartSearch = function () {
    return (0, react_redux_1.useSelector)(riskDetailsStartSeachSelector);
};
exports.selectRiskDetailsStartSearch = selectRiskDetailsStartSearch;
var selectRiskDetailsTablePage = function () {
    return (0, react_redux_1.useSelector)(selectorRiskDetailsTablePage);
};
exports.selectRiskDetailsTablePage = selectRiskDetailsTablePage;
var selectRiskDetailsPagination = function () {
    return (0, react_redux_1.useSelector)(exports.selectorRiskDetailsPagination);
};
exports.selectRiskDetailsPagination = selectRiskDetailsPagination;
var selectRowsPerPage = function (dispatchSliceFn) {
    return (0, react_redux_1.useSelector)((0, exports.selectorRowsPerPage)(dispatchSliceFn));
};
exports.selectRowsPerPage = selectRowsPerPage;
var selectRiskDetailsIsLoading = function () {
    return (0, react_redux_1.useSelector)(selectorRiskDetailsIsLoading);
};
exports.selectRiskDetailsIsLoading = selectRiskDetailsIsLoading;
var selectIsLoading = function () { return (0, react_redux_1.useSelector)(selectorIsLoading); };
exports.selectIsLoading = selectIsLoading;
var selectRiskDetailsIsWaiting = function () {
    return (0, react_redux_1.useSelector)(selectorRiskDetailsIsWaiting);
};
exports.selectRiskDetailsIsWaiting = selectRiskDetailsIsWaiting;
var selectSaveRunSettings = function () { return (0, react_redux_1.useSelector)(selectorSaveRunSettings); };
exports.selectSaveRunSettings = selectSaveRunSettings;
var selectRiskDetailsSearch = function () {
    return (0, react_redux_1.useSelector)(selectorRiskDetailsSearch);
};
exports.selectRiskDetailsSearch = selectRiskDetailsSearch;
var selectRiskDetailsFilterProps = function () {
    return (0, react_redux_1.useSelector)(selectorFilterProps);
};
exports.selectRiskDetailsFilterProps = selectRiskDetailsFilterProps;
var selectIsRiskSetupDirty = function () {
    return (0, react_redux_1.useSelector)(selectorIsRiskSetupDirty);
};
exports.selectIsRiskSetupDirty = selectIsRiskSetupDirty;
var selectRiskConfigNameError = function () {
    return (0, react_redux_1.useSelector)(selectorRiskConfigNameError);
};
exports.selectRiskConfigNameError = selectRiskConfigNameError;
var selectRiskConfigIsCreating = function () {
    return (0, react_redux_1.useSelector)(selectorRiskConfigIsCreating);
};
exports.selectRiskConfigIsCreating = selectRiskConfigIsCreating;
var selectRiskIsSaving = function () { return (0, react_redux_1.useSelector)(selectorRiskConfigIsSaving); };
exports.selectRiskIsSaving = selectRiskIsSaving;
var selectRiskIsDeleting = function () { return (0, react_redux_1.useSelector)(selectorRiskIsDeleting); };
exports.selectRiskIsDeleting = selectRiskIsDeleting;
var selectRiskDetailsStatus = function () {
    return (0, react_redux_1.useSelector)(riskDetailsStatusSelector);
};
exports.selectRiskDetailsStatus = selectRiskDetailsStatus;
var selectorIsCountLoading = function (key) {
    return (0, toolkit_1.createSelector)(RiskIsCountLoadingStoreSelector, function (state) {
        return state.indexOf(key) !== -1;
    });
};
exports.selectorIsCountLoading = selectorIsCountLoading;
var useSelectIsCountLoading = function (key) {
    return (0, react_redux_1.useSelector)((0, exports.selectorIsCountLoading)(key));
};
exports.useSelectIsCountLoading = useSelectIsCountLoading;
var selectorRiskCount = function (key) {
    return (0, toolkit_1.createSelector)(RiskCountStoreSelector, function (state) {
        if (state) {
            return state[key];
        }
    });
};
var selectRiskCount = function (key) { return (0, react_redux_1.useSelector)(selectorRiskCount(key)); };
exports.selectRiskCount = selectRiskCount;
//=====risk matrix selectors
var selectorRiskMatrix = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskMatrix; });
var selectRiskMatrix = function () { return (0, react_redux_1.useSelector)(selectorRiskMatrix); };
exports.selectRiskMatrix = selectRiskMatrix;
var selectorDidMatrixUpdate = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.didMatrixUpdate; });
var selectDidMatrixUpdate = function () { return (0, react_redux_1.useSelector)(selectorDidMatrixUpdate); };
exports.selectDidMatrixUpdate = selectDidMatrixUpdate;
var selectorEnablePreview = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskType === 'matrix' && riskStore.enablePreview; });
var selectEnablePreview = function () { return (0, react_redux_1.useSelector)(selectorEnablePreview); };
exports.selectEnablePreview = selectEnablePreview;
var selectorPreviewCancelled = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskType === 'matrix' && riskStore.cancelPreview; });
var selectPreviewCancelled = function () {
    return (0, react_redux_1.useSelector)(selectorPreviewCancelled);
};
exports.selectPreviewCancelled = selectPreviewCancelled;
var selectorIsPreviewLoading = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskType === 'matrix' && riskStore.isPreviewLoading; });
var selectIsPreviewLoading = function () {
    return (0, react_redux_1.useSelector)(selectorIsPreviewLoading);
};
exports.selectIsPreviewLoading = selectIsPreviewLoading;
var selectorIsPreviewOnLoad = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.isPreviewOnLoad; });
var selectIsPreviewOnLoad = function () { return (0, react_redux_1.useSelector)(selectorIsPreviewOnLoad); };
exports.selectIsPreviewOnLoad = selectIsPreviewOnLoad;
var selectorOnlyGradesUpdated = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.isOnlyGradesUpdated; });
var selectOnlyGradesUpdated = function () {
    return (0, react_redux_1.useSelector)(selectorOnlyGradesUpdated);
};
exports.selectOnlyGradesUpdated = selectOnlyGradesUpdated;
var selectorUpdatedRiskRanges = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskMatrix.grades; });
var selectUpdatedRiskRanges = function () {
    return (0, react_redux_1.useSelector)(selectorUpdatedRiskRanges);
};
exports.selectUpdatedRiskRanges = selectUpdatedRiskRanges;
var selectorUpdatedRiskMatrixGrid = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskMatrix.grid; });
var selectUpdatedRiskMatrixGrid = function () {
    return (0, react_redux_1.useSelector)(selectorUpdatedRiskMatrixGrid);
};
exports.selectUpdatedRiskMatrixGrid = selectUpdatedRiskMatrixGrid;
var selectorRiskType = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskConfig.riskSetting.riskType; });
var selectRiskType = function () { return (0, react_redux_1.useSelector)(selectorRiskType); };
exports.selectRiskType = selectRiskType;
var selectorPreviewStatus = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.previewStatus; });
var selectPreviewStatus = function () { return (0, react_redux_1.useSelector)(selectorPreviewStatus); };
exports.selectPreviewStatus = selectPreviewStatus;
exports.selectorRefreshMatrixGrid = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.refreshMatrixGrid; });
var selectRefreshMatrixGrid = function () {
    return (0, react_redux_1.useSelector)(exports.selectorRefreshMatrixGrid);
};
exports.selectRefreshMatrixGrid = selectRefreshMatrixGrid;
exports.selectorEditedCellsList = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.editedCellsList; });
var selectEditedCellsList = function () { return (0, react_redux_1.useSelector)(exports.selectorEditedCellsList); };
exports.selectEditedCellsList = selectEditedCellsList;
exports.selectorOverallRisk = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.overallRisk; });
var selectOverallRisk = function () { return (0, react_redux_1.useSelector)(exports.selectorOverallRisk); };
exports.selectOverallRisk = selectOverallRisk;
var useSelectLofCategories = function () { return (0, react_redux_1.useSelector)(lofCategoriesSelector); };
exports.useSelectLofCategories = useSelectLofCategories;
var useSelectCofCategories = function () { return (0, react_redux_1.useSelector)(cofCategoriesSelector); };
exports.useSelectCofCategories = useSelectCofCategories;
///============


/***/ }),

/***/ "./selectors/asset.selectors.ts":
/*!**************************************!*\
  !*** ./selectors/asset.selectors.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.selectAssetStore = exports.assetStoreSelector = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var parseNamespace = function (state) { return state[config_store_1.moduleNamespace]; };
exports.assetStoreSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.assets; });
var selectAssetStore = function () { return (0, react_redux_1.useSelector)(exports.assetStoreSelector); };
exports.selectAssetStore = selectAssetStore;


/***/ }),

/***/ "./selectors/component.selectors.ts":
/*!******************************************!*\
  !*** ./selectors/component.selectors.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useComponentMetadataStore = exports.ComponentStoreSelector = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var parseNamespace = function (state) { return state[config_store_1.moduleNamespace]; };
exports.ComponentStoreSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state === null || state === void 0 ? void 0 : state.ComponentStore; });
var ComponentRangeMetadataStoreSelector = (0, toolkit_1.createSelector)(exports.ComponentStoreSelector, function (store) { return store; });
var useComponentMetadataStore = function () {
    return (0, react_redux_1.useSelector)(ComponentRangeMetadataStoreSelector);
};
exports.useComponentMetadataStore = useComponentMetadataStore;


/***/ }),

/***/ "./selectors/index.ts":
/*!****************************!*\
  !*** ./selectors/index.ts ***!
  \****************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./CoF.selectors */ "./selectors/CoF.selectors.ts"), exports);
__exportStar(__webpack_require__(/*! ./LoF.selectors */ "./selectors/LoF.selectors.ts"), exports);
__exportStar(__webpack_require__(/*! ./Risk.selectors */ "./selectors/Risk.selectors.ts"), exports);
__exportStar(__webpack_require__(/*! ./component.selectors */ "./selectors/component.selectors.ts"), exports);
__exportStar(__webpack_require__(/*! ./util.selectors */ "./selectors/util.selectors.ts"), exports);
__exportStar(__webpack_require__(/*! ./asset.selectors */ "./selectors/asset.selectors.ts"), exports);


/***/ }),

/***/ "./selectors/util.selectors.ts":
/*!*************************************!*\
  !*** ./selectors/util.selectors.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.selectDataGridState = exports.DataGridSateSelector = exports.selectRiskLastRun = exports.selectRiskRunning = exports.selectRiskStatus = exports.selectRiskNullScore = exports.selectRiskMultiScoreEditDataGrid = exports.selectRiskMultiScoreDataGrid = exports.selectRiskScoreDataGrid = exports.selectRiskScoreTable = exports.selectRiskUnitScores = exports.selectRiskEditScores = exports.selectRiskScores = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var parseNamespace = function (state) { return state[config_store_1.moduleNamespace]; };
var UtilStoreSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.util; });
var RiskScoresSelector = (0, toolkit_1.createSelector)(UtilStoreSelector, function (state) { return state.riskScores; });
var RiskScoresEditSelector = (0, toolkit_1.createSelector)(UtilStoreSelector, function (state) { return state.riskEditScores; });
var RiskUnitScoresSelector = (0, toolkit_1.createSelector)(UtilStoreSelector, function (state) { return state.riskUnitScores; });
var RiskScoreTableSelector = (0, toolkit_1.createSelector)(UtilStoreSelector, function (state) { return state.riskScoreTable; });
var RiskScoreDataGridSelector = (0, toolkit_1.createSelector)(UtilStoreSelector, function (state) { return state.riskScoreDataGrid; });
var RiskMultiScoreDataGridSelector = (0, toolkit_1.createSelector)(UtilStoreSelector, function (state) { return state.riskMultiScoreDataGrid; });
var RiskMultiScoreEditDataGridSelector = (0, toolkit_1.createSelector)(UtilStoreSelector, function (state) { return state.riskMultiScoreEditDataGrid; });
var RiskNullScoreSelector = (0, toolkit_1.createSelector)(UtilStoreSelector, function (state) { return state.riskNullScore; });
var RiskStatusSelector = (0, toolkit_1.createSelector)(UtilStoreSelector, function (state) { return state.riskStatus; });
var RiskRunningSelector = (0, toolkit_1.createSelector)(UtilStoreSelector, function (state) { return state.riskRunning; });
var RiskLastRunSelector = (0, toolkit_1.createSelector)(UtilStoreSelector, function (state) { return state.riskLastRun; });
var selectRiskScores = function () { return (0, react_redux_1.useSelector)(RiskScoresSelector); };
exports.selectRiskScores = selectRiskScores;
var selectRiskEditScores = function () { return (0, react_redux_1.useSelector)(RiskScoresEditSelector); };
exports.selectRiskEditScores = selectRiskEditScores;
var selectRiskUnitScores = function () { return (0, react_redux_1.useSelector)(RiskUnitScoresSelector); };
exports.selectRiskUnitScores = selectRiskUnitScores;
var selectRiskScoreTable = function () { return (0, react_redux_1.useSelector)(RiskScoreTableSelector); };
exports.selectRiskScoreTable = selectRiskScoreTable;
var selectRiskScoreDataGrid = function () {
    return (0, react_redux_1.useSelector)(RiskScoreDataGridSelector);
};
exports.selectRiskScoreDataGrid = selectRiskScoreDataGrid;
var selectRiskMultiScoreDataGrid = function () {
    return (0, react_redux_1.useSelector)(RiskMultiScoreDataGridSelector);
};
exports.selectRiskMultiScoreDataGrid = selectRiskMultiScoreDataGrid;
var selectRiskMultiScoreEditDataGrid = function () {
    return (0, react_redux_1.useSelector)(RiskMultiScoreEditDataGridSelector);
};
exports.selectRiskMultiScoreEditDataGrid = selectRiskMultiScoreEditDataGrid;
var selectRiskNullScore = function () { return (0, react_redux_1.useSelector)(RiskNullScoreSelector); };
exports.selectRiskNullScore = selectRiskNullScore;
var selectRiskStatus = function () { return (0, react_redux_1.useSelector)(RiskStatusSelector); };
exports.selectRiskStatus = selectRiskStatus;
var selectRiskRunning = function () { return (0, react_redux_1.useSelector)(RiskRunningSelector); };
exports.selectRiskRunning = selectRiskRunning;
var selectRiskLastRun = function () { return (0, react_redux_1.useSelector)(RiskLastRunSelector); };
exports.selectRiskLastRun = selectRiskLastRun;
exports.DataGridSateSelector = (0, toolkit_1.createSelector)(UtilStoreSelector, function (state) { return state.dataGridState; });
var selectorDataGridState = function (key) {
    return (0, toolkit_1.createSelector)(exports.DataGridSateSelector, function (state) {
        if (state) {
            return state[key];
        }
    });
};
var selectDataGridState = function (key) {
    return (0, react_redux_1.useSelector)(selectorDataGridState(key));
};
exports.selectDataGridState = selectDataGridState;
exports["default"] = exports.selectRiskScores;


/***/ }),

/***/ "./services/CoF/CoF.services.ts":
/*!**************************************!*\
  !*** ./services/CoF/CoF.services.ts ***!
  \**************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getCoFComponentTaskMetadataApi = exports.getCoFComponentCustomTableMetadataApi = exports.getCoFComponentProximityAttrMetadataApi = exports.getCoFComponentAssetMetadataApi = exports.getCustomTableFieldsApi = exports.getProximityAttributeFieldsApi = exports.getCoFComponentProximityMetadataApi = exports.getCoFFieldsApi = exports.saveCoFApi = exports.getCoFConfigApi = void 0;
var risks_api_1 = __importDefault(__webpack_require__(/*! @Apis/risks.api */ "./apis/risks.api.ts"));
var getCoFConfigApi = function () {
    var address = '/cof/config';
    return risks_api_1.default.get(address);
};
exports.getCoFConfigApi = getCoFConfigApi;
var saveCoFApi = function (config) {
    var address = '/cof/config';
    return risks_api_1.default.put(address, config);
};
exports.saveCoFApi = saveCoFApi;
var getCoFFieldsApi = function (assetType) {
    var address = "/risk/fields?assetType=".concat(assetType, "&fieldType=cof");
    return risks_api_1.default.get(address);
};
exports.getCoFFieldsApi = getCoFFieldsApi;
var getCoFComponentProximityMetadataApi = function (assetType) {
    var address = "/risk/fields?assetType=".concat(assetType, "&fieldType=}&fieldType=").concat(encodeURIComponent('cof/proximity'));
    return risks_api_1.default.get(address);
};
exports.getCoFComponentProximityMetadataApi = getCoFComponentProximityMetadataApi;
var getProximityAttributeFieldsApi = function (assetType) {
    var address = "/risk/fields?assetType=".concat(assetType, "&fieldType=proximityAttribute");
    return risks_api_1.default.get(address);
};
exports.getProximityAttributeFieldsApi = getProximityAttributeFieldsApi;
var getCustomTableFieldsApi = function (assetType) {
    var address = "/risk/fields?assetType=".concat(assetType, "&fieldType=customTable");
    return risks_api_1.default.get(address);
};
exports.getCustomTableFieldsApi = getCustomTableFieldsApi;
var getCoFComponentAssetMetadataApi = function (assetType, param) {
    var address = "/cof/field/score?assetType=".concat(assetType, "&fieldName=").concat(param);
    return risks_api_1.default.get(address);
};
exports.getCoFComponentAssetMetadataApi = getCoFComponentAssetMetadataApi;
var getCoFComponentProximityAttrMetadataApi = function (assetType, fieldName, layerName) {
    var address = "/cof/field/score?assetType=".concat(assetType, "&fieldName=").concat(fieldName, "&layerName=").concat(layerName);
    return risks_api_1.default.get(address);
};
exports.getCoFComponentProximityAttrMetadataApi = getCoFComponentProximityAttrMetadataApi;
var getCoFComponentCustomTableMetadataApi = function (assetType, fieldName, tableName) {
    var address = "/cof/field/score?assetType=".concat(assetType, "&fieldName=").concat(fieldName, "&tableName=").concat(tableName);
    return risks_api_1.default.get(address);
};
exports.getCoFComponentCustomTableMetadataApi = getCoFComponentCustomTableMetadataApi;
var getCoFComponentTaskMetadataApi = function (assetType, fieldName, tableName) {
    var address = "/cof/field/score?assetType=".concat(assetType, "&fieldName=").concat(fieldName, "&taskType=").concat(tableName);
    return risks_api_1.default.get(address);
};
exports.getCoFComponentTaskMetadataApi = getCoFComponentTaskMetadataApi;


/***/ }),

/***/ "./services/LoF/LoF.services.ts":
/*!**************************************!*\
  !*** ./services/LoF/LoF.services.ts ***!
  \**************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getLoFComponentTaskMetadataApi = exports.getLoFComponentCustomTableMetadataApi = exports.getLoFComponentProximityAttrMetadataApi = exports.getLoFComponentAssetMetadataApi = exports.getLoFComponentInspectionMetadataApi = exports.getLoFInspectionFieldsApi = exports.getLoFFieldsApi = exports.saveLoFApi = exports.getLoFConfigApi = void 0;
var risks_api_1 = __importDefault(__webpack_require__(/*! @Apis/risks.api */ "./apis/risks.api.ts"));
var getLoFConfigApi = function () {
    var address = '/lof/config';
    return risks_api_1.default.get(address);
};
exports.getLoFConfigApi = getLoFConfigApi;
var saveLoFApi = function (config) {
    var address = '/lof/config';
    return risks_api_1.default.put(address, config);
};
exports.saveLoFApi = saveLoFApi;
var getLoFFieldsApi = function (assetType) {
    var address = "/risk/fields?assetType=".concat(assetType, "&fieldType=lof");
    return risks_api_1.default.get(address);
};
exports.getLoFFieldsApi = getLoFFieldsApi;
var getLoFInspectionFieldsApi = function (_a) {
    var assetType = _a.assetType, inspectionStandard = _a.inspectionStandard;
    var address = "/risk/fields?assetType=".concat(assetType, "&fieldType=").concat(encodeURIComponent('lof/inspection'), "&inspectionStandard=").concat(inspectionStandard);
    return risks_api_1.default.get(address);
};
exports.getLoFInspectionFieldsApi = getLoFInspectionFieldsApi;
var getLoFComponentInspectionMetadataApi = function (assetType, param) {
    var address = "/lof/inspection/score?assetType=".concat(assetType, "&fieldName=").concat(param);
    return risks_api_1.default.get(address);
};
exports.getLoFComponentInspectionMetadataApi = getLoFComponentInspectionMetadataApi;
var getLoFComponentAssetMetadataApi = function (assetType, param) {
    var address = "/lof/field/score?assetType=".concat(assetType, "&fieldName=").concat(param);
    return risks_api_1.default.get(address);
};
exports.getLoFComponentAssetMetadataApi = getLoFComponentAssetMetadataApi;
var getLoFComponentProximityAttrMetadataApi = function (assetType, fieldName, layerName) {
    var address = "/lof/field/score?assetType=".concat(assetType, "&fieldName=").concat(fieldName, "&layerName=").concat(layerName);
    return risks_api_1.default.get(address);
};
exports.getLoFComponentProximityAttrMetadataApi = getLoFComponentProximityAttrMetadataApi;
var getLoFComponentCustomTableMetadataApi = function (assetType, fieldName, tableName) {
    var address = "/lof/field/score?assetType=".concat(assetType, "&fieldName=").concat(fieldName, "&tableName=").concat(tableName);
    return risks_api_1.default.get(address);
};
exports.getLoFComponentCustomTableMetadataApi = getLoFComponentCustomTableMetadataApi;
var getLoFComponentTaskMetadataApi = function (assetType, fieldName, tableName) {
    var address = "/lof/field/score?assetType=".concat(assetType, "&fieldName=").concat(fieldName, "&taskType=").concat(tableName);
    return risks_api_1.default.get(address);
};
exports.getLoFComponentTaskMetadataApi = getLoFComponentTaskMetadataApi;


/***/ }),

/***/ "./services/Risk/Risk.services.ts":
/*!****************************************!*\
  !*** ./services/Risk/Risk.services.ts ***!
  \****************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getRiskPreviewApi = exports.initRiskPreviewApi = exports.getRiskCountScoreMatrixApi = exports.getTaskDataApi = exports.getSimulationDataApi = exports.getRiskCountTaskApi = exports.getRiskCountCustomTableApi = exports.getRiskCountProximityAtributeApi = exports.getRiskCountProximityApi = exports.getRiskCountObservationApi = exports.getRiskCountAtributeApi = exports.getRiskCountInspectionApi = exports.changeRiskConfigPublishStateApi = exports.deleteRiskApi = exports.getSpatialLayerListApi = exports.getRiskCalcLogApi = exports.getRiskCalcStatusService = exports.getRiskDetailsApi = exports.resetRiskPreviewCalculationApi = exports.resetRiskCalculationApi = exports.startRiskCalculationApi = exports.duplicateRiskConfigApi = exports.saveRiskConfigApi = exports.createRiskConfigApi = exports.getRiskConfigApi = void 0;
var risks_api_1 = __importStar(__webpack_require__(/*! @Apis/risks.api */ "./apis/risks.api.ts"));
var i18next_1 = __webpack_require__(/*! i18next */ "i18next");
var lib_get_service_1 = __webpack_require__(/*! @innovyze/lib_get_service */ "@innovyze/lib_get_service");
var getRiskConfigApi = function (configId) {
    var address = "/risk/config?configId=".concat(configId);
    return risks_api_1.default.get(address);
};
exports.getRiskConfigApi = getRiskConfigApi;
var createRiskConfigApi = function (config) {
    var address = '/risk/config';
    return risks_api_1.default.post(address, config);
};
exports.createRiskConfigApi = createRiskConfigApi;
var saveRiskConfigApi = function (config) {
    var address = '/risk/config/version';
    return risks_api_1.default.post(address, config);
};
exports.saveRiskConfigApi = saveRiskConfigApi;
var duplicateRiskConfigApi = function (configId, config) {
    var address = "/risk/config/duplicate?configId=".concat(configId);
    return risks_api_1.default.post(address, config);
};
exports.duplicateRiskConfigApi = duplicateRiskConfigApi;
var startRiskCalculationApi = function (configId) {
    var address = "/risk/calc?configId=".concat(configId);
    return risks_api_1.default.post(address);
};
exports.startRiskCalculationApi = startRiskCalculationApi;
var resetRiskCalculationApi = function (configId) {
    var address = "/risk/calc/reset?configId=".concat(configId);
    return risks_api_1.default.put(address);
};
exports.resetRiskCalculationApi = resetRiskCalculationApi;
var resetRiskPreviewCalculationApi = function (configId) {
    var address = "/risk/calc/reset?configId=".concat(configId, "&isMatrixPreview=true");
    return risks_api_1.default.put(address);
};
exports.resetRiskPreviewCalculationApi = resetRiskPreviewCalculationApi;
var getRiskDetailsApi = function (query) {
    var address = '/risk/score';
    return risks_api_1.default.get("".concat(address).concat(query));
};
exports.getRiskDetailsApi = getRiskDetailsApi;
var RiskCalcStatusService = /** @class */ (function () {
    function RiskCalcStatusService(token, configId) {
        var _this = this;
        this.token = token;
        this.configId = configId;
        this.getHeaders = function () {
            var headers = {
                Authorization: "Bearer ".concat(_this.token),
                'Content-Type': 'application/json',
                Accept: 'application/json',
            };
            var tenantId = (0, lib_get_service_1.getTenantId)();
            if (tenantId)
                headers['X-Tenant-Id'] = tenantId;
            return headers;
        };
    }
    RiskCalcStatusService.prototype.getProcessStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch("".concat(risks_api_1.riskBaseUrl, "risk/calc/status?configId=").concat(this.configId), {
                            method: 'GET',
                            headers: this.getHeaders(),
                        })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: throw new Error((0, i18next_1.t)('Unable to get risk calculation status'));
                }
            });
        });
    };
    return RiskCalcStatusService;
}());
exports["default"] = RiskCalcStatusService;
var getRiskCalcStatusService = function (token, configId) {
    return new RiskCalcStatusService(token, configId);
};
exports.getRiskCalcStatusService = getRiskCalcStatusService;
var getRiskCalcLogApi = function (configId) {
    var address = "/risk/calc/log?configId=".concat(configId);
    return risks_api_1.default.get("".concat(address));
};
exports.getRiskCalcLogApi = getRiskCalcLogApi;
var getSpatialLayerListApi = function () {
    var address = '/spatial/layerlist';
    return risks_api_1.default.get(address);
};
exports.getSpatialLayerListApi = getSpatialLayerListApi;
var deleteRiskApi = function (id) {
    var address = "/risk/config?configId=".concat(id);
    return risks_api_1.default.delete(address);
};
exports.deleteRiskApi = deleteRiskApi;
var changeRiskConfigPublishStateApi = function (newPublishState, configId) {
    var address = "/risk/config/publish?configId=".concat(configId);
    return risks_api_1.default.put(address, { newPublishState: newPublishState });
};
exports.changeRiskConfigPublishStateApi = changeRiskConfigPublishStateApi;
var getRiskCountApi = function (assetType, assetFilterId, fieldType, metadata, metadataType, additionalParams) {
    var params = new URLSearchParams(__assign({ assetType: assetType, fieldType: fieldType }, additionalParams));
    if (assetFilterId) {
        params.append('assetFilterId', assetFilterId);
    }
    var address = "/risk/count?".concat(params.toString());
    return risks_api_1.default.post(address, {
        metadata: metadata,
        metadataType: metadataType,
    });
};
var getRiskCountInspectionApi = function (metadata, metadataType, assetType, assetFilterId, fieldName, inspectionType) {
    return getRiskCountApi(assetType, assetFilterId, 'inspection', metadata, metadataType, {
        fieldName: fieldName,
        inspectionType: inspectionType.toUpperCase(),
    });
};
exports.getRiskCountInspectionApi = getRiskCountInspectionApi;
var getRiskCountAtributeApi = function (metadata, metadataType, assetType, assetFilterId, fieldName) {
    return getRiskCountApi(assetType, assetFilterId, 'attribute', metadata, metadataType, {
        fieldName: fieldName,
    });
};
exports.getRiskCountAtributeApi = getRiskCountAtributeApi;
var getRiskCountObservationApi = function (metadata, metadataType, assetType, assetFilterId, fieldName) {
    fieldName = fieldName === 'Code' ? 'PACP_CODE' : fieldName;
    return getRiskCountApi(assetType, assetFilterId, 'observation', metadata, metadataType, {
        fieldName: fieldName,
    });
};
exports.getRiskCountObservationApi = getRiskCountObservationApi;
var getRiskCountProximityApi = function (metadata, metadataType, assetType, assetFilterId, layerName) {
    return getRiskCountApi(assetType, assetFilterId, 'proximity', metadata, metadataType, {
        layerName: layerName,
    });
};
exports.getRiskCountProximityApi = getRiskCountProximityApi;
var getRiskCountProximityAtributeApi = function (metadata, metadataType, assetType, assetFilterId, layerName, fieldName, valueType, distance) {
    return getRiskCountApi(assetType, assetFilterId, 'proximityAttribute', metadata, metadataType, {
        layerName: layerName,
        fieldName: fieldName,
        maxDistance: distance,
    });
};
exports.getRiskCountProximityAtributeApi = getRiskCountProximityAtributeApi;
var getRiskCountCustomTableApi = function (metadata, metadataType, assetType, assetFilterId, fieldName, tableName, valueType) {
    return getRiskCountApi(assetType, assetFilterId, 'customTable', metadata, metadataType, {
        fieldName: fieldName,
        tableName: tableName,
        valueType: valueType,
    });
};
exports.getRiskCountCustomTableApi = getRiskCountCustomTableApi;
var getRiskCountTaskApi = function (metadata, metadataType, assetType, assetFilterId, fieldName, tableName, valueType, uploadId) {
    var address = "/risk/count?assetType=".concat(assetType, "&assetFilterId=").concat(assetFilterId, "&fieldType=task&fieldName=").concat(fieldName, "&tableName=").concat(tableName, "&uploadId=").concat(uploadId, "&valueType=").concat(valueType);
    return risks_api_1.default.post(address, {
        metadata: metadata,
        metadataType: metadataType,
    });
};
exports.getRiskCountTaskApi = getRiskCountTaskApi;
var getSimulationDataApi = function () {
    return risks_api_1.default.get('/risk/simulations');
};
exports.getSimulationDataApi = getSimulationDataApi;
var getTaskDataApi = function (assetType) {
    return risks_api_1.default.get("/risk/tasks?assetType=".concat(assetType));
};
exports.getTaskDataApi = getTaskDataApi;
var getRiskCountScoreMatrixApi = function (components, scoreMatrix, assetType, assetFilterId, inspectionType) {
    var address = "/risk/count?assetType=".concat(assetType, "&fieldType=multiParam");
    if (assetFilterId)
        address += "&assetFilterId=".concat(assetFilterId);
    if (inspectionType)
        address += "&inspectionType=".concat(inspectionType.toUpperCase());
    return risks_api_1.default.post(address, {
        paramComponents: components,
        scoreMatrix: scoreMatrix,
    });
};
exports.getRiskCountScoreMatrixApi = getRiskCountScoreMatrixApi;
var initRiskPreviewApi = function (cofWeighting, lofWeighting, riskMethod, grades, grid, preview, configId) {
    var address = "/risk/calc?configId=".concat(configId, "&isMatrixPreview=true");
    return risks_api_1.default.post(address, {
        cofWeighting: cofWeighting,
        lofWeighting: lofWeighting,
        riskMethod: riskMethod,
        grades: grades,
        grid: grid,
        preview: preview,
    });
};
exports.initRiskPreviewApi = initRiskPreviewApi;
var getRiskPreviewApi = function (configId) {
    var address = "risk/preview/status?configId=".concat(configId);
    return risks_api_1.default.get(address);
};
exports.getRiskPreviewApi = getRiskPreviewApi;


/***/ }),

/***/ "./services/asset/asset.services.ts":
/*!******************************************!*\
  !*** ./services/asset/asset.services.ts ***!
  \******************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getAssetFilterApi = exports.getAssetFilterListApi = void 0;
var assets_api_1 = __importDefault(__webpack_require__(/*! @Apis/assets.api */ "./apis/assets.api.ts"));
var getAssetFilterListApi = function () {
    var $projection = '_id,name,assetType';
    var query = new URLSearchParams({ $projection: $projection });
    var address = "/assets-filter/?".concat(query.toString());
    return assets_api_1.default.get(address);
};
exports.getAssetFilterListApi = getAssetFilterListApi;
var getAssetFilterApi = function (id) {
    var address = "/assets-filter/".concat(id);
    return assets_api_1.default.get(address);
};
exports.getAssetFilterApi = getAssetFilterApi;


/***/ }),

/***/ "./store/config.store.ts":
/*!*******************************!*\
  !*** ./store/config.store.ts ***!
  \*******************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.routeNamespace = exports.moduleNamespace = void 0;
exports.moduleNamespace = 'appAmRisk';
exports.routeNamespace = '/risk';


/***/ }),

/***/ "./types/asset.types.ts":
/*!******************************!*\
  !*** ./types/asset.types.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/category.types.ts":
/*!*********************************!*\
  !*** ./types/category.types.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/cof.types.ts":
/*!****************************!*\
  !*** ./types/cof.types.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/component.types.ts":
/*!**********************************!*\
  !*** ./types/component.types.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getTypeDisplay = exports.ComponentType = void 0;
var ComponentType;
(function (ComponentType) {
    ComponentType["SpatialProximity"] = "Spatial Proximity";
    ComponentType["SpatialAttribute"] = "ProximityAttribute";
    ComponentType["CustomTable"] = "customTable";
    ComponentType["MultiParam"] = "multiParam";
    ComponentType["Attribute"] = "attribute";
    ComponentType["Simulation"] = "simulation";
    ComponentType["Task"] = "task";
    ComponentType["Observation"] = "observation";
})(ComponentType = exports.ComponentType || (exports.ComponentType = {}));
var getTypeDisplay = function (value, t) {
    switch (value) {
        case ComponentType.SpatialProximity:
            return t('Spatial Proximity');
        case ComponentType.SpatialAttribute:
            return t('Spatial Proximity -- Attribute');
        case ComponentType.CustomTable:
            return t('Custom Table');
        case ComponentType.Simulation:
            return t('Simulation');
        case ComponentType.Task:
            return t('Task');
        case ComponentType.MultiParam:
            return t('Multi Parameter');
        case ComponentType.Observation:
            return t('Observation');
        default:
            return t('Attribute');
    }
};
exports.getTypeDisplay = getTypeDisplay;


/***/ }),

/***/ "./types/export.types.ts":
/*!*******************************!*\
  !*** ./types/export.types.ts ***!
  \*******************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/index.ts":
/*!************************!*\
  !*** ./types/index.ts ***!
  \************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./store.types */ "./types/store.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./component.types */ "./types/component.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./lof.types */ "./types/lof.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./asset.types */ "./types/asset.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./scoreTableType */ "./types/scoreTableType.ts"), exports);
__exportStar(__webpack_require__(/*! ./scoreDataGridType */ "./types/scoreDataGridType.ts"), exports);
__exportStar(__webpack_require__(/*! ./cof.types */ "./types/cof.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./risk.types */ "./types/risk.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./category.types */ "./types/category.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./export.types */ "./types/export.types.ts"), exports);


/***/ }),

/***/ "./types/lof.types.ts":
/*!****************************!*\
  !*** ./types/lof.types.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/risk.types.ts":
/*!*****************************!*\
  !*** ./types/risk.types.ts ***!
  \*****************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/scoreDataGridType.ts":
/*!************************************!*\
  !*** ./types/scoreDataGridType.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/scoreTableType.ts":
/*!*********************************!*\
  !*** ./types/scoreTableType.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/store.types.ts":
/*!******************************!*\
  !*** ./types/store.types.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");


/***/ }),

/***/ "./utils/actions.ts":
/*!**************************!*\
  !*** ./utils/actions.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.addRouteNamespace = exports.addNamespace = void 0;
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var addNamespace = function (action) { return config_store_1.moduleNamespace + '/' + action; };
exports.addNamespace = addNamespace;
var addRouteNamespace = function (route) {
    return config_store_1.routeNamespace + '/' + route;
};
exports.addRouteNamespace = addRouteNamespace;


/***/ }),

/***/ "./utils/urlFormatting.ts":
/*!********************************!*\
  !*** ./utils/urlFormatting.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.formatUrlTrailing = void 0;
var formatUrlTrailing = function (url) {
    return url.match(/\/$/) ? url : url + '/';
};
exports.formatUrlTrailing = formatUrlTrailing;


/***/ }),

/***/ "@innovyze/lib-am-common/Actions":
/*!**************************************************!*\
  !*** external "@innovyze/lib-am-common/Actions" ***!
  \**************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_lib_am_common_Actions__;

/***/ }),

/***/ "@innovyze/lib-am-common/Reducers":
/*!***************************************************!*\
  !*** external "@innovyze/lib-am-common/Reducers" ***!
  \***************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_lib_am_common_Reducers__;

/***/ }),

/***/ "@innovyze/lib_asset_schema":
/*!*********************************************!*\
  !*** external "@innovyze/lib_asset_schema" ***!
  \*********************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_lib_asset_schema__;

/***/ }),

/***/ "@innovyze/lib_asset_schema_store":
/*!***************************************************!*\
  !*** external "@innovyze/lib_asset_schema_store" ***!
  \***************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_lib_asset_schema_store__;

/***/ }),

/***/ "@innovyze/lib_get_service":
/*!********************************************!*\
  !*** external "@innovyze/lib_get_service" ***!
  \********************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_lib_get_service__;

/***/ }),

/***/ "@redux-saga/core/effects":
/*!*******************************************!*\
  !*** external "@redux-saga/core/effects" ***!
  \*******************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__redux_saga_core_effects__;

/***/ }),

/***/ "@innovyze/stylovyze":
/*!**********************************************************************************************************************************************!*\
  !*** external {"commonjs":"@innovyze/stylovyze","commonjs2":"@innovyze/stylovyze","amd":"@Innovyze/Stylovyze","root":"@Innovyze/Stylovyze"} ***!
  \**********************************************************************************************************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_stylovyze__;

/***/ }),

/***/ "@reduxjs/toolkit":
/*!**********************************************************************************************************************************!*\
  !*** external {"commonjs":"@reduxjs/toolkit","commonjs2":"@reduxjs/toolkit","amd":"@Reduxjs/Toolkit","root":"@Reduxjs/Toolkit"} ***!
  \**********************************************************************************************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__reduxjs_toolkit__;

/***/ }),

/***/ "i18next":
/*!**********************************************************************************************!*\
  !*** external {"commonjs":"i18next","commonjs2":"i18next","amd":"I18next","root":"I18next"} ***!
  \**********************************************************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE_i18next__;

/***/ }),

/***/ "react-redux":
/*!************************************************************************************************************!*\
  !*** external {"commonjs":"react-redux","commonjs2":"react-redux","amd":"ReactRedux","root":"ReactRedux"} ***!
  \************************************************************************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE_react_redux__;

/***/ }),

/***/ "../node_modules/axios/dist/browser/axios.cjs":
/*!****************************************************!*\
  !*** ../node_modules/axios/dist/browser/axios.cjs ***!
  \****************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// Axios v1.7.9 Copyright (c) 2024 Matt Zabriskie and contributors


function bind(fn, thisArg) {
  return function wrap() {
    return fn.apply(thisArg, arguments);
  };
}

// utils is a library of generic helper functions non-specific to axios

const {toString} = Object.prototype;
const {getPrototypeOf} = Object;

const kindOf = (cache => thing => {
    const str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(Object.create(null));

const kindOfTest = (type) => {
  type = type.toLowerCase();
  return (thing) => kindOf(thing) === type
};

const typeOfTest = type => thing => typeof thing === type;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */
const {isArray} = Array;

/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */
const isUndefined = typeOfTest('undefined');

/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
const isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  let result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */
const isString = typeOfTest('string');

/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
const isFunction = typeOfTest('function');

/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */
const isNumber = typeOfTest('number');

/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */
const isObject = (thing) => thing !== null && typeof thing === 'object';

/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */
const isBoolean = thing => thing === true || thing === false;

/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */
const isPlainObject = (val) => {
  if (kindOf(val) !== 'object') {
    return false;
  }

  const prototype = getPrototypeOf(val);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};

/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */
const isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */
const isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */
const isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */
const isStream = (val) => isObject(val) && isFunction(val.pipe);

/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */
const isFormData = (thing) => {
  let kind;
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) || (
      isFunction(thing.append) && (
        (kind = kindOf(thing)) === 'formdata' ||
        // detect form-data instance
        (kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]')
      )
    )
  )
};

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
const isURLSearchParams = kindOfTest('URLSearchParams');

const [isReadableStream, isRequest, isResponse, isHeaders] = ['ReadableStream', 'Request', 'Response', 'Headers'].map(kindOfTest);

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */
const trim = (str) => str.trim ?
  str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */
function forEach(obj, fn, {allOwnKeys = false} = {}) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  let i;
  let l;

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys.length;
    let key;

    for (i = 0; i < len; i++) {
      key = keys[i];
      fn.call(null, obj[key], key, obj);
    }
  }
}

function findKey(obj, key) {
  key = key.toLowerCase();
  const keys = Object.keys(obj);
  let i = keys.length;
  let _key;
  while (i-- > 0) {
    _key = keys[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}

const _global = (() => {
  /*eslint no-undef:0*/
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : (typeof window !== 'undefined' ? window : __webpack_require__.g)
})();

const isContextDefined = (context) => !isUndefined(context) && context !== _global;

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  const {caseless} = isContextDefined(this) && this || {};
  const result = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result, key) || key;
    if (isPlainObject(result[targetKey]) && isPlainObject(val)) {
      result[targetKey] = merge(result[targetKey], val);
    } else if (isPlainObject(val)) {
      result[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result[targetKey] = val.slice();
    } else {
      result[targetKey] = val;
    }
  };

  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */
const extend = (a, b, thisArg, {allOwnKeys}= {}) => {
  forEach(b, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, {allOwnKeys});
  return a;
};

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
};

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */
const inherits = (constructor, superConstructor, props, descriptors) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, 'super', {
    value: superConstructor.prototype
  });
  props && Object.assign(constructor.prototype, props);
};

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */
const toFlatObject = (sourceObj, destObj, filter, propFilter) => {
  let props;
  let i;
  let prop;
  const merged = {};

  destObj = destObj || {};
  // eslint-disable-next-line no-eq-null,eqeqeq
  if (sourceObj == null) return destObj;

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = filter !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
};

/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
};


/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
};

/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */
// eslint-disable-next-line func-names
const isTypedArray = (TypedArray => {
  // eslint-disable-next-line func-names
  return thing => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));

/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */
const forEachEntry = (obj, fn) => {
  const generator = obj && obj[Symbol.iterator];

  const iterator = generator.call(obj);

  let result;

  while ((result = iterator.next()) && !result.done) {
    const pair = result.value;
    fn.call(obj, pair[0], pair[1]);
  }
};

/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */
const matchAll = (regExp, str) => {
  let matches;
  const arr = [];

  while ((matches = regExp.exec(str)) !== null) {
    arr.push(matches);
  }

  return arr;
};

/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */
const isHTMLForm = kindOfTest('HTMLFormElement');

const toCamelCase = str => {
  return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g,
    function replacer(m, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};

/* Creating a function that will check if an object has a property. */
const hasOwnProperty = (({hasOwnProperty}) => (obj, prop) => hasOwnProperty.call(obj, prop))(Object.prototype);

/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */
const isRegExp = kindOfTest('RegExp');

const reduceDescriptors = (obj, reducer) => {
  const descriptors = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};

  forEach(descriptors, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });

  Object.defineProperties(obj, reducedDescriptors);
};

/**
 * Makes all methods read-only
 * @param {Object} obj
 */

const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    // skip restricted props in strict mode
    if (isFunction(obj) && ['arguments', 'caller', 'callee'].indexOf(name) !== -1) {
      return false;
    }

    const value = obj[name];

    if (!isFunction(value)) return;

    descriptor.enumerable = false;

    if ('writable' in descriptor) {
      descriptor.writable = false;
      return;
    }

    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error('Can not rewrite read-only method \'' + name + '\'');
      };
    }
  });
};

const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};

  const define = (arr) => {
    arr.forEach(value => {
      obj[value] = true;
    });
  };

  isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));

  return obj;
};

const noop = () => {};

const toFiniteNumber = (value, defaultValue) => {
  return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};

const ALPHA = 'abcdefghijklmnopqrstuvwxyz';

const DIGIT = '0123456789';

const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
};

const generateString = (size = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = '';
  const {length} = alphabet;
  while (size--) {
    str += alphabet[Math.random() * length|0];
  }

  return str;
};

/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}

const toJSONObject = (obj) => {
  const stack = new Array(10);

  const visit = (source, i) => {

    if (isObject(source)) {
      if (stack.indexOf(source) >= 0) {
        return;
      }

      if(!('toJSON' in source)) {
        stack[i] = source;
        const target = isArray(source) ? [] : {};

        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });

        stack[i] = undefined;

        return target;
      }
    }

    return source;
  };

  return visit(obj, 0);
};

const isAsyncFn = kindOfTest('AsyncFunction');

const isThenable = (thing) =>
  thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);

// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34

const _setImmediate = ((setImmediateSupported, postMessageSupported) => {
  if (setImmediateSupported) {
    return setImmediate;
  }

  return postMessageSupported ? ((token, callbacks) => {
    _global.addEventListener("message", ({source, data}) => {
      if (source === _global && data === token) {
        callbacks.length && callbacks.shift()();
      }
    }, false);

    return (cb) => {
      callbacks.push(cb);
      _global.postMessage(token, "*");
    }
  })(`axios@${Math.random()}`, []) : (cb) => setTimeout(cb);
})(
  typeof setImmediate === 'function',
  isFunction(_global.postMessage)
);

const asap = typeof queueMicrotask !== 'undefined' ?
  queueMicrotask.bind(_global) : ( typeof process !== 'undefined' && process.nextTick || _setImmediate);

// *********************

var utils$1 = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject,
  isPlainObject,
  isReadableStream,
  isRequest,
  isResponse,
  isHeaders,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty, // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable,
  setImmediate: _setImmediate,
  asap
};

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = (new Error()).stack;
  }

  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  if (response) {
    this.response = response;
    this.status = response.status ? response.status : null;
  }
}

utils$1.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils$1.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});

const prototype$1 = AxiosError.prototype;
const descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED',
  'ERR_NOT_SUPPORT',
  'ERR_INVALID_URL'
// eslint-disable-next-line func-names
].forEach(code => {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype$1, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(prototype$1);

  utils$1.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  }, prop => {
    return prop !== 'isAxiosError';
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.cause = error;

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

// eslint-disable-next-line strict
var httpAdapter = null;

/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */
function isVisitable(thing) {
  return utils$1.isPlainObject(thing) || utils$1.isArray(thing);
}

/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */
function removeBrackets(key) {
  return utils$1.endsWith(key, '[]') ? key.slice(0, -2) : key;
}

/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    // eslint-disable-next-line no-param-reassign
    token = removeBrackets(token);
    return !dots && i ? '[' + token + ']' : token;
  }).join(dots ? '.' : '');
}

/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */
function isFlatArray(arr) {
  return utils$1.isArray(arr) && !arr.some(isVisitable);
}

const predicates = utils$1.toFlatObject(utils$1, {}, null, function filter(prop) {
  return /^is[A-Z]/.test(prop);
});

/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/

/**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */
function toFormData(obj, formData, options) {
  if (!utils$1.isObject(obj)) {
    throw new TypeError('target must be an object');
  }

  // eslint-disable-next-line no-param-reassign
  formData = formData || new (FormData)();

  // eslint-disable-next-line no-param-reassign
  options = utils$1.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option, source) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    return !utils$1.isUndefined(source[option]);
  });

  const metaTokens = options.metaTokens;
  // eslint-disable-next-line no-use-before-define
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
  const useBlob = _Blob && utils$1.isSpecCompliantForm(formData);

  if (!utils$1.isFunction(visitor)) {
    throw new TypeError('visitor must be a function');
  }

  function convertValue(value) {
    if (value === null) return '';

    if (utils$1.isDate(value)) {
      return value.toISOString();
    }

    if (!useBlob && utils$1.isBlob(value)) {
      throw new AxiosError('Blob is not supported. Use a Buffer instead.');
    }

    if (utils$1.isArrayBuffer(value) || utils$1.isTypedArray(value)) {
      return useBlob && typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */
  function defaultVisitor(value, key, path) {
    let arr = value;

    if (value && !path && typeof value === 'object') {
      if (utils$1.endsWith(key, '{}')) {
        // eslint-disable-next-line no-param-reassign
        key = metaTokens ? key : key.slice(0, -2);
        // eslint-disable-next-line no-param-reassign
        value = JSON.stringify(value);
      } else if (
        (utils$1.isArray(value) && isFlatArray(value)) ||
        ((utils$1.isFileList(value) || utils$1.endsWith(key, '[]')) && (arr = utils$1.toArray(value))
        )) {
        // eslint-disable-next-line no-param-reassign
        key = removeBrackets(key);

        arr.forEach(function each(el, index) {
          !(utils$1.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index, dots) : (indexes === null ? key : key + '[]'),
            convertValue(el)
          );
        });
        return false;
      }
    }

    if (isVisitable(value)) {
      return true;
    }

    formData.append(renderKey(path, key, dots), convertValue(value));

    return false;
  }

  const stack = [];

  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });

  function build(value, path) {
    if (utils$1.isUndefined(value)) return;

    if (stack.indexOf(value) !== -1) {
      throw Error('Circular reference detected in ' + path.join('.'));
    }

    stack.push(value);

    utils$1.forEach(value, function each(el, key) {
      const result = !(utils$1.isUndefined(el) || el === null) && visitor.call(
        formData, el, utils$1.isString(key) ? key.trim() : key, path, exposedHelpers
      );

      if (result === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });

    stack.pop();
  }

  if (!utils$1.isObject(obj)) {
    throw new TypeError('data must be an object');
  }

  build(obj);

  return formData;
}

/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */
function encode$1(str) {
  const charMap = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
    return charMap[match];
  });
}

/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */
function AxiosURLSearchParams(params, options) {
  this._pairs = [];

  params && toFormData(params, this, options);
}

const prototype = AxiosURLSearchParams.prototype;

prototype.append = function append(name, value) {
  this._pairs.push([name, value]);
};

prototype.toString = function toString(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode$1);
  } : encode$1;

  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + '=' + _encode(pair[1]);
  }, '').join('&');
};

/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */
function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @param {?(object|Function)} options
 *
 * @returns {string} The formatted url
 */
function buildURL(url, params, options) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  
  const _encode = options && options.encode || encode;

  if (utils$1.isFunction(options)) {
    options = {
      serialize: options
    };
  } 

  const serializeFn = options && options.serialize;

  let serializedParams;

  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils$1.isURLSearchParams(params) ?
      params.toString() :
      new AxiosURLSearchParams(params, options).toString(_encode);
  }

  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");

    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
}

class InterceptorManager {
  constructor() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }

  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn) {
    utils$1.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  }
}

var InterceptorManager$1 = InterceptorManager;

var transitionalDefaults = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};

var URLSearchParams$1 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : AxiosURLSearchParams;

var FormData$1 = typeof FormData !== 'undefined' ? FormData : null;

var Blob$1 = typeof Blob !== 'undefined' ? Blob : null;

var platform$1 = {
  isBrowser: true,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  protocols: ['http', 'https', 'file', 'blob', 'url', 'data']
};

const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';

const _navigator = typeof navigator === 'object' && navigator || undefined;

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */
const hasStandardBrowserEnv = hasBrowserEnv &&
  (!_navigator || ['ReactNative', 'NativeScript', 'NS'].indexOf(_navigator.product) < 0);

/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */
const hasStandardBrowserWebWorkerEnv = (() => {
  return (
    typeof WorkerGlobalScope !== 'undefined' &&
    // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope &&
    typeof self.importScripts === 'function'
  );
})();

const origin = hasBrowserEnv && window.location.href || 'http://localhost';

var utils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  hasBrowserEnv: hasBrowserEnv,
  hasStandardBrowserWebWorkerEnv: hasStandardBrowserWebWorkerEnv,
  hasStandardBrowserEnv: hasStandardBrowserEnv,
  navigator: _navigator,
  origin: origin
});

var platform = {
  ...utils,
  ...platform$1
};

function toURLEncodedForm(data, options) {
  return toFormData(data, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils$1.isBuffer(value)) {
        this.append(key, value.toString('base64'));
        return false;
      }

      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}

/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */
function parsePropPath(name) {
  // foo[x][y][z]
  // foo.x.y.z
  // foo-x-y-z
  // foo x y z
  return utils$1.matchAll(/\w+|\[(\w*)]/g, name).map(match => {
    return match[0] === '[]' ? '' : match[1] || match[0];
  });
}

/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */
function arrayToObject(arr) {
  const obj = {};
  const keys = Object.keys(arr);
  let i;
  const len = keys.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys[i];
    obj[key] = arr[key];
  }
  return obj;
}

/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */
function formDataToJSON(formData) {
  function buildPath(path, value, target, index) {
    let name = path[index++];

    if (name === '__proto__') return true;

    const isNumericKey = Number.isFinite(+name);
    const isLast = index >= path.length;
    name = !name && utils$1.isArray(target) ? target.length : name;

    if (isLast) {
      if (utils$1.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }

      return !isNumericKey;
    }

    if (!target[name] || !utils$1.isObject(target[name])) {
      target[name] = [];
    }

    const result = buildPath(path, value, target[name], index);

    if (result && utils$1.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }

    return !isNumericKey;
  }

  if (utils$1.isFormData(formData) && utils$1.isFunction(formData.entries)) {
    const obj = {};

    utils$1.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });

    return obj;
  }

  return null;
}

/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */
function stringifySafely(rawValue, parser, encoder) {
  if (utils$1.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$1.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

const defaults = {

  transitional: transitionalDefaults,

  adapter: ['xhr', 'http', 'fetch'],

  transformRequest: [function transformRequest(data, headers) {
    const contentType = headers.getContentType() || '';
    const hasJSONContentType = contentType.indexOf('application/json') > -1;
    const isObjectPayload = utils$1.isObject(data);

    if (isObjectPayload && utils$1.isHTMLForm(data)) {
      data = new FormData(data);
    }

    const isFormData = utils$1.isFormData(data);

    if (isFormData) {
      return hasJSONContentType ? JSON.stringify(formDataToJSON(data)) : data;
    }

    if (utils$1.isArrayBuffer(data) ||
      utils$1.isBuffer(data) ||
      utils$1.isStream(data) ||
      utils$1.isFile(data) ||
      utils$1.isBlob(data) ||
      utils$1.isReadableStream(data)
    ) {
      return data;
    }
    if (utils$1.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$1.isURLSearchParams(data)) {
      headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
      return data.toString();
    }

    let isFileList;

    if (isObjectPayload) {
      if (contentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return toURLEncodedForm(data, this.formSerializer).toString();
      }

      if ((isFileList = utils$1.isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
        const _FormData = this.env && this.env.FormData;

        return toFormData(
          isFileList ? {'files[]': data} : data,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }

    if (isObjectPayload || hasJSONContentType ) {
      headers.setContentType('application/json', false);
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    const transitional = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    const JSONRequested = this.responseType === 'json';

    if (utils$1.isResponse(data) || utils$1.isReadableStream(data)) {
      return data;
    }

    if (data && utils$1.isString(data) && ((forcedJSONParsing && !this.responseType) || JSONRequested)) {
      const silentJSONParsing = transitional && transitional.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;

      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': undefined
    }
  }
};

utils$1.forEach(['delete', 'get', 'head', 'post', 'put', 'patch'], (method) => {
  defaults.headers[method] = {};
});

var defaults$1 = defaults;

// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = utils$1.toObjectSet([
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
]);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */
var parseHeaders = rawHeaders => {
  const parsed = {};
  let key;
  let val;
  let i;

  rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
    i = line.indexOf(':');
    key = line.substring(0, i).trim().toLowerCase();
    val = line.substring(i + 1).trim();

    if (!key || (parsed[key] && ignoreDuplicateOf[key])) {
      return;
    }

    if (key === 'set-cookie') {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};

const $internals = Symbol('internals');

function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}

function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }

  return utils$1.isArray(value) ? value.map(normalizeValue) : String(value);
}

function parseTokens(str) {
  const tokens = Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match;

  while ((match = tokensRE.exec(str))) {
    tokens[match[1]] = match[2];
  }

  return tokens;
}

const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());

function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
  if (utils$1.isFunction(filter)) {
    return filter.call(this, value, header);
  }

  if (isHeaderNameFilter) {
    value = header;
  }

  if (!utils$1.isString(value)) return;

  if (utils$1.isString(filter)) {
    return value.indexOf(filter) !== -1;
  }

  if (utils$1.isRegExp(filter)) {
    return filter.test(value);
  }
}

function formatHeader(header) {
  return header.trim()
    .toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
      return char.toUpperCase() + str;
    });
}

function buildAccessors(obj, header) {
  const accessorName = utils$1.toCamelCase(' ' + header);

  ['get', 'set', 'has'].forEach(methodName => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}

class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }

  set(header, valueOrRewrite, rewrite) {
    const self = this;

    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);

      if (!lHeader) {
        throw new Error('header name must be a non-empty string');
      }

      const key = utils$1.findKey(self, lHeader);

      if(!key || self[key] === undefined || _rewrite === true || (_rewrite === undefined && self[key] !== false)) {
        self[key || _header] = normalizeValue(_value);
      }
    }

    const setHeaders = (headers, _rewrite) =>
      utils$1.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));

    if (utils$1.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite);
    } else if(utils$1.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else if (utils$1.isHeaders(header)) {
      for (const [key, value] of header.entries()) {
        setHeader(value, key, rewrite);
      }
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }

    return this;
  }

  get(header, parser) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils$1.findKey(this, header);

      if (key) {
        const value = this[key];

        if (!parser) {
          return value;
        }

        if (parser === true) {
          return parseTokens(value);
        }

        if (utils$1.isFunction(parser)) {
          return parser.call(this, value, key);
        }

        if (utils$1.isRegExp(parser)) {
          return parser.exec(value);
        }

        throw new TypeError('parser must be boolean|regexp|function');
      }
    }
  }

  has(header, matcher) {
    header = normalizeHeader(header);

    if (header) {
      const key = utils$1.findKey(this, header);

      return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
    }

    return false;
  }

  delete(header, matcher) {
    const self = this;
    let deleted = false;

    function deleteHeader(_header) {
      _header = normalizeHeader(_header);

      if (_header) {
        const key = utils$1.findKey(self, _header);

        if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
          delete self[key];

          deleted = true;
        }
      }
    }

    if (utils$1.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }

    return deleted;
  }

  clear(matcher) {
    const keys = Object.keys(this);
    let i = keys.length;
    let deleted = false;

    while (i--) {
      const key = keys[i];
      if(!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
        delete this[key];
        deleted = true;
      }
    }

    return deleted;
  }

  normalize(format) {
    const self = this;
    const headers = {};

    utils$1.forEach(this, (value, header) => {
      const key = utils$1.findKey(headers, header);

      if (key) {
        self[key] = normalizeValue(value);
        delete self[header];
        return;
      }

      const normalized = format ? formatHeader(header) : String(header).trim();

      if (normalized !== header) {
        delete self[header];
      }

      self[normalized] = normalizeValue(value);

      headers[normalized] = true;
    });

    return this;
  }

  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }

  toJSON(asStrings) {
    const obj = Object.create(null);

    utils$1.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils$1.isArray(value) ? value.join(', ') : value);
    });

    return obj;
  }

  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }

  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ': ' + value).join('\n');
  }

  get [Symbol.toStringTag]() {
    return 'AxiosHeaders';
  }

  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }

  static concat(first, ...targets) {
    const computed = new this(first);

    targets.forEach((target) => computed.set(target));

    return computed;
  }

  static accessor(header) {
    const internals = this[$internals] = (this[$internals] = {
      accessors: {}
    });

    const accessors = internals.accessors;
    const prototype = this.prototype;

    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);

      if (!accessors[lHeader]) {
        buildAccessors(prototype, _header);
        accessors[lHeader] = true;
      }
    }

    utils$1.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);

    return this;
  }
}

AxiosHeaders.accessor(['Content-Type', 'Content-Length', 'Accept', 'Accept-Encoding', 'User-Agent', 'Authorization']);

// reserved names hotfix
utils$1.reduceDescriptors(AxiosHeaders.prototype, ({value}, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  }
});

utils$1.freezeMethods(AxiosHeaders);

var AxiosHeaders$1 = AxiosHeaders;

/**
 * Transform the data for a request or a response
 *
 * @param {Array|Function} fns A single function or Array of functions
 * @param {?Object} response The response object
 *
 * @returns {*} The resulting transformed data
 */
function transformData(fns, response) {
  const config = this || defaults$1;
  const context = response || config;
  const headers = AxiosHeaders$1.from(context.headers);
  let data = context.data;

  utils$1.forEach(fns, function transform(fn) {
    data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
  });

  headers.normalize();

  return data;
}

function isCancel(value) {
  return !!(value && value.__CANCEL__);
}

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */
function CanceledError(message, config, request) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED, config, request);
  this.name = 'CanceledError';
}

utils$1.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 *
 * @returns {object} The response.
 */
function settle(resolve, reject, response) {
  const validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}

function parseProtocol(url) {
  const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
}

/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */
function speedometer(samplesCount, min) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail = 0;
  let firstSampleTS;

  min = min !== undefined ? min : 1000;

  return function push(chunkLength) {
    const now = Date.now();

    const startedAt = timestamps[tail];

    if (!firstSampleTS) {
      firstSampleTS = now;
    }

    bytes[head] = chunkLength;
    timestamps[head] = now;

    let i = tail;
    let bytesCount = 0;

    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }

    head = (head + 1) % samplesCount;

    if (head === tail) {
      tail = (tail + 1) % samplesCount;
    }

    if (now - firstSampleTS < min) {
      return;
    }

    const passed = startedAt && now - startedAt;

    return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
  };
}

/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */
function throttle(fn, freq) {
  let timestamp = 0;
  let threshold = 1000 / freq;
  let lastArgs;
  let timer;

  const invoke = (args, now = Date.now()) => {
    timestamp = now;
    lastArgs = null;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    fn.apply(null, args);
  };

  const throttled = (...args) => {
    const now = Date.now();
    const passed = now - timestamp;
    if ( passed >= threshold) {
      invoke(args, now);
    } else {
      lastArgs = args;
      if (!timer) {
        timer = setTimeout(() => {
          timer = null;
          invoke(lastArgs);
        }, threshold - passed);
      }
    }
  };

  const flush = () => lastArgs && invoke(lastArgs);

  return [throttled, flush];
}

const progressEventReducer = (listener, isDownloadStream, freq = 3) => {
  let bytesNotified = 0;
  const _speedometer = speedometer(50, 250);

  return throttle(e => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : undefined;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;

    bytesNotified = loaded;

    const data = {
      loaded,
      total,
      progress: total ? (loaded / total) : undefined,
      bytes: progressBytes,
      rate: rate ? rate : undefined,
      estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
      event: e,
      lengthComputable: total != null,
      [isDownloadStream ? 'download' : 'upload']: true
    };

    listener(data);
  }, freq);
};

const progressEventDecorator = (total, throttled) => {
  const lengthComputable = total != null;

  return [(loaded) => throttled[0]({
    lengthComputable,
    total,
    loaded
  }), throttled[1]];
};

const asyncDecorator = (fn) => (...args) => utils$1.asap(() => fn(...args));

var isURLSameOrigin = platform.hasStandardBrowserEnv ? ((origin, isMSIE) => (url) => {
  url = new URL(url, platform.origin);

  return (
    origin.protocol === url.protocol &&
    origin.host === url.host &&
    (isMSIE || origin.port === url.port)
  );
})(
  new URL(platform.origin),
  platform.navigator && /(msie|trident)/i.test(platform.navigator.userAgent)
) : () => true;

var cookies = platform.hasStandardBrowserEnv ?

  // Standard browser envs support document.cookie
  {
    write(name, value, expires, path, domain, secure) {
      const cookie = [name + '=' + encodeURIComponent(value)];

      utils$1.isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());

      utils$1.isString(path) && cookie.push('path=' + path);

      utils$1.isString(domain) && cookie.push('domain=' + domain);

      secure === true && cookie.push('secure');

      document.cookie = cookie.join('; ');
    },

    read(name) {
      const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return (match ? decodeURIComponent(match[3]) : null);
    },

    remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  }

  :

  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {},
    read() {
      return null;
    },
    remove() {}
  };

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 *
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 *
 * @returns {string} The combined URL
 */
function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
}

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 *
 * @returns {string} The combined full path
 */
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}

const headersToObject = (thing) => thing instanceof AxiosHeaders$1 ? { ...thing } : thing;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 *
 * @returns {Object} New object resulting from merging config2 to config1
 */
function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  const config = {};

  function getMergedValue(target, source, prop, caseless) {
    if (utils$1.isPlainObject(target) && utils$1.isPlainObject(source)) {
      return utils$1.merge.call({caseless}, target, source);
    } else if (utils$1.isPlainObject(source)) {
      return utils$1.merge({}, source);
    } else if (utils$1.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(a, b, prop , caseless) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(a, b, prop , caseless);
    } else if (!utils$1.isUndefined(a)) {
      return getMergedValue(undefined, a, prop , caseless);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(a, b) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(undefined, b);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(a, b) {
    if (!utils$1.isUndefined(b)) {
      return getMergedValue(undefined, b);
    } else if (!utils$1.isUndefined(a)) {
      return getMergedValue(undefined, a);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(a, b, prop) {
    if (prop in config2) {
      return getMergedValue(a, b);
    } else if (prop in config1) {
      return getMergedValue(undefined, a);
    }
  }

  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b , prop) => mergeDeepProperties(headersToObject(a), headersToObject(b),prop, true)
  };

  utils$1.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
    const merge = mergeMap[prop] || mergeDeepProperties;
    const configValue = merge(config1[prop], config2[prop], prop);
    (utils$1.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
}

var resolveConfig = (config) => {
  const newConfig = mergeConfig({}, config);

  let {data, withXSRFToken, xsrfHeaderName, xsrfCookieName, headers, auth} = newConfig;

  newConfig.headers = headers = AxiosHeaders$1.from(headers);

  newConfig.url = buildURL(buildFullPath(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);

  // HTTP basic authentication
  if (auth) {
    headers.set('Authorization', 'Basic ' +
      btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : ''))
    );
  }

  let contentType;

  if (utils$1.isFormData(data)) {
    if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
      headers.setContentType(undefined); // Let the browser set it
    } else if ((contentType = headers.getContentType()) !== false) {
      // fix semicolon duplication issue for ReactNative FormData implementation
      const [type, ...tokens] = contentType ? contentType.split(';').map(token => token.trim()).filter(Boolean) : [];
      headers.setContentType([type || 'multipart/form-data', ...tokens].join('; '));
    }
  }

  // Add xsrf header
  // This is only done if running in a standard browser environment.
  // Specifically not if we're in a web worker, or react-native.

  if (platform.hasStandardBrowserEnv) {
    withXSRFToken && utils$1.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));

    if (withXSRFToken || (withXSRFToken !== false && isURLSameOrigin(newConfig.url))) {
      // Add xsrf header
      const xsrfValue = xsrfHeaderName && xsrfCookieName && cookies.read(xsrfCookieName);

      if (xsrfValue) {
        headers.set(xsrfHeaderName, xsrfValue);
      }
    }
  }

  return newConfig;
};

const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';

var xhrAdapter = isXHRAdapterSupported && function (config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    const _config = resolveConfig(config);
    let requestData = _config.data;
    const requestHeaders = AxiosHeaders$1.from(_config.headers).normalize();
    let {responseType, onUploadProgress, onDownloadProgress} = _config;
    let onCanceled;
    let uploadThrottled, downloadThrottled;
    let flushUpload, flushDownload;

    function done() {
      flushUpload && flushUpload(); // flush events
      flushDownload && flushDownload(); // flush events

      _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);

      _config.signal && _config.signal.removeEventListener('abort', onCanceled);
    }

    let request = new XMLHttpRequest();

    request.open(_config.method.toUpperCase(), _config.url, true);

    // Set the request timeout in MS
    request.timeout = _config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      const responseHeaders = AxiosHeaders$1.from(
        'getAllResponseHeaders' in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === 'text' || responseType === 'json' ?
        request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
      const transitional = _config.transitional || transitionalDefaults;
      if (_config.timeoutErrorMessage) {
        timeoutErrorMessage = _config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Remove Content-Type if data is undefined
    requestData === undefined && requestHeaders.setContentType(null);

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils$1.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }

    // Add withCredentials to request if needed
    if (!utils$1.isUndefined(_config.withCredentials)) {
      request.withCredentials = !!_config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = _config.responseType;
    }

    // Handle progress if needed
    if (onDownloadProgress) {
      ([downloadThrottled, flushDownload] = progressEventReducer(onDownloadProgress, true));
      request.addEventListener('progress', downloadThrottled);
    }

    // Not all browsers support upload events
    if (onUploadProgress && request.upload) {
      ([uploadThrottled, flushUpload] = progressEventReducer(onUploadProgress));

      request.upload.addEventListener('progress', uploadThrottled);

      request.upload.addEventListener('loadend', flushUpload);
    }

    if (_config.cancelToken || _config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = cancel => {
        if (!request) {
          return;
        }
        reject(!cancel || cancel.type ? new CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };

      _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
      if (_config.signal) {
        _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
      }
    }

    const protocol = parseProtocol(_config.url);

    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData || null);
  });
};

const composeSignals = (signals, timeout) => {
  const {length} = (signals = signals ? signals.filter(Boolean) : []);

  if (timeout || length) {
    let controller = new AbortController();

    let aborted;

    const onabort = function (reason) {
      if (!aborted) {
        aborted = true;
        unsubscribe();
        const err = reason instanceof Error ? reason : this.reason;
        controller.abort(err instanceof AxiosError ? err : new CanceledError(err instanceof Error ? err.message : err));
      }
    };

    let timer = timeout && setTimeout(() => {
      timer = null;
      onabort(new AxiosError(`timeout ${timeout} of ms exceeded`, AxiosError.ETIMEDOUT));
    }, timeout);

    const unsubscribe = () => {
      if (signals) {
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach(signal => {
          signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
        });
        signals = null;
      }
    };

    signals.forEach((signal) => signal.addEventListener('abort', onabort));

    const {signal} = controller;

    signal.unsubscribe = () => utils$1.asap(unsubscribe);

    return signal;
  }
};

var composeSignals$1 = composeSignals;

const streamChunk = function* (chunk, chunkSize) {
  let len = chunk.byteLength;

  if (!chunkSize || len < chunkSize) {
    yield chunk;
    return;
  }

  let pos = 0;
  let end;

  while (pos < len) {
    end = pos + chunkSize;
    yield chunk.slice(pos, end);
    pos = end;
  }
};

const readBytes = async function* (iterable, chunkSize) {
  for await (const chunk of readStream(iterable)) {
    yield* streamChunk(chunk, chunkSize);
  }
};

const readStream = async function* (stream) {
  if (stream[Symbol.asyncIterator]) {
    yield* stream;
    return;
  }

  const reader = stream.getReader();
  try {
    for (;;) {
      const {done, value} = await reader.read();
      if (done) {
        break;
      }
      yield value;
    }
  } finally {
    await reader.cancel();
  }
};

const trackStream = (stream, chunkSize, onProgress, onFinish) => {
  const iterator = readBytes(stream, chunkSize);

  let bytes = 0;
  let done;
  let _onFinish = (e) => {
    if (!done) {
      done = true;
      onFinish && onFinish(e);
    }
  };

  return new ReadableStream({
    async pull(controller) {
      try {
        const {done, value} = await iterator.next();

        if (done) {
         _onFinish();
          controller.close();
          return;
        }

        let len = value.byteLength;
        if (onProgress) {
          let loadedBytes = bytes += len;
          onProgress(loadedBytes);
        }
        controller.enqueue(new Uint8Array(value));
      } catch (err) {
        _onFinish(err);
        throw err;
      }
    },
    cancel(reason) {
      _onFinish(reason);
      return iterator.return();
    }
  }, {
    highWaterMark: 2
  })
};

const isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const isReadableStreamSupported = isFetchSupported && typeof ReadableStream === 'function';

// used only inside the fetch adapter
const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ?
    ((encoder) => (str) => encoder.encode(str))(new TextEncoder()) :
    async (str) => new Uint8Array(await new Response(str).arrayBuffer())
);

const test = (fn, ...args) => {
  try {
    return !!fn(...args);
  } catch (e) {
    return false
  }
};

const supportsRequestStream = isReadableStreamSupported && test(() => {
  let duplexAccessed = false;

  const hasContentType = new Request(platform.origin, {
    body: new ReadableStream(),
    method: 'POST',
    get duplex() {
      duplexAccessed = true;
      return 'half';
    },
  }).headers.has('Content-Type');

  return duplexAccessed && !hasContentType;
});

const DEFAULT_CHUNK_SIZE = 64 * 1024;

const supportsResponseStream = isReadableStreamSupported &&
  test(() => utils$1.isReadableStream(new Response('').body));


const resolvers = {
  stream: supportsResponseStream && ((res) => res.body)
};

isFetchSupported && (((res) => {
  ['text', 'arrayBuffer', 'blob', 'formData', 'stream'].forEach(type => {
    !resolvers[type] && (resolvers[type] = utils$1.isFunction(res[type]) ? (res) => res[type]() :
      (_, config) => {
        throw new AxiosError(`Response type '${type}' is not supported`, AxiosError.ERR_NOT_SUPPORT, config);
      });
  });
})(new Response));

const getBodyLength = async (body) => {
  if (body == null) {
    return 0;
  }

  if(utils$1.isBlob(body)) {
    return body.size;
  }

  if(utils$1.isSpecCompliantForm(body)) {
    const _request = new Request(platform.origin, {
      method: 'POST',
      body,
    });
    return (await _request.arrayBuffer()).byteLength;
  }

  if(utils$1.isArrayBufferView(body) || utils$1.isArrayBuffer(body)) {
    return body.byteLength;
  }

  if(utils$1.isURLSearchParams(body)) {
    body = body + '';
  }

  if(utils$1.isString(body)) {
    return (await encodeText(body)).byteLength;
  }
};

const resolveBodyLength = async (headers, body) => {
  const length = utils$1.toFiniteNumber(headers.getContentLength());

  return length == null ? getBodyLength(body) : length;
};

var fetchAdapter = isFetchSupported && (async (config) => {
  let {
    url,
    method,
    data,
    signal,
    cancelToken,
    timeout,
    onDownloadProgress,
    onUploadProgress,
    responseType,
    headers,
    withCredentials = 'same-origin',
    fetchOptions
  } = resolveConfig(config);

  responseType = responseType ? (responseType + '').toLowerCase() : 'text';

  let composedSignal = composeSignals$1([signal, cancelToken && cancelToken.toAbortSignal()], timeout);

  let request;

  const unsubscribe = composedSignal && composedSignal.unsubscribe && (() => {
      composedSignal.unsubscribe();
  });

  let requestContentLength;

  try {
    if (
      onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' &&
      (requestContentLength = await resolveBodyLength(headers, data)) !== 0
    ) {
      let _request = new Request(url, {
        method: 'POST',
        body: data,
        duplex: "half"
      });

      let contentTypeHeader;

      if (utils$1.isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) {
        headers.setContentType(contentTypeHeader);
      }

      if (_request.body) {
        const [onProgress, flush] = progressEventDecorator(
          requestContentLength,
          progressEventReducer(asyncDecorator(onUploadProgress))
        );

        data = trackStream(_request.body, DEFAULT_CHUNK_SIZE, onProgress, flush);
      }
    }

    if (!utils$1.isString(withCredentials)) {
      withCredentials = withCredentials ? 'include' : 'omit';
    }

    // Cloudflare Workers throws when credentials are defined
    // see https://github.com/cloudflare/workerd/issues/902
    const isCredentialsSupported = "credentials" in Request.prototype;
    request = new Request(url, {
      ...fetchOptions,
      signal: composedSignal,
      method: method.toUpperCase(),
      headers: headers.normalize().toJSON(),
      body: data,
      duplex: "half",
      credentials: isCredentialsSupported ? withCredentials : undefined
    });

    let response = await fetch(request);

    const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');

    if (supportsResponseStream && (onDownloadProgress || (isStreamResponse && unsubscribe))) {
      const options = {};

      ['status', 'statusText', 'headers'].forEach(prop => {
        options[prop] = response[prop];
      });

      const responseContentLength = utils$1.toFiniteNumber(response.headers.get('content-length'));

      const [onProgress, flush] = onDownloadProgress && progressEventDecorator(
        responseContentLength,
        progressEventReducer(asyncDecorator(onDownloadProgress), true)
      ) || [];

      response = new Response(
        trackStream(response.body, DEFAULT_CHUNK_SIZE, onProgress, () => {
          flush && flush();
          unsubscribe && unsubscribe();
        }),
        options
      );
    }

    responseType = responseType || 'text';

    let responseData = await resolvers[utils$1.findKey(resolvers, responseType) || 'text'](response, config);

    !isStreamResponse && unsubscribe && unsubscribe();

    return await new Promise((resolve, reject) => {
      settle(resolve, reject, {
        data: responseData,
        headers: AxiosHeaders$1.from(response.headers),
        status: response.status,
        statusText: response.statusText,
        config,
        request
      });
    })
  } catch (err) {
    unsubscribe && unsubscribe();

    if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) {
      throw Object.assign(
        new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request),
        {
          cause: err.cause || err
        }
      )
    }

    throw AxiosError.from(err, err && err.code, config, request);
  }
});

const knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter,
  fetch: fetchAdapter
};

utils$1.forEach(knownAdapters, (fn, value) => {
  if (fn) {
    try {
      Object.defineProperty(fn, 'name', {value});
    } catch (e) {
      // eslint-disable-next-line no-empty
    }
    Object.defineProperty(fn, 'adapterName', {value});
  }
});

const renderReason = (reason) => `- ${reason}`;

const isResolvedHandle = (adapter) => utils$1.isFunction(adapter) || adapter === null || adapter === false;

var adapters = {
  getAdapter: (adapters) => {
    adapters = utils$1.isArray(adapters) ? adapters : [adapters];

    const {length} = adapters;
    let nameOrAdapter;
    let adapter;

    const rejectedReasons = {};

    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters[i];
      let id;

      adapter = nameOrAdapter;

      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];

        if (adapter === undefined) {
          throw new AxiosError(`Unknown adapter '${id}'`);
        }
      }

      if (adapter) {
        break;
      }

      rejectedReasons[id || '#' + i] = adapter;
    }

    if (!adapter) {

      const reasons = Object.entries(rejectedReasons)
        .map(([id, state]) => `adapter ${id} ` +
          (state === false ? 'is not supported by the environment' : 'is not available in the build')
        );

      let s = length ?
        (reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0])) :
        'as no adapter specified';

      throw new AxiosError(
        `There is no suitable adapter to dispatch the request ` + s,
        'ERR_NOT_SUPPORT'
      );
    }

    return adapter;
  },
  adapters: knownAdapters
};

/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError(null, config);
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 *
 * @returns {Promise} The Promise to be fulfilled
 */
function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  config.headers = AxiosHeaders$1.from(config.headers);

  // Transform request data
  config.data = transformData.call(
    config,
    config.transformRequest
  );

  if (['post', 'put', 'patch'].indexOf(config.method) !== -1) {
    config.headers.setContentType('application/x-www-form-urlencoded', false);
  }

  const adapter = adapters.getAdapter(config.adapter || defaults$1.adapter);

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );

    response.headers = AxiosHeaders$1.from(response.headers);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = AxiosHeaders$1.from(reason.response.headers);
      }
    }

    return Promise.reject(reason);
  });
}

const VERSION = "1.7.9";

const validators$1 = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach((type, i) => {
  validators$1[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

const deprecatedWarnings = {};

/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */
validators$1.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return (value, opt, opts) => {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

validators$1.spelling = function spelling(correctSpelling) {
  return (value, opt) => {
    // eslint-disable-next-line no-console
    console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
    return true;
  }
};

/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys = Object.keys(options);
  let i = keys.length;
  while (i-- > 0) {
    const opt = keys[i];
    const validator = schema[opt];
    if (validator) {
      const value = options[opt];
      const result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

var validator = {
  assertOptions,
  validators: validators$1
};

const validators = validator.validators;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new InterceptorManager$1(),
      response: new InterceptorManager$1()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(configOrUrl, config) {
    try {
      return await this._request(configOrUrl, config);
    } catch (err) {
      if (err instanceof Error) {
        let dummy = {};

        Error.captureStackTrace ? Error.captureStackTrace(dummy) : (dummy = new Error());

        // slice off the Error: ... line
        const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
        try {
          if (!err.stack) {
            err.stack = stack;
            // match without the 2 top stack lines
          } else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) {
            err.stack += '\n' + stack;
          }
        } catch (e) {
          // ignore the case where "stack" is an un-writable property
        }
      }

      throw err;
    }
  }

  _request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    config = mergeConfig(this.defaults, config);

    const {transitional, paramsSerializer, headers} = config;

    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }

    if (paramsSerializer != null) {
      if (utils$1.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        };
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: validators.function,
          serialize: validators.function
        }, true);
      }
    }

    validator.assertOptions(config, {
      baseUrl: validators.spelling('baseURL'),
      withXsrfToken: validators.spelling('withXSRFToken')
    }, true);

    // Set config.method
    config.method = (config.method || this.defaults.method || 'get').toLowerCase();

    // Flatten headers
    let contextHeaders = headers && utils$1.merge(
      headers.common,
      headers[config.method]
    );

    headers && utils$1.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      (method) => {
        delete headers[method];
      }
    );

    config.headers = AxiosHeaders$1.concat(contextHeaders, headers);

    // filter out skipped interceptors
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    let promise;
    let i = 0;
    let len;

    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), undefined];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;

      promise = Promise.resolve(config);

      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }

      return promise;
    }

    len = requestInterceptorChain.length;

    let newConfig = config;

    i = 0;

    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }

    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    i = 0;
    len = responseInterceptorChain.length;

    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }

    return promise;
  }

  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}

// Provide aliases for supported request methods
utils$1.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});

utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url,
        data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

var Axios$1 = Axios;

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */
class CancelToken {
  constructor(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    let resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    const token = this;

    // eslint-disable-next-line func-names
    this.promise.then(cancel => {
      if (!token._listeners) return;

      let i = token._listeners.length;

      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = onfulfilled => {
      let _resolve;
      // eslint-disable-next-line func-names
      const promise = new Promise(resolve => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message, config, request) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new CanceledError(message, config, request);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }

  /**
   * Subscribe to the cancel signal
   */

  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }

  /**
   * Unsubscribe from the cancel signal
   */

  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  }

  toAbortSignal() {
    const controller = new AbortController();

    const abort = (err) => {
      controller.abort(err);
    };

    this.subscribe(abort);

    controller.signal.unsubscribe = () => this.unsubscribe(abort);

    return controller.signal;
  }

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token,
      cancel
    };
  }
}

var CancelToken$1 = CancelToken;

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 *
 * @returns {Function}
 */
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 *
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
function isAxiosError(payload) {
  return utils$1.isObject(payload) && (payload.isAxiosError === true);
}

const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
};

Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});

var HttpStatusCode$1 = HttpStatusCode;

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  const context = new Axios$1(defaultConfig);
  const instance = bind(Axios$1.prototype.request, context);

  // Copy axios.prototype to instance
  utils$1.extend(instance, Axios$1.prototype, context, {allOwnKeys: true});

  // Copy context to instance
  utils$1.extend(instance, context, null, {allOwnKeys: true});

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
const axios = createInstance(defaults$1);

// Expose Axios class to allow class inheritance
axios.Axios = Axios$1;

// Expose Cancel & CancelToken
axios.CanceledError = CanceledError;
axios.CancelToken = CancelToken$1;
axios.isCancel = isCancel;
axios.VERSION = VERSION;
axios.toFormData = toFormData;

// Expose AxiosError class
axios.AxiosError = AxiosError;

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};

axios.spread = spread;

// Expose isAxiosError
axios.isAxiosError = isAxiosError;

// Expose mergeConfig
axios.mergeConfig = mergeConfig;

axios.AxiosHeaders = AxiosHeaders$1;

axios.formToJSON = thing => formDataToJSON(utils$1.isHTMLForm(thing) ? new FormData(thing) : thing);

axios.getAdapter = adapters.getAdapter;

axios.HttpStatusCode = HttpStatusCode$1;

axios.default = axios;

module.exports = axios;
//# sourceMappingURL=axios.cjs.map


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__("./sagas/index.ts");
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=Sagas.js.map